const os = (t) => ({
  query: (e) => t.post("v3/user/auth", e)
}), cs = (t) => ({
  query: (e) => t.post("v3/user/auth/sign_in", e)
}), us = (t) => ({
  query: (e) => t.post("v3/user/auth/sign_in_with_token", e)
}), ds = (t) => ({
  query: (e) => t.post("v3/user/auth/sign_up_with_token", e)
}), ls = (t) => ({
  query: (e) => t.post("v3/user/auth/finish_signup", e)
}), fs = (t) => ({
  query: (e) => t.post(
    `v3/user/automatic_proposals/${e.automaticProposalId}/automatic_proposal_comments/${e.automaticProposalHouseId}`,
    { automatic_proposal_comment: e.automatic_proposal_comment }
  )
}), hs = (t) => ({
  query: (e) => t.put(
    `v3/user/automatic_proposals/${e.automaticProposalId}/automatic_proposal_comments/${e.automaticProposalHouseId}`,
    { automatic_proposal_comment: e.automatic_proposal_comment }
  )
}), Wt = (t) => t.relationships ? ys(t) : {
  id: t.id,
  type: t.type,
  ...t.meta ? { meta: t.meta } : {},
  ...t.attributes
}, Gt = (t) => {
  const e = {};
  return t && Object.keys(t).forEach((s) => {
    const n = t == null ? void 0 : t[s].data;
    Array.isArray(n) ? e[`${s}Ids`] = n.map(({ id: a }) => a) : e[`${s}Id`] = (n == null ? void 0 : n.id) || null;
  }), e;
}, Jt = (t) => {
  const e = t.relationships, r = t.attributes;
  return t != null && t.attributes ? { id: t.id, ...r, ...Gt(e) } : { ...t, ...Gt(e) };
}, ys = (t) => {
  var s;
  const e = {}, r = t == null ? void 0 : t.relationships;
  if (r)
    for (const [n, a] of Object.entries(r))
      Array.isArray(a.data) ? e[`${n}Ids`] = a.data.map((i) => i.id) : e[`${n}Id`] = (s = a.data) == null ? void 0 : s.id;
  return {
    id: t.id,
    type: t.type,
    ...t.attributes,
    ...t.meta ? { meta: t.meta } : {},
    ...e
  };
}, Kt = (t) => Array.isArray(t) ? t.map((e) => Wt(e)) : Wt(t), ms = (t) => {
  const e = {}, r = {};
  return t.map((s) => s.type).forEach((s) => {
    e[s] ? e[s] = 2 : e[s] = 1;
  }), Object.values(e).forEach((s, n) => {
    const a = Object.keys(e)[n], i = t.filter((d) => d.type === a), o = t.find((d) => d.type === a);
    s > 1 ? r[`${a}s`] = Kt(i) : o && (r[`${a}s`] = Kt(o));
  }), r;
}, te = (t) => {
  const { data: e, headers: r, included: s, meta: n } = t;
  if (e && typeof e != "string") {
    const a = Array.isArray(e) ? e.map((o) => Jt(o)) : Jt(e), i = s ? ms(s) : null;
    return {
      data: a,
      headers: r,
      ...n ? { meta: n } : {},
      ...i ? { included: i } : {}
    };
  }
  return t;
};
function kr(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: ps } = Object.prototype, { getPrototypeOf: Dt } = Object, { iterator: We, toStringTag: $r } = Symbol, Ge = ((t) => (e) => {
  const r = ps.call(e);
  return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), z = (t) => (t = t.toLowerCase(), (e) => Ge(e) === t), Je = (t) => (e) => typeof e === t, { isArray: be } = Array, xe = Je("undefined");
function gs(t) {
  return t !== null && !xe(t) && t.constructor !== null && !xe(t.constructor) && L(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Ir = z("ArrayBuffer");
function vs(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && Ir(t.buffer), e;
}
const _s = Je("string"), L = Je("function"), xr = Je("number"), Ke = (t) => t !== null && typeof t == "object", bs = (t) => t === !0 || t === !1, Ce = (t) => {
  if (Ge(t) !== "object")
    return !1;
  const e = Dt(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !($r in t) && !(We in t);
}, qs = z("Date"), ws = z("File"), ks = z("Blob"), $s = z("FileList"), Is = (t) => Ke(t) && L(t.pipe), xs = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || L(t.append) && ((e = Ge(t)) === "formdata" || // detect form-data instance
  e === "object" && L(t.toString) && t.toString() === "[object FormData]"));
}, Ts = z("URLSearchParams"), [Ss, As, Rs, Es] = ["ReadableStream", "Request", "Response", "Headers"].map(z), Cs = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ae(t, e, { allOwnKeys: r = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let s, n;
  if (typeof t != "object" && (t = [t]), be(t))
    for (s = 0, n = t.length; s < n; s++)
      e.call(null, t[s], s, t);
  else {
    const a = r ? Object.getOwnPropertyNames(t) : Object.keys(t), i = a.length;
    let o;
    for (s = 0; s < i; s++)
      o = a[s], e.call(null, t[o], o, t);
  }
}
function Tr(t, e) {
  e = e.toLowerCase();
  const r = Object.keys(t);
  let s = r.length, n;
  for (; s-- > 0; )
    if (n = r[s], e === n.toLowerCase())
      return n;
  return null;
}
const oe = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Sr = (t) => !xe(t) && t !== oe;
function ct() {
  const { caseless: t } = Sr(this) && this || {}, e = {}, r = (s, n) => {
    const a = t && Tr(e, n) || n;
    Ce(e[a]) && Ce(s) ? e[a] = ct(e[a], s) : Ce(s) ? e[a] = ct({}, s) : be(s) ? e[a] = s.slice() : e[a] = s;
  };
  for (let s = 0, n = arguments.length; s < n; s++)
    arguments[s] && Ae(arguments[s], r);
  return e;
}
const Os = (t, e, r, { allOwnKeys: s } = {}) => (Ae(e, (n, a) => {
  r && L(n) ? t[a] = kr(n, r) : t[a] = n;
}, { allOwnKeys: s }), t), Ps = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), Ns = (t, e, r, s) => {
  t.prototype = Object.create(e.prototype, s), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), r && Object.assign(t.prototype, r);
}, Ds = (t, e, r, s) => {
  let n, a, i;
  const o = {};
  if (e = e || {}, t == null)
    return e;
  do {
    for (n = Object.getOwnPropertyNames(t), a = n.length; a-- > 0; )
      i = n[a], (!s || s(i, t, e)) && !o[i] && (e[i] = t[i], o[i] = !0);
    t = r !== !1 && Dt(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}, js = (t, e, r) => {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  const s = t.indexOf(e, r);
  return s !== -1 && s === r;
}, Us = (t) => {
  if (!t)
    return null;
  if (be(t))
    return t;
  let e = t.length;
  if (!xr(e))
    return null;
  const r = new Array(e);
  for (; e-- > 0; )
    r[e] = t[e];
  return r;
}, Ls = ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && Dt(Uint8Array)), Bs = (t, e) => {
  const s = (t && t[We]).call(t);
  let n;
  for (; (n = s.next()) && !n.done; ) {
    const a = n.value;
    e.call(t, a[0], a[1]);
  }
}, Hs = (t, e) => {
  let r;
  const s = [];
  for (; (r = t.exec(e)) !== null; )
    s.push(r);
  return s;
}, Fs = z("HTMLFormElement"), Ms = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, s, n) {
    return s.toUpperCase() + n;
  }
), Xt = (({ hasOwnProperty: t }) => (e, r) => t.call(e, r))(Object.prototype), zs = z("RegExp"), Ar = (t, e) => {
  const r = Object.getOwnPropertyDescriptors(t), s = {};
  Ae(r, (n, a) => {
    let i;
    (i = e(n, a, t)) !== !1 && (s[a] = i || n);
  }), Object.defineProperties(t, s);
}, Vs = (t) => {
  Ar(t, (e, r) => {
    if (L(t) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const s = t[r];
    if (L(s)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Zs = (t, e) => {
  const r = {}, s = (n) => {
    n.forEach((a) => {
      r[a] = !0;
    });
  };
  return be(t) ? s(t) : s(String(t).split(e)), r;
}, Ws = () => {
}, Gs = (t, e) => t != null && Number.isFinite(t = +t) ? t : e;
function Js(t) {
  return !!(t && L(t.append) && t[$r] === "FormData" && t[We]);
}
const Ks = (t) => {
  const e = new Array(10), r = (s, n) => {
    if (Ke(s)) {
      if (e.indexOf(s) >= 0)
        return;
      if (!("toJSON" in s)) {
        e[n] = s;
        const a = be(s) ? [] : {};
        return Ae(s, (i, o) => {
          const d = r(i, n + 1);
          !xe(d) && (a[o] = d);
        }), e[n] = void 0, a;
      }
    }
    return s;
  };
  return r(t, 0);
}, Xs = z("AsyncFunction"), Qs = (t) => t && (Ke(t) || L(t)) && L(t.then) && L(t.catch), Rr = ((t, e) => t ? setImmediate : e ? ((r, s) => (oe.addEventListener("message", ({ source: n, data: a }) => {
  n === oe && a === r && s.length && s.shift()();
}, !1), (n) => {
  s.push(n), oe.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  L(oe.postMessage)
), Ys = typeof queueMicrotask < "u" ? queueMicrotask.bind(oe) : typeof process < "u" && process.nextTick || Rr, en = (t) => t != null && L(t[We]), l = {
  isArray: be,
  isArrayBuffer: Ir,
  isBuffer: gs,
  isFormData: xs,
  isArrayBufferView: vs,
  isString: _s,
  isNumber: xr,
  isBoolean: bs,
  isObject: Ke,
  isPlainObject: Ce,
  isReadableStream: Ss,
  isRequest: As,
  isResponse: Rs,
  isHeaders: Es,
  isUndefined: xe,
  isDate: qs,
  isFile: ws,
  isBlob: ks,
  isRegExp: zs,
  isFunction: L,
  isStream: Is,
  isURLSearchParams: Ts,
  isTypedArray: Ls,
  isFileList: $s,
  forEach: Ae,
  merge: ct,
  extend: Os,
  trim: Cs,
  stripBOM: Ps,
  inherits: Ns,
  toFlatObject: Ds,
  kindOf: Ge,
  kindOfTest: z,
  endsWith: js,
  toArray: Us,
  forEachEntry: Bs,
  matchAll: Hs,
  isHTMLForm: Fs,
  hasOwnProperty: Xt,
  hasOwnProp: Xt,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ar,
  freezeMethods: Vs,
  toObjectSet: Zs,
  toCamelCase: Ms,
  noop: Ws,
  toFiniteNumber: Gs,
  findKey: Tr,
  global: oe,
  isContextDefined: Sr,
  isSpecCompliantForm: Js,
  toJSONObject: Ks,
  isAsyncFn: Xs,
  isThenable: Qs,
  setImmediate: Rr,
  asap: Ys,
  isIterable: en
};
function I(t, e, r, s, n) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), s && (this.request = s), n && (this.response = n, this.status = n.status ? n.status : null);
}
l.inherits(I, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: l.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Er = I.prototype, Cr = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  Cr[t] = { value: t };
});
Object.defineProperties(I, Cr);
Object.defineProperty(Er, "isAxiosError", { value: !0 });
I.from = (t, e, r, s, n, a) => {
  const i = Object.create(Er);
  return l.toFlatObject(t, i, function(d) {
    return d !== Error.prototype;
  }, (o) => o !== "isAxiosError"), I.call(i, t.message, e, r, s, n), i.cause = t, i.name = t.name, a && Object.assign(i, a), i;
};
const tn = null;
function ut(t) {
  return l.isPlainObject(t) || l.isArray(t);
}
function Or(t) {
  return l.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Qt(t, e, r) {
  return t ? t.concat(e).map(function(n, a) {
    return n = Or(n), !r && a ? "[" + n + "]" : n;
  }).join(r ? "." : "") : e;
}
function rn(t) {
  return l.isArray(t) && !t.some(ut);
}
const sn = l.toFlatObject(l, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Xe(t, e, r) {
  if (!l.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), r = l.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(v, _) {
    return !l.isUndefined(_[v]);
  });
  const s = r.metaTokens, n = r.visitor || c, a = r.dots, i = r.indexes, d = (r.Blob || typeof Blob < "u" && Blob) && l.isSpecCompliantForm(e);
  if (!l.isFunction(n))
    throw new TypeError("visitor must be a function");
  function u(y) {
    if (y === null)
      return "";
    if (l.isDate(y))
      return y.toISOString();
    if (l.isBoolean(y))
      return y.toString();
    if (!d && l.isBlob(y))
      throw new I("Blob is not supported. Use a Buffer instead.");
    return l.isArrayBuffer(y) || l.isTypedArray(y) ? d && typeof Blob == "function" ? new Blob([y]) : Buffer.from(y) : y;
  }
  function c(y, v, _) {
    let A = y;
    if (y && !_ && typeof y == "object") {
      if (l.endsWith(v, "{}"))
        v = s ? v : v.slice(0, -2), y = JSON.stringify(y);
      else if (l.isArray(y) && rn(y) || (l.isFileList(y) || l.endsWith(v, "[]")) && (A = l.toArray(y)))
        return v = Or(v), A.forEach(function(R, B) {
          !(l.isUndefined(R) || R === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Qt([v], B, a) : i === null ? v : v + "[]",
            u(R)
          );
        }), !1;
    }
    return ut(y) ? !0 : (e.append(Qt(_, v, a), u(y)), !1);
  }
  const f = [], h = Object.assign(sn, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: ut
  });
  function p(y, v) {
    if (!l.isUndefined(y)) {
      if (f.indexOf(y) !== -1)
        throw Error("Circular reference detected in " + v.join("."));
      f.push(y), l.forEach(y, function(A, C) {
        (!(l.isUndefined(A) || A === null) && n.call(
          e,
          A,
          l.isString(C) ? C.trim() : C,
          v,
          h
        )) === !0 && p(A, v ? v.concat(C) : [C]);
      }), f.pop();
    }
  }
  if (!l.isObject(t))
    throw new TypeError("data must be an object");
  return p(t), e;
}
function Yt(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(s) {
    return e[s];
  });
}
function jt(t, e) {
  this._pairs = [], t && Xe(t, this, e);
}
const Pr = jt.prototype;
Pr.append = function(e, r) {
  this._pairs.push([e, r]);
};
Pr.toString = function(e) {
  const r = e ? function(s) {
    return e.call(this, s, Yt);
  } : Yt;
  return this._pairs.map(function(n) {
    return r(n[0]) + "=" + r(n[1]);
  }, "").join("&");
};
function nn(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Nr(t, e, r) {
  if (!e)
    return t;
  const s = r && r.encode || nn;
  l.isFunction(r) && (r = {
    serialize: r
  });
  const n = r && r.serialize;
  let a;
  if (n ? a = n(e, r) : a = l.isURLSearchParams(e) ? e.toString() : new jt(e, r).toString(s), a) {
    const i = t.indexOf("#");
    i !== -1 && (t = t.slice(0, i)), t += (t.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return t;
}
class an {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, r, s) {
    return this.handlers.push({
      fulfilled: e,
      rejected: r,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    l.forEach(this.handlers, function(s) {
      s !== null && e(s);
    });
  }
}
const er = an, Dr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, on = typeof URLSearchParams < "u" ? URLSearchParams : jt, cn = typeof FormData < "u" ? FormData : null, un = typeof Blob < "u" ? Blob : null, dn = {
  isBrowser: !0,
  classes: {
    URLSearchParams: on,
    FormData: cn,
    Blob: un
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ut = typeof window < "u" && typeof document < "u", dt = typeof navigator == "object" && navigator || void 0, ln = Ut && (!dt || ["ReactNative", "NativeScript", "NS"].indexOf(dt.product) < 0), fn = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), hn = Ut && window.location.href || "http://localhost", yn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ut,
  hasStandardBrowserEnv: ln,
  hasStandardBrowserWebWorkerEnv: fn,
  navigator: dt,
  origin: hn
}, Symbol.toStringTag, { value: "Module" })), j = {
  ...yn,
  ...dn
};
function mn(t, e) {
  return Xe(t, new j.classes.URLSearchParams(), Object.assign({
    visitor: function(r, s, n, a) {
      return j.isNode && l.isBuffer(r) ? (this.append(s, r.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function pn(t) {
  return l.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function gn(t) {
  const e = {}, r = Object.keys(t);
  let s;
  const n = r.length;
  let a;
  for (s = 0; s < n; s++)
    a = r[s], e[a] = t[a];
  return e;
}
function jr(t) {
  function e(r, s, n, a) {
    let i = r[a++];
    if (i === "__proto__")
      return !0;
    const o = Number.isFinite(+i), d = a >= r.length;
    return i = !i && l.isArray(n) ? n.length : i, d ? (l.hasOwnProp(n, i) ? n[i] = [n[i], s] : n[i] = s, !o) : ((!n[i] || !l.isObject(n[i])) && (n[i] = []), e(r, s, n[i], a) && l.isArray(n[i]) && (n[i] = gn(n[i])), !o);
  }
  if (l.isFormData(t) && l.isFunction(t.entries)) {
    const r = {};
    return l.forEachEntry(t, (s, n) => {
      e(pn(s), n, r, 0);
    }), r;
  }
  return null;
}
function vn(t, e, r) {
  if (l.isString(t))
    try {
      return (e || JSON.parse)(t), l.trim(t);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (r || JSON.stringify)(t);
}
const Lt = {
  transitional: Dr,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, r) {
    const s = r.getContentType() || "", n = s.indexOf("application/json") > -1, a = l.isObject(e);
    if (a && l.isHTMLForm(e) && (e = new FormData(e)), l.isFormData(e))
      return n ? JSON.stringify(jr(e)) : e;
    if (l.isArrayBuffer(e) || l.isBuffer(e) || l.isStream(e) || l.isFile(e) || l.isBlob(e) || l.isReadableStream(e))
      return e;
    if (l.isArrayBufferView(e))
      return e.buffer;
    if (l.isURLSearchParams(e))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let o;
    if (a) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return mn(e, this.formSerializer).toString();
      if ((o = l.isFileList(e)) || s.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return Xe(
          o ? { "files[]": e } : e,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return a || n ? (r.setContentType("application/json", !1), vn(e)) : e;
  }],
  transformResponse: [function(e) {
    const r = this.transitional || Lt.transitional, s = r && r.forcedJSONParsing, n = this.responseType === "json";
    if (l.isResponse(e) || l.isReadableStream(e))
      return e;
    if (e && l.isString(e) && (s && !this.responseType || n)) {
      const i = !(r && r.silentJSONParsing) && n;
      try {
        return JSON.parse(e);
      } catch (o) {
        if (i)
          throw o.name === "SyntaxError" ? I.from(o, I.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: j.classes.FormData,
    Blob: j.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
l.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  Lt.headers[t] = {};
});
const Bt = Lt, _n = l.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), bn = (t) => {
  const e = {};
  let r, s, n;
  return t && t.split(`
`).forEach(function(i) {
    n = i.indexOf(":"), r = i.substring(0, n).trim().toLowerCase(), s = i.substring(n + 1).trim(), !(!r || e[r] && _n[r]) && (r === "set-cookie" ? e[r] ? e[r].push(s) : e[r] = [s] : e[r] = e[r] ? e[r] + ", " + s : s);
  }), e;
}, tr = Symbol("internals");
function ke(t) {
  return t && String(t).trim().toLowerCase();
}
function Oe(t) {
  return t === !1 || t == null ? t : l.isArray(t) ? t.map(Oe) : String(t);
}
function qn(t) {
  const e = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = r.exec(t); )
    e[s[1]] = s[2];
  return e;
}
const wn = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function tt(t, e, r, s, n) {
  if (l.isFunction(s))
    return s.call(this, e, r);
  if (n && (e = r), !!l.isString(e)) {
    if (l.isString(s))
      return e.indexOf(s) !== -1;
    if (l.isRegExp(s))
      return s.test(e);
  }
}
function kn(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, r, s) => r.toUpperCase() + s);
}
function $n(t, e) {
  const r = l.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(t, s + r, {
      value: function(n, a, i) {
        return this[s].call(this, e, n, a, i);
      },
      configurable: !0
    });
  });
}
class Qe {
  constructor(e) {
    e && this.set(e);
  }
  set(e, r, s) {
    const n = this;
    function a(o, d, u) {
      const c = ke(d);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const f = l.findKey(n, c);
      (!f || n[f] === void 0 || u === !0 || u === void 0 && n[f] !== !1) && (n[f || d] = Oe(o));
    }
    const i = (o, d) => l.forEach(o, (u, c) => a(u, c, d));
    if (l.isPlainObject(e) || e instanceof this.constructor)
      i(e, r);
    else if (l.isString(e) && (e = e.trim()) && !wn(e))
      i(bn(e), r);
    else if (l.isObject(e) && l.isIterable(e)) {
      let o = {}, d, u;
      for (const c of e) {
        if (!l.isArray(c))
          throw TypeError("Object iterator must return a key-value pair");
        o[u = c[0]] = (d = o[u]) ? l.isArray(d) ? [...d, c[1]] : [d, c[1]] : c[1];
      }
      i(o, r);
    } else
      e != null && a(r, e, s);
    return this;
  }
  get(e, r) {
    if (e = ke(e), e) {
      const s = l.findKey(this, e);
      if (s) {
        const n = this[s];
        if (!r)
          return n;
        if (r === !0)
          return qn(n);
        if (l.isFunction(r))
          return r.call(this, n, s);
        if (l.isRegExp(r))
          return r.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, r) {
    if (e = ke(e), e) {
      const s = l.findKey(this, e);
      return !!(s && this[s] !== void 0 && (!r || tt(this, this[s], s, r)));
    }
    return !1;
  }
  delete(e, r) {
    const s = this;
    let n = !1;
    function a(i) {
      if (i = ke(i), i) {
        const o = l.findKey(s, i);
        o && (!r || tt(s, s[o], o, r)) && (delete s[o], n = !0);
      }
    }
    return l.isArray(e) ? e.forEach(a) : a(e), n;
  }
  clear(e) {
    const r = Object.keys(this);
    let s = r.length, n = !1;
    for (; s--; ) {
      const a = r[s];
      (!e || tt(this, this[a], a, e, !0)) && (delete this[a], n = !0);
    }
    return n;
  }
  normalize(e) {
    const r = this, s = {};
    return l.forEach(this, (n, a) => {
      const i = l.findKey(s, a);
      if (i) {
        r[i] = Oe(n), delete r[a];
        return;
      }
      const o = e ? kn(a) : String(a).trim();
      o !== a && delete r[a], r[o] = Oe(n), s[o] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const r = /* @__PURE__ */ Object.create(null);
    return l.forEach(this, (s, n) => {
      s != null && s !== !1 && (r[n] = e && l.isArray(s) ? s.join(", ") : s);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, r]) => e + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...r) {
    const s = new this(e);
    return r.forEach((n) => s.set(n)), s;
  }
  static accessor(e) {
    const s = (this[tr] = this[tr] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function a(i) {
      const o = ke(i);
      s[o] || ($n(n, i), s[o] = !0);
    }
    return l.isArray(e) ? e.forEach(a) : a(e), this;
  }
}
Qe.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
l.reduceDescriptors(Qe.prototype, ({ value: t }, e) => {
  let r = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(s) {
      this[r] = s;
    }
  };
});
l.freezeMethods(Qe);
const M = Qe;
function rt(t, e) {
  const r = this || Bt, s = e || r, n = M.from(s.headers);
  let a = s.data;
  return l.forEach(t, function(o) {
    a = o.call(r, a, n.normalize(), e ? e.status : void 0);
  }), n.normalize(), a;
}
function Ur(t) {
  return !!(t && t.__CANCEL__);
}
function qe(t, e, r) {
  I.call(this, t ?? "canceled", I.ERR_CANCELED, e, r), this.name = "CanceledError";
}
l.inherits(qe, I, {
  __CANCEL__: !0
});
function Lr(t, e, r) {
  const s = r.config.validateStatus;
  !r.status || !s || s(r.status) ? t(r) : e(new I(
    "Request failed with status code " + r.status,
    [I.ERR_BAD_REQUEST, I.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function In(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function xn(t, e) {
  t = t || 10;
  const r = new Array(t), s = new Array(t);
  let n = 0, a = 0, i;
  return e = e !== void 0 ? e : 1e3, function(d) {
    const u = Date.now(), c = s[a];
    i || (i = u), r[n] = d, s[n] = u;
    let f = a, h = 0;
    for (; f !== n; )
      h += r[f++], f = f % t;
    if (n = (n + 1) % t, n === a && (a = (a + 1) % t), u - i < e)
      return;
    const p = c && u - c;
    return p ? Math.round(h * 1e3 / p) : void 0;
  };
}
function Tn(t, e) {
  let r = 0, s = 1e3 / e, n, a;
  const i = (u, c = Date.now()) => {
    r = c, n = null, a && (clearTimeout(a), a = null), t.apply(null, u);
  };
  return [(...u) => {
    const c = Date.now(), f = c - r;
    f >= s ? i(u, c) : (n = u, a || (a = setTimeout(() => {
      a = null, i(n);
    }, s - f)));
  }, () => n && i(n)];
}
const Ue = (t, e, r = 3) => {
  let s = 0;
  const n = xn(50, 250);
  return Tn((a) => {
    const i = a.loaded, o = a.lengthComputable ? a.total : void 0, d = i - s, u = n(d), c = i <= o;
    s = i;
    const f = {
      loaded: i,
      total: o,
      progress: o ? i / o : void 0,
      bytes: d,
      rate: u || void 0,
      estimated: u && o && c ? (o - i) / u : void 0,
      event: a,
      lengthComputable: o != null,
      [e ? "download" : "upload"]: !0
    };
    t(f);
  }, r);
}, rr = (t, e) => {
  const r = t != null;
  return [(s) => e[0]({
    lengthComputable: r,
    total: t,
    loaded: s
  }), e[1]];
}, sr = (t) => (...e) => l.asap(() => t(...e)), Sn = j.hasStandardBrowserEnv ? ((t, e) => (r) => (r = new URL(r, j.origin), t.protocol === r.protocol && t.host === r.host && (e || t.port === r.port)))(
  new URL(j.origin),
  j.navigator && /(msie|trident)/i.test(j.navigator.userAgent)
) : () => !0, An = j.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, r, s, n, a) {
      const i = [t + "=" + encodeURIComponent(e)];
      l.isNumber(r) && i.push("expires=" + new Date(r).toGMTString()), l.isString(s) && i.push("path=" + s), l.isString(n) && i.push("domain=" + n), a === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Rn(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function En(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function Br(t, e, r) {
  let s = !Rn(e);
  return t && (s || r == !1) ? En(t, e) : e;
}
const nr = (t) => t instanceof M ? { ...t } : t;
function ce(t, e) {
  e = e || {};
  const r = {};
  function s(u, c, f, h) {
    return l.isPlainObject(u) && l.isPlainObject(c) ? l.merge.call({ caseless: h }, u, c) : l.isPlainObject(c) ? l.merge({}, c) : l.isArray(c) ? c.slice() : c;
  }
  function n(u, c, f, h) {
    if (l.isUndefined(c)) {
      if (!l.isUndefined(u))
        return s(void 0, u, f, h);
    } else
      return s(u, c, f, h);
  }
  function a(u, c) {
    if (!l.isUndefined(c))
      return s(void 0, c);
  }
  function i(u, c) {
    if (l.isUndefined(c)) {
      if (!l.isUndefined(u))
        return s(void 0, u);
    } else
      return s(void 0, c);
  }
  function o(u, c, f) {
    if (f in e)
      return s(u, c);
    if (f in t)
      return s(void 0, u);
  }
  const d = {
    url: a,
    method: a,
    data: a,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: o,
    headers: (u, c, f) => n(nr(u), nr(c), f, !0)
  };
  return l.forEach(Object.keys(Object.assign({}, t, e)), function(c) {
    const f = d[c] || n, h = f(t[c], e[c], c);
    l.isUndefined(h) && f !== o || (r[c] = h);
  }), r;
}
const Hr = (t) => {
  const e = ce({}, t);
  let { data: r, withXSRFToken: s, xsrfHeaderName: n, xsrfCookieName: a, headers: i, auth: o } = e;
  e.headers = i = M.from(i), e.url = Nr(Br(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), o && i.set(
    "Authorization",
    "Basic " + btoa((o.username || "") + ":" + (o.password ? unescape(encodeURIComponent(o.password)) : ""))
  );
  let d;
  if (l.isFormData(r)) {
    if (j.hasStandardBrowserEnv || j.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((d = i.getContentType()) !== !1) {
      const [u, ...c] = d ? d.split(";").map((f) => f.trim()).filter(Boolean) : [];
      i.setContentType([u || "multipart/form-data", ...c].join("; "));
    }
  }
  if (j.hasStandardBrowserEnv && (s && l.isFunction(s) && (s = s(e)), s || s !== !1 && Sn(e.url))) {
    const u = n && a && An.read(a);
    u && i.set(n, u);
  }
  return e;
}, Cn = typeof XMLHttpRequest < "u", On = Cn && function(t) {
  return new Promise(function(r, s) {
    const n = Hr(t);
    let a = n.data;
    const i = M.from(n.headers).normalize();
    let { responseType: o, onUploadProgress: d, onDownloadProgress: u } = n, c, f, h, p, y;
    function v() {
      p && p(), y && y(), n.cancelToken && n.cancelToken.unsubscribe(c), n.signal && n.signal.removeEventListener("abort", c);
    }
    let _ = new XMLHttpRequest();
    _.open(n.method.toUpperCase(), n.url, !0), _.timeout = n.timeout;
    function A() {
      if (!_)
        return;
      const R = M.from(
        "getAllResponseHeaders" in _ && _.getAllResponseHeaders()
      ), P = {
        data: !o || o === "text" || o === "json" ? _.responseText : _.response,
        status: _.status,
        statusText: _.statusText,
        headers: R,
        config: t,
        request: _
      };
      Lr(function(ie) {
        r(ie), v();
      }, function(ie) {
        s(ie), v();
      }, P), _ = null;
    }
    "onloadend" in _ ? _.onloadend = A : _.onreadystatechange = function() {
      !_ || _.readyState !== 4 || _.status === 0 && !(_.responseURL && _.responseURL.indexOf("file:") === 0) || setTimeout(A);
    }, _.onabort = function() {
      _ && (s(new I("Request aborted", I.ECONNABORTED, t, _)), _ = null);
    }, _.onerror = function() {
      s(new I("Network Error", I.ERR_NETWORK, t, _)), _ = null;
    }, _.ontimeout = function() {
      let B = n.timeout ? "timeout of " + n.timeout + "ms exceeded" : "timeout exceeded";
      const P = n.transitional || Dr;
      n.timeoutErrorMessage && (B = n.timeoutErrorMessage), s(new I(
        B,
        P.clarifyTimeoutError ? I.ETIMEDOUT : I.ECONNABORTED,
        t,
        _
      )), _ = null;
    }, a === void 0 && i.setContentType(null), "setRequestHeader" in _ && l.forEach(i.toJSON(), function(B, P) {
      _.setRequestHeader(P, B);
    }), l.isUndefined(n.withCredentials) || (_.withCredentials = !!n.withCredentials), o && o !== "json" && (_.responseType = n.responseType), u && ([h, y] = Ue(u, !0), _.addEventListener("progress", h)), d && _.upload && ([f, p] = Ue(d), _.upload.addEventListener("progress", f), _.upload.addEventListener("loadend", p)), (n.cancelToken || n.signal) && (c = (R) => {
      _ && (s(!R || R.type ? new qe(null, t, _) : R), _.abort(), _ = null);
    }, n.cancelToken && n.cancelToken.subscribe(c), n.signal && (n.signal.aborted ? c() : n.signal.addEventListener("abort", c)));
    const C = In(n.url);
    if (C && j.protocols.indexOf(C) === -1) {
      s(new I("Unsupported protocol " + C + ":", I.ERR_BAD_REQUEST, t));
      return;
    }
    _.send(a || null);
  });
}, Pn = (t, e) => {
  const { length: r } = t = t ? t.filter(Boolean) : [];
  if (e || r) {
    let s = new AbortController(), n;
    const a = function(u) {
      if (!n) {
        n = !0, o();
        const c = u instanceof Error ? u : this.reason;
        s.abort(c instanceof I ? c : new qe(c instanceof Error ? c.message : c));
      }
    };
    let i = e && setTimeout(() => {
      i = null, a(new I(`timeout ${e} of ms exceeded`, I.ETIMEDOUT));
    }, e);
    const o = () => {
      t && (i && clearTimeout(i), i = null, t.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(a) : u.removeEventListener("abort", a);
      }), t = null);
    };
    t.forEach((u) => u.addEventListener("abort", a));
    const { signal: d } = s;
    return d.unsubscribe = () => l.asap(o), d;
  }
}, Nn = Pn, Dn = function* (t, e) {
  let r = t.byteLength;
  if (!e || r < e) {
    yield t;
    return;
  }
  let s = 0, n;
  for (; s < r; )
    n = s + e, yield t.slice(s, n), s = n;
}, jn = async function* (t, e) {
  for await (const r of Un(t))
    yield* Dn(r, e);
}, Un = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: r, value: s } = await e.read();
      if (r)
        break;
      yield s;
    }
  } finally {
    await e.cancel();
  }
}, ar = (t, e, r, s) => {
  const n = jn(t, e);
  let a = 0, i, o = (d) => {
    i || (i = !0, s && s(d));
  };
  return new ReadableStream({
    async pull(d) {
      try {
        const { done: u, value: c } = await n.next();
        if (u) {
          o(), d.close();
          return;
        }
        let f = c.byteLength;
        if (r) {
          let h = a += f;
          r(h);
        }
        d.enqueue(new Uint8Array(c));
      } catch (u) {
        throw o(u), u;
      }
    },
    cancel(d) {
      return o(d), n.return();
    }
  }, {
    highWaterMark: 2
  });
}, Ye = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Fr = Ye && typeof ReadableStream == "function", Ln = Ye && (typeof TextEncoder == "function" ? ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), Mr = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, Bn = Fr && Mr(() => {
  let t = !1;
  const e = new Request(j.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
}), ir = 64 * 1024, lt = Fr && Mr(() => l.isReadableStream(new Response("").body)), Le = {
  stream: lt && ((t) => t.body)
};
Ye && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !Le[e] && (Le[e] = l.isFunction(t[e]) ? (r) => r[e]() : (r, s) => {
      throw new I(`Response type '${e}' is not supported`, I.ERR_NOT_SUPPORT, s);
    });
  });
})(new Response());
const Hn = async (t) => {
  if (t == null)
    return 0;
  if (l.isBlob(t))
    return t.size;
  if (l.isSpecCompliantForm(t))
    return (await new Request(j.origin, {
      method: "POST",
      body: t
    }).arrayBuffer()).byteLength;
  if (l.isArrayBufferView(t) || l.isArrayBuffer(t))
    return t.byteLength;
  if (l.isURLSearchParams(t) && (t = t + ""), l.isString(t))
    return (await Ln(t)).byteLength;
}, Fn = async (t, e) => {
  const r = l.toFiniteNumber(t.getContentLength());
  return r ?? Hn(e);
}, Mn = Ye && (async (t) => {
  let {
    url: e,
    method: r,
    data: s,
    signal: n,
    cancelToken: a,
    timeout: i,
    onDownloadProgress: o,
    onUploadProgress: d,
    responseType: u,
    headers: c,
    withCredentials: f = "same-origin",
    fetchOptions: h
  } = Hr(t);
  u = u ? (u + "").toLowerCase() : "text";
  let p = Nn([n, a && a.toAbortSignal()], i), y;
  const v = p && p.unsubscribe && (() => {
    p.unsubscribe();
  });
  let _;
  try {
    if (d && Bn && r !== "get" && r !== "head" && (_ = await Fn(c, s)) !== 0) {
      let P = new Request(e, {
        method: "POST",
        body: s,
        duplex: "half"
      }), Q;
      if (l.isFormData(s) && (Q = P.headers.get("content-type")) && c.setContentType(Q), P.body) {
        const [ie, Re] = rr(
          _,
          Ue(sr(d))
        );
        s = ar(P.body, ir, ie, Re);
      }
    }
    l.isString(f) || (f = f ? "include" : "omit");
    const A = "credentials" in Request.prototype;
    y = new Request(e, {
      ...h,
      signal: p,
      method: r.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: s,
      duplex: "half",
      credentials: A ? f : void 0
    });
    let C = await fetch(y, h);
    const R = lt && (u === "stream" || u === "response");
    if (lt && (o || R && v)) {
      const P = {};
      ["status", "statusText", "headers"].forEach((Zt) => {
        P[Zt] = C[Zt];
      });
      const Q = l.toFiniteNumber(C.headers.get("content-length")), [ie, Re] = o && rr(
        Q,
        Ue(sr(o), !0)
      ) || [];
      C = new Response(
        ar(C.body, ir, ie, () => {
          Re && Re(), v && v();
        }),
        P
      );
    }
    u = u || "text";
    let B = await Le[l.findKey(Le, u) || "text"](C, t);
    return !R && v && v(), await new Promise((P, Q) => {
      Lr(P, Q, {
        data: B,
        headers: M.from(C.headers),
        status: C.status,
        statusText: C.statusText,
        config: t,
        request: y
      });
    });
  } catch (A) {
    throw v && v(), A && A.name === "TypeError" && /Load failed|fetch/i.test(A.message) ? Object.assign(
      new I("Network Error", I.ERR_NETWORK, t, y),
      {
        cause: A.cause || A
      }
    ) : I.from(A, A && A.code, t, y);
  }
}), ft = {
  http: tn,
  xhr: On,
  fetch: Mn
};
l.forEach(ft, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const or = (t) => `- ${t}`, zn = (t) => l.isFunction(t) || t === null || t === !1, zr = {
  getAdapter: (t) => {
    t = l.isArray(t) ? t : [t];
    const { length: e } = t;
    let r, s;
    const n = {};
    for (let a = 0; a < e; a++) {
      r = t[a];
      let i;
      if (s = r, !zn(r) && (s = ft[(i = String(r)).toLowerCase()], s === void 0))
        throw new I(`Unknown adapter '${i}'`);
      if (s)
        break;
      n[i || "#" + a] = s;
    }
    if (!s) {
      const a = Object.entries(n).map(
        ([o, d]) => `adapter ${o} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = e ? a.length > 1 ? `since :
` + a.map(or).join(`
`) : " " + or(a[0]) : "as no adapter specified";
      throw new I(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return s;
  },
  adapters: ft
};
function st(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new qe(null, t);
}
function cr(t) {
  return st(t), t.headers = M.from(t.headers), t.data = rt.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), zr.getAdapter(t.adapter || Bt.adapter)(t).then(function(s) {
    return st(t), s.data = rt.call(
      t,
      t.transformResponse,
      s
    ), s.headers = M.from(s.headers), s;
  }, function(s) {
    return Ur(s) || (st(t), s && s.response && (s.response.data = rt.call(
      t,
      t.transformResponse,
      s.response
    ), s.response.headers = M.from(s.response.headers))), Promise.reject(s);
  });
}
const Vr = "1.10.0", et = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  et[t] = function(s) {
    return typeof s === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const ur = {};
et.transitional = function(e, r, s) {
  function n(a, i) {
    return "[Axios v" + Vr + "] Transitional option '" + a + "'" + i + (s ? ". " + s : "");
  }
  return (a, i, o) => {
    if (e === !1)
      throw new I(
        n(i, " has been removed" + (r ? " in " + r : "")),
        I.ERR_DEPRECATED
      );
    return r && !ur[i] && (ur[i] = !0, console.warn(
      n(
        i,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(a, i, o) : !0;
  };
};
et.spelling = function(e) {
  return (r, s) => (console.warn(`${s} is likely a misspelling of ${e}`), !0);
};
function Vn(t, e, r) {
  if (typeof t != "object")
    throw new I("options must be an object", I.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(t);
  let n = s.length;
  for (; n-- > 0; ) {
    const a = s[n], i = e[a];
    if (i) {
      const o = t[a], d = o === void 0 || i(o, a, t);
      if (d !== !0)
        throw new I("option " + a + " must be " + d, I.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new I("Unknown option " + a, I.ERR_BAD_OPTION);
  }
}
const Pe = {
  assertOptions: Vn,
  validators: et
}, V = Pe.validators;
let Be = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new er(),
      response: new er()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, r) {
    try {
      return await this._request(e, r);
    } catch (s) {
      if (s instanceof Error) {
        let n = {};
        Error.captureStackTrace ? Error.captureStackTrace(n) : n = new Error();
        const a = n.stack ? n.stack.replace(/^.+\n/, "") : "";
        try {
          s.stack ? a && !String(s.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + a) : s.stack = a;
        } catch {
        }
      }
      throw s;
    }
  }
  _request(e, r) {
    typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = ce(this.defaults, r);
    const { transitional: s, paramsSerializer: n, headers: a } = r;
    s !== void 0 && Pe.assertOptions(s, {
      silentJSONParsing: V.transitional(V.boolean),
      forcedJSONParsing: V.transitional(V.boolean),
      clarifyTimeoutError: V.transitional(V.boolean)
    }, !1), n != null && (l.isFunction(n) ? r.paramsSerializer = {
      serialize: n
    } : Pe.assertOptions(n, {
      encode: V.function,
      serialize: V.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Pe.assertOptions(r, {
      baseUrl: V.spelling("baseURL"),
      withXsrfToken: V.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let i = a && l.merge(
      a.common,
      a[r.method]
    );
    a && l.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (y) => {
        delete a[y];
      }
    ), r.headers = M.concat(i, a);
    const o = [];
    let d = !0;
    this.interceptors.request.forEach(function(v) {
      typeof v.runWhen == "function" && v.runWhen(r) === !1 || (d = d && v.synchronous, o.unshift(v.fulfilled, v.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(v) {
      u.push(v.fulfilled, v.rejected);
    });
    let c, f = 0, h;
    if (!d) {
      const y = [cr.bind(this), void 0];
      for (y.unshift.apply(y, o), y.push.apply(y, u), h = y.length, c = Promise.resolve(r); f < h; )
        c = c.then(y[f++], y[f++]);
      return c;
    }
    h = o.length;
    let p = r;
    for (f = 0; f < h; ) {
      const y = o[f++], v = o[f++];
      try {
        p = y(p);
      } catch (_) {
        v.call(this, _);
        break;
      }
    }
    try {
      c = cr.call(this, p);
    } catch (y) {
      return Promise.reject(y);
    }
    for (f = 0, h = u.length; f < h; )
      c = c.then(u[f++], u[f++]);
    return c;
  }
  getUri(e) {
    e = ce(this.defaults, e);
    const r = Br(e.baseURL, e.url, e.allowAbsoluteUrls);
    return Nr(r, e.params, e.paramsSerializer);
  }
};
l.forEach(["delete", "get", "head", "options"], function(e) {
  Be.prototype[e] = function(r, s) {
    return this.request(ce(s || {}, {
      method: e,
      url: r,
      data: (s || {}).data
    }));
  };
});
l.forEach(["post", "put", "patch"], function(e) {
  function r(s) {
    return function(a, i, o) {
      return this.request(ce(o || {}, {
        method: e,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: i
      }));
    };
  }
  Be.prototype[e] = r(), Be.prototype[e + "Form"] = r(!0);
});
const Ne = Be;
class Ht {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(a) {
      r = a;
    });
    const s = this;
    this.promise.then((n) => {
      if (!s._listeners)
        return;
      let a = s._listeners.length;
      for (; a-- > 0; )
        s._listeners[a](n);
      s._listeners = null;
    }), this.promise.then = (n) => {
      let a;
      const i = new Promise((o) => {
        s.subscribe(o), a = o;
      }).then(n);
      return i.cancel = function() {
        s.unsubscribe(a);
      }, i;
    }, e(function(a, i, o) {
      s.reason || (s.reason = new qe(a, i, o), r(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(e);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), r = (s) => {
      e.abort(s);
    };
    return this.subscribe(r), e.signal.unsubscribe = () => this.unsubscribe(r), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Ht(function(n) {
        e = n;
      }),
      cancel: e
    };
  }
}
const Zn = Ht;
function Wn(t) {
  return function(r) {
    return t.apply(null, r);
  };
}
function Gn(t) {
  return l.isObject(t) && t.isAxiosError === !0;
}
const ht = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ht).forEach(([t, e]) => {
  ht[e] = t;
});
const Jn = ht;
function Zr(t) {
  const e = new Ne(t), r = kr(Ne.prototype.request, e);
  return l.extend(r, Ne.prototype, e, { allOwnKeys: !0 }), l.extend(r, e, null, { allOwnKeys: !0 }), r.create = function(n) {
    return Zr(ce(t, n));
  }, r;
}
const N = Zr(Bt);
N.Axios = Ne;
N.CanceledError = qe;
N.CancelToken = Zn;
N.isCancel = Ur;
N.VERSION = Vr;
N.toFormData = Xe;
N.AxiosError = I;
N.Cancel = N.CanceledError;
N.all = function(e) {
  return Promise.all(e);
};
N.spread = Wn;
N.isAxiosError = Gn;
N.mergeConfig = ce;
N.AxiosHeaders = M;
N.formToJSON = (t) => jr(l.isHTMLForm(t) ? new FormData(t) : t);
N.getAdapter = zr.getAdapter;
N.HttpStatusCode = Jn;
N.default = N;
const Ft = N;
var Kn = Symbol("cache-parser");
function dr(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, s = new Array(e); r < e; r++)
    s[r] = t[r];
  return s;
}
function de(t) {
  return (typeof t == "string" || typeof t == "number") && (t = Number(t)) >= 0 && t < 1 / 0;
}
function Z(t) {
  return t === !0 || typeof t == "number" || typeof t == "string" && t !== "false";
}
var le = Number;
function Wr(t) {
  var e = Object.defineProperty({}, Kn, { enumerable: !1, value: 1 });
  if (!t || typeof t != "string")
    return e;
  var r = function(u) {
    for (var c, f = {}, h = function(v, _) {
      var A = typeof Symbol < "u" && v[Symbol.iterator] || v["@@iterator"];
      if (A)
        return (A = A.call(v)).next.bind(A);
      if (Array.isArray(v) || (A = function(R, B) {
        if (R) {
          if (typeof R == "string")
            return dr(R, B);
          var P = Object.prototype.toString.call(R).slice(8, -1);
          return P === "Object" && R.constructor && (P = R.constructor.name), P === "Map" || P === "Set" ? Array.from(R) : P === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(P) ? dr(R, B) : void 0;
        }
      }(v))) {
        A && (v = A);
        var C = 0;
        return function() {
          return C >= v.length ? { done: !0 } : { done: !1, value: v[C++] };
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }(u.toLowerCase().replace(/\s+/g, "").split(",")); !(c = h()).done; ) {
      var p, y = c.value.split("=", 2);
      f[y[0]] = (p = y[1]) == null || p;
    }
    return f;
  }(t), s = r["max-age"], n = r["max-stale"], a = r["min-fresh"], i = r["s-maxage"], o = r["stale-if-error"], d = r["stale-while-revalidate"];
  return Z(r.immutable) && (e.immutable = !0), de(s) && (e.maxAge = le(s)), de(n) && (e.maxStale = le(n)), de(a) && (e.minFresh = le(a)), Z(r["must-revalidate"]) && (e.mustRevalidate = !0), Z(r["must-understand"]) && (e.mustUnderstand = !0), Z(r["no-cache"]) && (e.noCache = !0), Z(r["no-store"]) && (e.noStore = !0), Z(r["no-transform"]) && (e.noTransform = !0), Z(r["only-if-cached"]) && (e.onlyIfCached = !0), Z(r.private) && (e.private = !0), Z(r["proxy-revalidate"]) && (e.proxyRevalidate = !0), Z(r.public) && (e.public = !0), de(i) && (e.sMaxAge = le(i)), de(o) && (e.staleIfError = le(o)), de(d) && (e.staleWhileRevalidate = le(d)), e;
}
var Xn = Symbol();
function Qn() {
  var t, e, r = new Promise(function(s, n) {
    t = s, e = n;
  });
  return r.resolve = t, r.reject = e, r[Xn] = 1, r;
}
function Yn(t, e) {
  return t > e ? 1 : -1;
}
function De(t, e) {
  var r = 5381;
  if (typeof t == "object" && t !== null && (t.toString === Object.prototype.toString || t.toString === Array.prototype.toString)) {
    e || (e = /* @__PURE__ */ new WeakSet());
    for (var s = Object.keys(t).sort(Yn), n = 0; n < s.length; n++) {
      var a = s[n], i = t[a];
      if (r = 33 * r ^ De(a, e), typeof i == "object" && i !== null && (t.toString === Object.prototype.toString || t.toString === Array.prototype.toString)) {
        if (e.has(i))
          continue;
        e.add(i);
      }
      r = 33 * r ^ De(i, e);
    }
    return 33 * r ^ De(t.constructor, e);
  }
  var o = typeof t;
  try {
    t instanceof Date ? o += t.getTime() : o += String(t);
  } catch {
    o += String(Object.assign({}, t));
  }
  for (var d = 0; d < o.length; d++)
    r = 33 * r ^ o.charCodeAt(d);
  return r;
}
/*!
 * Axios Cache Interceptor 1.8.0
 * (c) 2021-present Arthur Fiorette & Contributors
 * Released under the MIT License.
 */
const D = Object.freeze({
  /**
   * ```txt
   * If-Modified-Since: <day-name>, <day> <month> <year> <hour>:<minute>:<second> GMT
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/If-Modified-Since
   */
  IfModifiedSince: "if-modified-since",
  /**
   * ```txt
   * Last-Modified: <day-name>, <day> <month> <year> <hour>:<minute>:<second> GMT
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Last-Modified
   */
  LastModified: "last-modified",
  /**
   * ```txt
   * If-None-Match: "<etag_value>"
   * If-None-Match: "<etag_value>", "<etag_value>", …
   * If-None-Match: *
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/If-None-Match
   */
  IfNoneMatch: "if-none-match",
  /**
   * ```txt
   * Cache-Control: max-age=604800
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cache-Control
   */
  CacheControl: "cache-control",
  /**
   * ```txt
   * Pragma: no - cache;
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Pragma
   */
  Pragma: "pragma",
  /**
   * ```txt
   * ETag: W / '<etag_value>';
   * ETag: '<etag_value>';
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/ETag
   */
  ETag: "etag",
  /**
   * ```txt
   * Expires: <http-date>
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Expires
   */
  Expires: "expires",
  /**
   * ```txt
   * Age: <delta-seconds>
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Age
   */
  Age: "age",
  /**
   * Used internally as metadata to mark the cache item as revalidatable and enabling
   * stale cache state Contains a string of ASCII characters that can be used as ETag for
   * `If-Match` header Provided by user using `cache.etag` value.
   *
   * ```txt
   * X-Axios-Cache-Etag: "<etag_value>"
   * ```
   */
  XAxiosCacheEtag: "x-axios-cache-etag",
  /**
   * Used internally as metadata to mark the cache item as revalidatable and enabling
   * stale cache state may contain `'use-cache-timestamp'` if `cache.modifiedSince` is
   * `true`, otherwise will contain a date from `cache.modifiedSince`. If a date is
   * provided, it can be used for `If-Modified-Since` header, otherwise the cache
   * timestamp can be used for `If-Modified-Since` header.
   *
   * ```txt
   * X-Axios-Cache-Last-Modified: <day-name>, <day> <month> <year> <hour>:<minute>:<second> GMT
   * X-Axios-Cache-Last-Modified: use-cache-timestamp
   * ```
   */
  XAxiosCacheLastModified: "x-axios-cache-last-modified",
  /**
   * Used internally as metadata to mark the cache item able to be used if the server
   * returns an error. The stale-if-error response directive indicates that the cache can
   * reuse a stale response when any error occurs.
   *
   * ```txt
   * XAxiosCacheStaleIfError: <seconds>
   * ```
   */
  XAxiosCacheStaleIfError: "x-axios-cache-stale-if-error"
}), ea = (t, e) => {
  if (!t)
    return "not enough headers";
  const r = t[D.CacheControl];
  if (r) {
    const n = Wr(String(r));
    if (
      // Header told that this response should not be cached.
      n.noCache || n.noStore || // Server side handling private data
      e === "server" && n.private
    )
      return "dont cache";
    if (n.immutable)
      return {
        cache: 1e3 * 60 * 60 * 24 * 365
      };
    if (n.maxAge !== void 0) {
      const a = t[D.Age];
      return {
        cache: a ? (
          // If age is present, we must subtract it from maxAge
          (n.maxAge - Number(a)) * 1e3
        ) : n.maxAge * 1e3,
        // Already out of date, must be requested again
        stale: (
          // I couldn't find any documentation about who should be used, as they
          // are not meant to overlap each other. But, as we cannot request in the
          // background, as the stale-while-revalidate says, and we just increase
          // its staleTtl when its present, max-stale is being preferred over
          // stale-while-revalidate.
          n.maxStale !== void 0 ? n.maxStale * 1e3 : n.staleWhileRevalidate !== void 0 ? n.staleWhileRevalidate * 1e3 : void 0
        )
      };
    }
  }
  const s = t[D.Expires];
  if (s) {
    const n = Date.parse(String(s)) - Date.now();
    return n >= 0 ? {
      cache: n
    } : "dont cache";
  }
  return "not enough headers";
};
function Te() {
  return Te = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var s in r)
        Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
    }
    return t;
  }, Te.apply(this, arguments);
}
async function ta(t, e) {
  if (typeof e == "function")
    return e(t);
  const {
    statusCheck: r,
    responseMatch: s,
    containsHeaders: n
  } = e;
  if (r && !await r(t.status) || s && !await s(t))
    return !1;
  if (n)
    for (const [i, o] of Object.entries(n)) {
      var a;
      if (!await o(
        // Avoid bugs in case the header is not in lower case
        (a = t.headers[i.toLowerCase()]) != null ? a : t.headers[i]
      ))
        return !1;
    }
  return !0;
}
function lr(t, e) {
  return t instanceof RegExp ? (t.lastIndex = 0, t.test(e)) : e.includes(t);
}
function ra(t) {
  return t ? (e) => t(e) || e === 304 : (e) => e >= 200 && e < 300 || e === 304;
}
function yt(t = "get", e = []) {
  return t = t.toLowerCase(), e.some((r) => r === t);
}
function sa(t, e) {
  e.headers || (e.headers = {});
  const {
    etag: r,
    modifiedSince: s
  } = e.cache;
  if (r) {
    var n;
    const a = r === !0 ? (n = t.data) == null ? void 0 : n.headers[D.ETag] : r;
    a && (e.headers[D.IfNoneMatch] = a);
  }
  s && (e.headers[D.IfModifiedSince] = s === !0 ? (
    // If last-modified is not present, use the createdAt timestamp
    t.data.headers[D.LastModified] || new Date(t.createdAt).toUTCString()
  ) : s.toUTCString());
}
function na(t, e) {
  return t.status === 304 && e ? (t.cached = !0, t.data = e.data, t.status = e.status, t.statusText = e.statusText, t.headers = Te({}, e.headers, t.headers), e) : {
    data: t.data,
    status: t.status,
    statusText: t.statusText,
    headers: t.headers
  };
}
function aa(t) {
  const e = async (r) => {
    if (r.id = t.generateKey(r), r.cache === !1)
      return r;
    if (r.cache = Te({}, t.defaults.cache, r.cache), typeof r.cache.cachePredicate == "object" && r.cache.cachePredicate.ignoreUrls && r.url) {
      for (const v of r.cache.cachePredicate.ignoreUrls)
        if (lr(v, r.url))
          return r;
    }
    if (typeof r.cache.cachePredicate == "object" && r.cache.cachePredicate.allowUrls && r.url) {
      let v = !1;
      for (const _ of r.cache.cachePredicate.allowUrls)
        if (lr(_, r.url)) {
          v = !0;
          break;
        }
      if (!v)
        return r;
    }
    if (r.cache.cacheTakeover) {
      var s, n, a, i, o, d, u, c, f;
      (a = (s = r.headers)[n = D.CacheControl]) != null || (s[n] = "no-cache"), (d = (i = r.headers)[o = D.Pragma]) != null || (i[o] = "no-cache"), (f = (u = r.headers)[c = D.Expires]) != null || (u[c] = "0");
    }
    if (!yt(r.method, r.cache.methods))
      return r;
    let h = await t.storage.get(r.id, r);
    const p = r.cache.override;
    e:
      if (h.state === "empty" || h.state === "stale" || h.state === "must-revalidate" || p) {
        if (t.waiting.has(r.id) && !p && (h = await t.storage.get(r.id, r), h.state !== "empty" && h.state !== "must-revalidate"))
          break e;
        const v = Qn();
        return t.waiting.set(r.id, v), v.catch(() => {
        }), await t.storage.set(r.id, {
          state: "loading",
          previous: p ? (
            // Simply determine if the request is stale or not
            // based if it had previous data or not
            h.data ? "stale" : "empty"
          ) : (
            // Typescript doesn't know that cache.state here can only be 'empty' or 'stale'
            h.state
          ),
          data: h.data,
          // If the cache is empty and asked to override it, use the current timestamp
          createdAt: p && !h.createdAt ? Date.now() : h.createdAt
        }, r), (h.state === "stale" || h.state === "must-revalidate") && sa(h, r), r.validateStatus = ra(r.validateStatus), (h.state === "stale" || h.data && h.state !== "must-revalidate") && await (r.cache.hydrate == null ? void 0 : r.cache.hydrate(h)), r;
      }
    let y;
    if (h.state === "loading") {
      const v = t.waiting.get(r.id);
      if (!v)
        return h.data && await (r.cache.hydrate == null ? void 0 : r.cache.hydrate(h)), r;
      try {
        await v;
        const _ = await t.storage.get(r.id, r);
        if (!_.data)
          return e(r);
        y = _.data;
      } catch {
        return h.data && await (r.cache.hydrate == null ? void 0 : r.cache.hydrate(h)), e(r);
      }
    } else
      y = h.data;
    return r.transformResponse = void 0, r.adapter = function() {
      return Promise.resolve({
        config: r,
        data: y.data,
        headers: y.headers,
        status: y.status,
        statusText: y.statusText,
        cached: !0,
        stale: h.previous === "stale",
        id: r.id
      });
    }, r;
  };
  return {
    onFulfilled: e
  };
}
async function ia(t, e, r) {
  if (typeof r == "function")
    return r(e);
  for (const [s, n] of Object.entries(r)) {
    if (n === "delete") {
      await t.remove(s, e.config);
      continue;
    }
    const a = await t.get(s, e.config);
    if (a.state === "loading")
      continue;
    const i = await n(a, e);
    if (i === "delete") {
      await t.remove(s, e.config);
      continue;
    }
    i !== "ignore" && await t.set(s, i, e.config);
  }
}
function oa(t) {
  const e = async (n, a, i) => {
    i && await t.storage.remove(n, a);
    const o = t.waiting.get(n);
    o && (o.reject(), t.waiting.delete(n));
  };
  return {
    onFulfilled: async (n) => {
      var a;
      if (!(n != null && n.config))
        throw n;
      n.id = n.config.id, (a = n.cached) != null || (n.cached = !1);
      const i = n.config, o = i.cache;
      if (n.cached)
        return n;
      if (!o)
        return n.cached = !1, n;
      if (o.update && await ia(t.storage, n, o.update), !yt(i.method, o.methods))
        return n;
      const d = await t.storage.get(n.id, i);
      if (
        // If the request interceptor had a problem or it wasn't cached
        d.state !== "loading"
      )
        return n;
      if (
        // For 'loading' values (previous: stale), this check already ran in the past.
        !d.data && !await ta(n, o.cachePredicate)
      )
        return await e(n.id, i, !0), n;
      for (const y of Object.keys(n.headers))
        y.startsWith("x-axios-cache") && delete n.headers[y];
      o.etag && o.etag !== !0 && (n.headers[D.XAxiosCacheEtag] = o.etag), o.modifiedSince && (n.headers[D.XAxiosCacheLastModified] = o.modifiedSince === !0 ? "use-cache-timestamp" : o.modifiedSince.toUTCString());
      let u = o.ttl || -1, c;
      if (o.interpretHeader) {
        const y = t.headerInterpreter(n.headers, t.location);
        if (y === "dont cache")
          return await e(n.id, i, !0), n;
        y !== "not enough headers" && (typeof y == "number" ? u = y : (u = y.cache, c = y.stale));
      }
      const f = na(n, d.data);
      typeof u == "function" && (u = await u(n)), o.staleIfError && (n.headers[D.XAxiosCacheStaleIfError] = String(u));
      const h = {
        state: "cached",
        ttl: u,
        staleTtl: c,
        createdAt: Date.now(),
        data: f
      };
      await t.storage.set(n.id, h, i);
      const p = t.waiting.get(n.id);
      return p && (p.resolve(), t.waiting.delete(n.id)), n;
    },
    onRejected: async (n) => {
      if (!n.isAxiosError || !n.config)
        throw n;
      const a = n.config, i = a.id, o = a.cache, d = n.response;
      if (!o || !i)
        throw n;
      if (!yt(a.method, o.methods))
        throw await e(i, a, !0), n;
      const u = await t.storage.get(i, a);
      if (
        // This will only not be loading if the interceptor broke
        u.state !== "loading" || u.previous !== "stale"
      )
        throw await e(
          i,
          a,
          // Do not clear cache if this request is cached, but the request was cancelled before returning the cached response
          n.code !== "ERR_CANCELED" || n.code === "ERR_CANCELED" && u.state !== "cached"
        ), n;
      if (o.staleIfError) {
        const c = String(d == null ? void 0 : d.headers[D.CacheControl]), f = c && Wr(c).staleIfError, h = typeof o.staleIfError == "function" ? await o.staleIfError(d, u, n) : o.staleIfError === !0 && f ? f * 1e3 : o.staleIfError;
        if (h === !0 || // staleIfError is the number of seconds that stale is allowed to be used
        typeof h == "number" && u.createdAt + h > Date.now()) {
          await t.storage.set(i, {
            state: "stale",
            createdAt: Date.now(),
            data: u.data
          }, a);
          const p = t.waiting.get(i);
          return p && (p.resolve(), t.waiting.delete(i)), {
            cached: !0,
            stale: !0,
            config: a,
            id: i,
            data: u.data.data,
            headers: u.data.headers,
            status: u.data.status,
            statusText: u.data.statusText
          };
        }
      }
      throw await e(i, a, !0), n;
    }
  };
}
const ca = (t) => !!t && !!t["is-storage"];
function Gr(t) {
  const e = t.data.headers;
  return D.ETag in e || D.LastModified in e || D.XAxiosCacheEtag in e || D.XAxiosCacheLastModified in e;
}
function ua(t) {
  return String(t.data.headers[D.CacheControl]).includes("must-revalidate");
}
function Jr(t) {
  return Gr(t) ? !0 : t.state === "cached" && t.staleTtl !== void 0 && // Only allow stale values after the ttl is already in the past and the staleTtl is in the future.
  // In cases that just createdAt + ttl > Date.now(), isn't enough because the staleTtl could be <= 0.
  // This logic only returns true when Date.now() is between the (createdAt + ttl) and (createdAt + ttl + staleTtl).
  // Following the example below:
  // |--createdAt--:--ttl--:---staleTtl--->
  // [        past        ][now is in here]
  Math.abs(Date.now() - (t.createdAt + t.ttl)) <= t.staleTtl;
}
function mt(t) {
  return t.ttl !== void 0 && t.createdAt + t.ttl <= Date.now();
}
function da({
  set: t,
  find: e,
  remove: r,
  clear: s
}) {
  return {
    //@ts-expect-error - we don't want to expose this
    "is-storage": 1,
    set: t,
    remove: r,
    clear: s,
    get: async (n, a) => {
      let i = await e(n, a);
      if (!i)
        return {
          state: "empty"
        };
      if (i.state === "empty" || i.state === "loading" || i.state === "must-revalidate")
        return i;
      if (i.state === "cached") {
        if (!mt(i))
          return i;
        if (!Jr(i))
          return await r(n, a), {
            state: "empty"
          };
        if (i = {
          state: "stale",
          createdAt: i.createdAt,
          data: i.data,
          ttl: i.staleTtl !== void 0 ? i.staleTtl + i.ttl : void 0
        }, await t(n, i, a), ua(i))
          return Te({}, i, {
            state: "must-revalidate"
          });
      }
      return !mt(i) || Gr(i) ? i : (await r(n, a), {
        state: "empty"
      });
    }
  };
}
const fr = (
  // https://caniuse.com/mdn-api_structuredclone (10/18/2023 92.51%)
  typeof structuredClone == "function" ? structuredClone : (t) => JSON.parse(JSON.stringify(t))
);
function la(t = !1, e = !1, r = !1) {
  const s = da({
    set: (n, a) => {
      if (r) {
        let i = Object.keys(s.data);
        if (i.length >= r)
          for (s.cleanup(), i = Object.keys(s.data); i.length >= r; )
            delete s.data[i.shift()];
      }
      s.data[n] = t === "double" ? fr(a) : a;
    },
    remove: (n) => {
      delete s.data[n];
    },
    find: (n) => {
      const a = s.data[n];
      return t && a !== void 0 ? fr(a) : a;
    },
    clear: () => {
      s.data = /* @__PURE__ */ Object.create(null);
    }
  });
  return s.data = /* @__PURE__ */ Object.create(null), s.cleanup = () => {
    const n = Object.keys(s.data);
    let a = -1, i, o;
    for (; ++a < n.length; ) {
      if (o = n[a], i = s.data[o], i.state === "empty") {
        s.remove(o);
        continue;
      }
      i.state === "cached" && mt(i) && !Jr(i) && s.remove(o);
    }
  }, e && (s.cleaner = setInterval(s.cleanup, e)), s;
}
const hr = /^\/|\/$/g;
function fa(t) {
  return (e) => {
    if (e.id)
      return e.id;
    const r = t(e);
    return typeof r == "string" || typeof r == "number" ? `${r}` : `${De(r)}`;
  };
}
const ha = fa(({
  baseURL: t,
  url: e,
  method: r,
  params: s,
  data: n
}) => (t !== void 0 ? t = t.replace(hr, "") : t = "", e !== void 0 ? e = e.replace(hr, "") : e = "", r !== void 0 ? r = r.toLowerCase() : r = "get", {
  url: t + (t && e ? "/" : "") + e,
  params: s,
  method: r,
  data: n
}));
function Kr(t, e = {}) {
  var r, s, n, a, i, o, d, u;
  const c = t;
  if (c.defaults.cache)
    throw new Error("setupCache() should be called only once");
  if (c.location = typeof window > "u" ? "server" : "client", c.storage = e.storage || la(), !ca(c.storage))
    throw new Error("Use buildStorage() function");
  return c.waiting = e.waiting || /* @__PURE__ */ new Map(), c.generateKey = e.generateKey || ha, c.headerInterpreter = e.headerInterpreter || ea, c.requestInterceptor = e.requestInterceptor || aa(c), c.responseInterceptor = e.responseInterceptor || oa(c), c.debug = e.debug || function() {
  }, c.defaults.cache = {
    update: e.update || {},
    ttl: (r = e.ttl) != null ? r : 1e3 * 60 * 5,
    // Although RFC 7231 also marks POST as cacheable, most users don't know that
    // and may have problems about why their "create X" route not working.
    methods: e.methods || ["get", "head"],
    cachePredicate: e.cachePredicate || {
      // All cacheable status codes defined in RFC 7231
      statusCheck: (f) => [200, 203, 300, 301, 302, 404, 405, 410, 414, 501].includes(f)
    },
    etag: (s = e.etag) != null ? s : !0,
    // This option is going to be ignored by servers when ETag is enabled
    // Checks strict equality to false to avoid undefined-ish values
    modifiedSince: (n = e.modifiedSince) != null ? n : e.etag === !1,
    interpretHeader: (a = e.interpretHeader) != null ? a : !0,
    cacheTakeover: (i = e.cacheTakeover) != null ? i : !0,
    staleIfError: (o = e.staleIfError) != null ? o : !0,
    override: (d = e.override) != null ? d : !1,
    hydrate: (u = e.hydrate) != null ? u : void 0
  }, c.interceptors.request.use(c.requestInterceptor.onFulfilled, c.requestInterceptor.onRejected), c.interceptors.response.use(c.responseInterceptor.onFulfilled, c.responseInterceptor.onRejected), c;
}
const Xr = {
  "access-token": "",
  client: "",
  uid: ""
}, ya = ({
  apiUrl: t,
  getDeviceUniqueId: e,
  interceptors: r,
  locale: s,
  source: n,
  storageClient: a
}) => {
  const i = `${t}/${s}/api/`, o = Kr(
    Ft.create({
      baseURL: `${i}`,
      headers: { ...Xr }
    })
  ), d = async (f) => {
    if (f && f.headers && f.headers["access-token"]) {
      const h = {
        accessToken: f.headers["access-token"],
        client: f.headers.client,
        uid: f.headers.uid,
        httpSource: n
      };
      a == null || a.setItem("headers", JSON.stringify(h));
    }
  }, u = (f) => {
    f.interceptors.response.use(
      function(h) {
        var p, y, v, _;
        return d(h), Array.isArray(r == null ? void 0 : r.response) && (r == null || r.response.forEach((A) => A(h))), (p = h.data) != null && p.data || (y = h.data) != null && y.success ? {
          ...h.data,
          headers: h.headers,
          included: (v = h.data) == null ? void 0 : v.included
        } : {
          data: h.data,
          headers: h.headers,
          included: (_ = h.data) == null ? void 0 : _.included
        };
      },
      (h) => (h.response && d(h.response), Promise.reject(h))
    );
  };
  return ((f) => {
    f.interceptors.request.use(
      async function(h) {
        const p = await (a == null ? void 0 : a.getItem("headers"));
        return p && (h.headers["access-token"] = JSON.parse(p).accessToken, h.headers.client = JSON.parse(p).client, h.headers.uid = JSON.parse(p).uid, h.headers.httpSource = JSON.parse(p).httpSource), e && (h.headers.deviceIdentifier = await e()), h;
      },
      (h) => Promise.reject(h)
    );
  })(o), u(o), o;
}, ma = ({ apiUrl: t }) => {
  const e = `${t}/api/`;
  return Ft.create({
    baseURL: `${e}`,
    headers: Xr
  });
}, fe = ({ apiUrl: t }) => {
  const e = `${t}/`;
  return Kr(
    Ft.create({
      baseURL: e,
      headers: {
        "Content-Type": "application/json"
      }
    })
  );
}, $e = {
  lc: (t) => ya(t),
  mindee: (t) => fe(t),
  abtest: (t) => fe(t),
  ipLocation: (t) => fe(t),
  sharegroop: (t) => fe(t),
  strapiAdmin: (t) => ma(t),
  hubspot: (t) => fe(t),
  mapbox: (t) => fe(t)
}, se = ({
  api: t,
  locale: e,
  storageClient: r,
  unserialized: s = !1
}) => {
  const n = {
    apiUrl: t.url,
    interceptors: t.interceptors,
    locale: e,
    storageClient: r,
    source: t.source,
    getDeviceUniqueId: t.getDeviceUniqueId
  };
  return {
    get: async (a, i) => {
      try {
        const o = await $e[t.name](n).get(a, i);
        return i != null && i.responseType ? Promise.resolve(o) : s ? t.name === "strapiAdmin" ? Promise.resolve(o.data) : Promise.resolve(o) : Promise.resolve(
          te(o)
        );
      } catch (o) {
        return Promise.resolve({
          errors: o
        });
      }
    },
    post: async (a, i, o) => {
      try {
        const d = await $e[t.name](n).post(
          a,
          i,
          o
        );
        return s ? Promise.resolve(d) : Promise.resolve(te(d));
      } catch (d) {
        return Promise.resolve({
          errors: d
        });
      }
    },
    put: async (a, i, o) => {
      try {
        const d = await $e[t.name](n).put(
          a,
          i,
          o
        );
        return s ? Promise.resolve(d) : Promise.resolve(te(d));
      } catch (d) {
        return Promise.resolve({
          errors: d
        });
      }
    },
    delete: async (a) => {
      try {
        const i = await $e[t.name](n).delete(a);
        return s ? Promise.resolve(i) : Promise.resolve(te(i));
      } catch (i) {
        return Promise.resolve({
          errors: i
        });
      }
    },
    raw: async (a, i) => {
      const o = await $e[t.name](n).request({
        url: a,
        method: "GET",
        ...i,
        responseType: i.responseType.toLowerCase()
      });
      return {
        headers: new Headers(Object.entries(o.headers)),
        _data: o.data
      };
    }
  };
}, pa = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, ga = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, va = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function _a(t, e) {
  if (t === "__proto__" || t === "constructor" && e && typeof e == "object" && "prototype" in e) {
    ba(t);
    return;
  }
  return e;
}
function ba(t) {
  console.warn(`[destr] Dropping "${t}" key to prevent prototype pollution.`);
}
function qa(t, e = {}) {
  if (typeof t != "string")
    return t;
  if (t[0] === '"' && t[t.length - 1] === '"' && t.indexOf("\\") === -1)
    return t.slice(1, -1);
  const r = t.trim();
  if (r.length <= 9)
    switch (r.toLowerCase()) {
      case "true":
        return !0;
      case "false":
        return !1;
      case "undefined":
        return;
      case "null":
        return null;
      case "nan":
        return Number.NaN;
      case "infinity":
        return Number.POSITIVE_INFINITY;
      case "-infinity":
        return Number.NEGATIVE_INFINITY;
    }
  if (!va.test(t)) {
    if (e.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return t;
  }
  try {
    if (pa.test(t) || ga.test(t)) {
      if (e.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(t, _a);
    }
    return JSON.parse(t);
  } catch (s) {
    if (e.strict)
      throw s;
    return t;
  }
}
const wa = /#/g, ka = /&/g, $a = /\//g, Ia = /=/g, Mt = /\+/g, xa = /%5e/gi, Ta = /%60/gi, Sa = /%7c/gi, Aa = /%20/gi;
function Ra(t) {
  return encodeURI("" + t).replace(Sa, "|");
}
function pt(t) {
  return Ra(typeof t == "string" ? t : JSON.stringify(t)).replace(Mt, "%2B").replace(Aa, "+").replace(wa, "%23").replace(ka, "%26").replace(Ta, "`").replace(xa, "^").replace($a, "%2F");
}
function nt(t) {
  return pt(t).replace(Ia, "%3D");
}
function Qr(t = "") {
  try {
    return decodeURIComponent("" + t);
  } catch {
    return "" + t;
  }
}
function Ea(t) {
  return Qr(t.replace(Mt, " "));
}
function Ca(t) {
  return Qr(t.replace(Mt, " "));
}
function Oa(t = "") {
  const e = /* @__PURE__ */ Object.create(null);
  t[0] === "?" && (t = t.slice(1));
  for (const r of t.split("&")) {
    const s = r.match(/([^=]+)=?(.*)/) || [];
    if (s.length < 2)
      continue;
    const n = Ea(s[1]);
    if (n === "__proto__" || n === "constructor")
      continue;
    const a = Ca(s[2] || "");
    e[n] === void 0 ? e[n] = a : Array.isArray(e[n]) ? e[n].push(a) : e[n] = [e[n], a];
  }
  return e;
}
function Pa(t, e) {
  return (typeof e == "number" || typeof e == "boolean") && (e = String(e)), e ? Array.isArray(e) ? e.map(
    (r) => `${nt(t)}=${pt(r)}`
  ).join("&") : `${nt(t)}=${pt(e)}` : nt(t);
}
function Na(t) {
  return Object.keys(t).filter((e) => t[e] !== void 0).map((e) => Pa(e, t[e])).filter(Boolean).join("&");
}
const Da = /^[\s\w\0+.-]{2,}:([/\\]{1,2})/, ja = /^[\s\w\0+.-]{2,}:([/\\]{2})?/, Ua = /^([/\\]\s*){2,}[^/\\]/, La = /\/$|\/\?|\/#/, Ba = /^\.?\//;
function Yr(t, e = {}) {
  return typeof e == "boolean" && (e = { acceptRelative: e }), e.strict ? Da.test(t) : ja.test(t) || (e.acceptRelative ? Ua.test(t) : !1);
}
function gt(t = "", e) {
  return e ? La.test(t) : t.endsWith("/");
}
function Ha(t = "", e) {
  if (!e)
    return (gt(t) ? t.slice(0, -1) : t) || "/";
  if (!gt(t, !0))
    return t || "/";
  let r = t, s = "";
  const n = t.indexOf("#");
  n !== -1 && (r = t.slice(0, n), s = t.slice(n));
  const [a, ...i] = r.split("?");
  return ((a.endsWith("/") ? a.slice(0, -1) : a) || "/") + (i.length > 0 ? `?${i.join("?")}` : "") + s;
}
function Fa(t = "", e) {
  if (!e)
    return t.endsWith("/") ? t : t + "/";
  if (gt(t, !0))
    return t || "/";
  let r = t, s = "";
  const n = t.indexOf("#");
  if (n !== -1 && (r = t.slice(0, n), s = t.slice(n), !r))
    return s;
  const [a, ...i] = r.split("?");
  return a + "/" + (i.length > 0 ? `?${i.join("?")}` : "") + s;
}
function Ma(t, e) {
  if (Va(e) || Yr(t))
    return t;
  const r = Ha(e);
  return t.startsWith(r) ? t : Wa(r, t);
}
function za(t, e) {
  const r = ts(t), s = { ...Oa(r.search), ...e };
  return r.search = Na(s), Ga(r);
}
function Va(t) {
  return !t || t === "/";
}
function Za(t) {
  return t && t !== "/";
}
function Wa(t, ...e) {
  let r = t || "";
  for (const s of e.filter((n) => Za(n)))
    if (r) {
      const n = s.replace(Ba, "");
      r = Fa(r) + n;
    } else
      r = s;
  return r;
}
const es = Symbol.for("ufo:protocolRelative");
function ts(t = "", e) {
  const r = t.match(
    /^[\s\0]*(blob:|data:|javascript:|vbscript:)(.*)/i
  );
  if (r) {
    const [, f, h = ""] = r;
    return {
      protocol: f.toLowerCase(),
      pathname: h,
      href: f + h,
      auth: "",
      host: "",
      search: "",
      hash: ""
    };
  }
  if (!Yr(t, { acceptRelative: !0 }))
    return e ? ts(e + t) : yr(t);
  const [, s = "", n, a = ""] = t.replace(/\\/g, "/").match(/^[\s\0]*([\w+.-]{2,}:)?\/\/([^/@]+@)?(.*)/) || [];
  let [, i = "", o = ""] = a.match(/([^#/?]*)(.*)?/) || [];
  s === "file:" && (o = o.replace(/\/(?=[A-Za-z]:)/, ""));
  const { pathname: d, search: u, hash: c } = yr(o);
  return {
    protocol: s.toLowerCase(),
    auth: n ? n.slice(0, Math.max(0, n.length - 1)) : "",
    host: i,
    pathname: d,
    search: u,
    hash: c,
    [es]: !s
  };
}
function yr(t = "") {
  const [e = "", r = "", s = ""] = (t.match(/([^#?]*)(\?[^#]*)?(#.*)?/) || []).splice(1);
  return {
    pathname: e,
    search: r,
    hash: s
  };
}
function Ga(t) {
  const e = t.pathname || "", r = t.search ? (t.search.startsWith("?") ? "" : "?") + t.search : "", s = t.hash || "", n = t.auth ? t.auth + "@" : "", a = t.host || "";
  return (t.protocol || t[es] ? (t.protocol || "") + "//" : "") + n + a + e + r + s;
}
class Ja extends Error {
  constructor(e, r) {
    super(e, r), this.name = "FetchError", r != null && r.cause && !this.cause && (this.cause = r.cause);
  }
}
function Ka(t) {
  var d, u, c, f, h;
  const e = ((d = t.error) == null ? void 0 : d.message) || ((u = t.error) == null ? void 0 : u.toString()) || "", r = ((c = t.request) == null ? void 0 : c.method) || ((f = t.options) == null ? void 0 : f.method) || "GET", s = ((h = t.request) == null ? void 0 : h.url) || String(t.request) || "/", n = `[${r}] ${JSON.stringify(s)}`, a = t.response ? `${t.response.status} ${t.response.statusText}` : "<no response>", i = `${n}: ${a}${e ? ` ${e}` : ""}`, o = new Ja(
    i,
    t.error ? { cause: t.error } : void 0
  );
  for (const p of ["request", "options", "response"])
    Object.defineProperty(o, p, {
      get() {
        return t[p];
      }
    });
  for (const [p, y] of [
    ["data", "_data"],
    ["status", "status"],
    ["statusCode", "status"],
    ["statusText", "statusText"],
    ["statusMessage", "statusText"]
  ])
    Object.defineProperty(o, p, {
      get() {
        return t.response && t.response[y];
      }
    });
  return o;
}
const Xa = new Set(
  Object.freeze(["PATCH", "POST", "PUT", "DELETE"])
);
function mr(t = "GET") {
  return Xa.has(t.toUpperCase());
}
function Qa(t) {
  if (t === void 0)
    return !1;
  const e = typeof t;
  return e === "string" || e === "number" || e === "boolean" || e === null ? !0 : e !== "object" ? !1 : Array.isArray(t) ? !0 : t.buffer ? !1 : t.constructor && t.constructor.name === "Object" || typeof t.toJSON == "function";
}
const Ya = /* @__PURE__ */ new Set([
  "image/svg",
  "application/xml",
  "application/xhtml",
  "application/html"
]), ei = /^application\/(?:[\w!#$%&*.^`~-]*\+)?json(;.+)?$/i;
function ti(t = "") {
  if (!t)
    return "json";
  const e = t.split(";").shift() || "";
  return ei.test(e) ? "json" : Ya.has(e) || e.startsWith("text/") ? "text" : "blob";
}
function ri(t, e, r, s) {
  const n = si(
    (e == null ? void 0 : e.headers) ?? (t == null ? void 0 : t.headers),
    r == null ? void 0 : r.headers,
    s
  );
  let a;
  return (r != null && r.query || r != null && r.params || e != null && e.params || e != null && e.query) && (a = {
    ...r == null ? void 0 : r.params,
    ...r == null ? void 0 : r.query,
    ...e == null ? void 0 : e.params,
    ...e == null ? void 0 : e.query
  }), {
    ...r,
    ...e,
    query: a,
    params: a,
    headers: n
  };
}
function si(t, e, r) {
  if (!e)
    return new r(t);
  const s = new r(e);
  if (t)
    for (const [n, a] of Symbol.iterator in t || Array.isArray(t) ? t : new r(t))
      s.set(n, a);
  return s;
}
async function Ee(t, e) {
  if (e)
    if (Array.isArray(e))
      for (const r of e)
        await r(t);
    else
      await e(t);
}
const ni = /* @__PURE__ */ new Set([
  408,
  // Request Timeout
  409,
  // Conflict
  425,
  // Too Early (Experimental)
  429,
  // Too Many Requests
  500,
  // Internal Server Error
  502,
  // Bad Gateway
  503,
  // Service Unavailable
  504
  // Gateway Timeout
]), ai = /* @__PURE__ */ new Set([101, 204, 205, 304]);
function rs(t = {}) {
  const {
    fetch: e = globalThis.fetch,
    Headers: r = globalThis.Headers,
    AbortController: s = globalThis.AbortController
  } = t;
  async function n(o) {
    const d = o.error && o.error.name === "AbortError" && !o.options.timeout || !1;
    if (o.options.retry !== !1 && !d) {
      let c;
      typeof o.options.retry == "number" ? c = o.options.retry : c = mr(o.options.method) ? 0 : 1;
      const f = o.response && o.response.status || 500;
      if (c > 0 && (Array.isArray(o.options.retryStatusCodes) ? o.options.retryStatusCodes.includes(f) : ni.has(f))) {
        const h = typeof o.options.retryDelay == "function" ? o.options.retryDelay(o) : o.options.retryDelay || 0;
        return h > 0 && await new Promise((p) => setTimeout(p, h)), a(o.request, {
          ...o.options,
          retry: c - 1
        });
      }
    }
    const u = Ka(o);
    throw Error.captureStackTrace && Error.captureStackTrace(u, a), u;
  }
  const a = async function(d, u = {}) {
    const c = {
      request: d,
      options: ri(
        d,
        u,
        t.defaults,
        r
      ),
      response: void 0,
      error: void 0
    };
    c.options.method && (c.options.method = c.options.method.toUpperCase()), c.options.onRequest && await Ee(c, c.options.onRequest), typeof c.request == "string" && (c.options.baseURL && (c.request = Ma(c.request, c.options.baseURL)), c.options.query && (c.request = za(c.request, c.options.query), delete c.options.query), "query" in c.options && delete c.options.query, "params" in c.options && delete c.options.params), c.options.body && mr(c.options.method) && (Qa(c.options.body) ? (c.options.body = typeof c.options.body == "string" ? c.options.body : JSON.stringify(c.options.body), c.options.headers = new r(c.options.headers || {}), c.options.headers.has("content-type") || c.options.headers.set("content-type", "application/json"), c.options.headers.has("accept") || c.options.headers.set("accept", "application/json")) : (
      // ReadableStream Body
      ("pipeTo" in c.options.body && typeof c.options.body.pipeTo == "function" || // Node.js Stream Body
      typeof c.options.body.pipe == "function") && ("duplex" in c.options || (c.options.duplex = "half"))
    ));
    let f;
    if (!c.options.signal && c.options.timeout) {
      const p = new s();
      f = setTimeout(() => {
        const y = new Error(
          "[TimeoutError]: The operation was aborted due to timeout"
        );
        y.name = "TimeoutError", y.code = 23, p.abort(y);
      }, c.options.timeout), c.options.signal = p.signal;
    }
    try {
      c.response = await e(
        c.request,
        c.options
      );
    } catch (p) {
      return c.error = p, c.options.onRequestError && await Ee(
        c,
        c.options.onRequestError
      ), await n(c);
    } finally {
      f && clearTimeout(f);
    }
    if ((c.response.body || // https://github.com/unjs/ofetch/issues/324
    // https://github.com/unjs/ofetch/issues/294
    // https://github.com/JakeChampion/fetch/issues/1454
    c.response._bodyInit) && !ai.has(c.response.status) && c.options.method !== "HEAD") {
      const p = (c.options.parseResponse ? "json" : c.options.responseType) || ti(c.response.headers.get("content-type") || "");
      switch (p) {
        case "json": {
          const y = await c.response.text(), v = c.options.parseResponse || qa;
          c.response._data = v(y);
          break;
        }
        case "stream": {
          c.response._data = c.response.body || c.response._bodyInit;
          break;
        }
        default:
          c.response._data = await c.response[p]();
      }
    }
    return c.options.onResponse && await Ee(
      c,
      c.options.onResponse
    ), !c.options.ignoreResponseError && c.response.status >= 400 && c.response.status < 600 ? (c.options.onResponseError && await Ee(
      c,
      c.options.onResponseError
    ), await n(c)) : c.response;
  }, i = async function(d, u) {
    return (await a(d, u))._data;
  };
  return i.raw = a, i.native = (...o) => e(...o), i.create = (o = {}, d = {}) => rs({
    ...t,
    ...d,
    defaults: {
      ...t.defaults,
      ...d.defaults,
      ...o
    }
  }), i;
}
const He = function() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
}(), ii = He.fetch ? (...t) => He.fetch(...t) : () => Promise.reject(new Error("[ofetch] global.fetch is not supported!")), oi = He.Headers, ci = He.AbortController, J = rs({ fetch: ii, Headers: oi, AbortController: ci }), we = ({ api: t }) => {
  const e = `${t.url}/`;
  return {
    get: async (r, s) => {
      try {
        const n = await J(`${e}${r}`, {
          method: "GET",
          ...s
        });
        return s != null && s.responseType, Promise.resolve(n);
      } catch (n) {
        return Promise.resolve({
          errors: n
        });
      }
    },
    post: async (r, s, n) => {
      try {
        const a = await J(`${e}${r}`, {
          method: "POST",
          body: s,
          ...n
        });
        return Promise.resolve(a);
      } catch (a) {
        return Promise.resolve({
          errors: a
        });
      }
    },
    put: async (r, s, n) => {
      try {
        const a = await J(`${e}${r}`, {
          method: "PUT",
          body: s,
          ...n
        });
        return Promise.resolve(a);
      } catch (a) {
        return Promise.resolve({
          errors: a
        });
      }
    },
    delete: async (r) => {
      try {
        const s = await J(`${e}${r}`, {
          method: "DELETE"
        });
        return Promise.resolve(s);
      } catch (s) {
        return Promise.resolve({
          errors: s
        });
      }
    }
  };
};
class nf {
  constructor(e) {
    this.provider = e, this.amplitudeApiUrl = "", this.experimentApiUrl = "", this.amplitudeLabApiUrl = "", this.amplitudeLabHeaders = {}, this.experimentHeaders = {}, this.amplitudeApiKey = "", this.httpTracking = {}, this.httpAmplitudeLab = {}, this.httpExperiment = {}, this.amplitudeLabHeaders = {
      headers: { Authorization: `Api-Key ${this.provider.amplitudeApiKey}` }
    }, this.experimentHeaders = {
      headers: { Authorization: `Bearer ${this.provider.experimentApiKey}` }
    }, this.amplitudeApiKey = this.provider.amplitudeApiKey, this.amplitudeApiUrl = this.provider.amplitudeApiUrl, this.amplitudeLabApiUrl = this.provider.amplitudeLabApiUrl, this.experimentApiUrl = this.provider.experimentApiUrl, this.httpTracking = this.setHttp(
      this.provider.httpClientType,
      this.amplitudeApiUrl
    ), this.httpAmplitudeLab = this.setHttp(
      this.provider.httpClientType,
      this.amplitudeLabApiUrl
    ), this.httpExperiment = this.setHttp(
      this.provider.httpClientType,
      this.experimentApiUrl
    );
  }
  setHttp(e, r) {
    const s = { name: "abtest", url: r };
    return e === "axios" ? se({ api: s, unserialized: !0 }) : we({ api: s });
  }
  // Récupère la liste des experiments (par défaut en cours et décidées)
  async getExperiments(e = ["running", "decision-made"]) {
    try {
      return ((await this.httpExperiment.get(
        "api/1/experiments",
        this.experimentHeaders
      )).experiments ?? []).filter((s) => e.includes(s.state)).map((s) => ({
        id: s.id,
        key: s.key,
        state: s.state,
        variants: s.variants
      }));
    } catch (r) {
      return console.error("Failed to get experiments", r), [];
    }
  }
  // Récupère le variant a associé au user pour chaque flagkey (flagkey étant l'id d'une experiment)
  async getUserVariant({
    flagKey: e,
    deviceId: r,
    userId: s
  }) {
    const n = {
      query: {
        flag_key: e,
        ...r ? { device_id: r } : {},
        ...s ? { user_id: s } : {}
      },
      ...this.amplitudeLabHeaders
    };
    try {
      const a = await this.httpAmplitudeLab.get(
        "v1/vardata",
        n
      );
      return e in a ? a[e].key : "control";
    } catch (a) {
      return console.error("Failed to get user variant", a), "";
    }
  }
  // Permet de tracker lorsque le user commence une experiment (clique sur un bouton or whatever)
  async sendExposure({
    deviceId: e,
    userId: r,
    flagKey: s,
    variant: n
  }) {
    const a = {
      api_key: this.amplitudeApiKey,
      events: [
        {
          event_type: "$exposure",
          device_id: e,
          event_properties: {
            flag_key: s,
            variant: n
          },
          ...r ? { user_id: r } : {}
        }
      ]
    };
    try {
      return await this.httpTracking.post("2/httpapi", a);
    } catch (i) {
      console.error(i);
    }
  }
  async getUserVariants({
    deviceId: e,
    userId: r
  }) {
    const s = {};
    try {
      const n = await this.getExperiments();
      if (n && (n == null ? void 0 : n.length) > 0)
        for (const a of n)
          try {
            const i = await this.getUserVariant({
              flagKey: a.key,
              deviceId: e,
              userId: r
            });
            s[a.key] = i;
          } catch (i) {
            console.error(
              `Failed to get variant for key: ${a.key}`,
              i
            );
          }
      return { experiments: n, userVariant: s };
    } catch (n) {
      console.error(n);
    }
  }
  async getUserVariantsV2({
    deviceId: e,
    userId: r
  }) {
    try {
      const s = await this.getExperiments(), n = [];
      if (s && (s == null ? void 0 : s.length) > 0)
        for (const o of s)
          n.push(
            this.getUserVariant({
              flagKey: o.key,
              deviceId: e,
              userId: r
            })
          );
      const i = (await Promise.all(n)).reduce(
        (o, d, u) => (o[s[u].key] = d, o),
        {}
      );
      return { experiments: s, userVariants: i };
    } catch (s) {
      return console.error(s), { experiments: [], userVariants: {} };
    }
  }
}
const pr = (t) => {
  let e = t[0].toUpperCase();
  for (let r = 1; r < t.length; r++)
    [" ", "-"].includes(t[r - 1]) ? e += t[r].toUpperCase() : e += t[r].toLowerCase();
  return e;
};
class af {
  constructor(e) {
    this.provider = e, this.headers = {}, this.http = {}, this.apiUrl = "", this.headers = {
      headers: { Authorization: `Token ${this.provider.apiKey}` }
    }, this.apiUrl = this.provider.apiUrl, this.http = this.setHttp(this.provider.httpClientType);
  }
  setHttp(e) {
    const r = { name: "mindee", url: this.apiUrl };
    return e === "axios" ? se({ api: r, unserialized: !0 }) : we({ api: r });
  }
  getPredictData(e, r) {
    return e.reduce(
      (s, n) => {
        const a = [
          "surname",
          "given_names",
          "alternate_name"
        ].includes(n);
        if (Array.isArray(r[n])) {
          const i = r[n];
          s[n] = i.filter((o) => o.value).map((o) => a ? pr(o.value) : o.value);
        } else {
          const i = r[n];
          i.value && (s[n] = a ? pr(i.value) : i.value);
        }
        return s;
      },
      {}
    );
  }
  dataFormatter(e) {
    return e.map((r) => {
      const s = Object.keys(r.prediction);
      return this.getPredictData(s, r.prediction);
    });
  }
  async verifyPassport(e) {
    const r = await this.http.post(
      "v1/products/mindee/passport/v1/predict",
      { document: e },
      this.headers
    ).then(
      (n) => typeof n.data == "object" ? n : { data: n }
    );
    return {
      data: this.dataFormatter(
        r.data.document.inference.pages
      ),
      error: r.data.api_request.error,
      status: r.data.api_request.status,
      code: r.data.api_request.status_code
    };
  }
  async verifyIdentityCard(e) {
    const r = await this.http.post(
      "v1/products/mindee/idcard_fr/v2/predict",
      { document: e },
      this.headers
    ).then(
      (n) => typeof n.data == "object" ? n : { data: n }
    );
    return {
      data: this.dataFormatter(
        r.data.document.inference.pages
      ),
      error: r.data.api_request.error,
      status: r.data.api_request.status,
      code: r.data.api_request.status_code
    };
  }
}
class of {
  constructor(e) {
    this.provider = e, this.http = {}, this.http = this.setHttp(this.provider.httpClientType);
  }
  setHttp(e) {
    const r = { name: "mapbox", url: this.provider.apiUrl };
    return e === "axios" ? se({ api: r, unserialized: !0 }) : we({ api: r });
  }
  /** Get place(s) based on a string query */
  async forwardSearch(e, r = {}) {
    const s = Object.fromEntries(
      Object.entries(r).filter(([i, o]) => typeof o < "u").map(([i, o]) => [i, o.toString()])
    ), n = new URLSearchParams({
      access_token: this.provider.apiKey,
      autocomplete: "true",
      limit: "4",
      q: e,
      types: "country,region,places",
      ...s
    }).toString(), a = await this.http.get(`search/geocode/v6/forward?${n}`);
    if (a.errors)
      throw a.errors;
    return a.features ?? [];
  }
}
const gr = (t) => {
  const e = t.fields && Object.entries(t.fields).map(
    (r) => `filter[${r[0]}]=${r[1].operation}:${r[1].value}`
  );
  return t.sort ? e ? `${e.join("&")}&sort=${t.sort}` : `sort=${t.sort}` : e && e.join("&");
}, vr = (t) => {
  const e = t.include && t.include.join(), r = t.fields && Object.entries(t.fields).map(
    (s) => `fields[${s[0]}]=${s[1].join()}`
  );
  if (e && r)
    return `include=${e}&${r.join("&")}`;
  if (!e && r)
    return r.join("&");
  if (e && !r)
    return `include=${e}`;
}, w = ({
  includes: t,
  filter: e,
  pagination: r = { page: "1", per: "25" }
}) => {
  const s = `page=${r.page}&per=${r.per}`;
  return t && !e ? `?${vr(t)}&${s}` : e && !t ? `?${gr(e)}&${s}` : e && t ? `?${vr(t)}&${gr(
    e
  )}&${s}` : !e && !t && r ? `?${s}` : "";
}, vt = (t, e) => {
  const r = { ...t };
  for (const s in e)
    e[s] instanceof Object && !Array.isArray(e[s]) && t[s] ? r[s] = vt(t[s], e[s]) : r.hasOwnProperty(s) || (r[s] = e[s]);
  return r;
};
var S;
(function(t) {
  t.assertEqual = (n) => {
  };
  function e(n) {
  }
  t.assertIs = e;
  function r(n) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (n) => {
    const a = {};
    for (const i of n)
      a[i] = i;
    return a;
  }, t.getValidEnumValues = (n) => {
    const a = t.objectKeys(n).filter((o) => typeof n[n[o]] != "number"), i = {};
    for (const o of a)
      i[o] = n[o];
    return t.objectValues(i);
  }, t.objectValues = (n) => t.objectKeys(n).map(function(a) {
    return n[a];
  }), t.objectKeys = typeof Object.keys == "function" ? (n) => Object.keys(n) : (n) => {
    const a = [];
    for (const i in n)
      Object.prototype.hasOwnProperty.call(n, i) && a.push(i);
    return a;
  }, t.find = (n, a) => {
    for (const i of n)
      if (a(i))
        return i;
  }, t.isInteger = typeof Number.isInteger == "function" ? (n) => Number.isInteger(n) : (n) => typeof n == "number" && Number.isFinite(n) && Math.floor(n) === n;
  function s(n, a = " | ") {
    return n.map((i) => typeof i == "string" ? `'${i}'` : i).join(a);
  }
  t.joinValues = s, t.jsonStringifyReplacer = (n, a) => typeof a == "bigint" ? a.toString() : a;
})(S || (S = {}));
var _r;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(_r || (_r = {}));
const b = S.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Y = (t) => {
  switch (typeof t) {
    case "undefined":
      return b.undefined;
    case "string":
      return b.string;
    case "number":
      return Number.isNaN(t) ? b.nan : b.number;
    case "boolean":
      return b.boolean;
    case "function":
      return b.function;
    case "bigint":
      return b.bigint;
    case "symbol":
      return b.symbol;
    case "object":
      return Array.isArray(t) ? b.array : t === null ? b.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? b.promise : typeof Map < "u" && t instanceof Map ? b.map : typeof Set < "u" && t instanceof Set ? b.set : typeof Date < "u" && t instanceof Date ? b.date : b.object;
    default:
      return b.unknown;
  }
}, m = S.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class X extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (s) => {
      this.issues = [...this.issues, s];
    }, this.addIssues = (s = []) => {
      this.issues = [...this.issues, ...s];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(a) {
      return a.message;
    }, s = { _errors: [] }, n = (a) => {
      for (const i of a.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(n);
        else if (i.code === "invalid_return_type")
          n(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          n(i.argumentsError);
        else if (i.path.length === 0)
          s._errors.push(r(i));
        else {
          let o = s, d = 0;
          for (; d < i.path.length; ) {
            const u = i.path[d];
            d === i.path.length - 1 ? (o[u] = o[u] || { _errors: [] }, o[u]._errors.push(r(i))) : o[u] = o[u] || { _errors: [] }, o = o[u], d++;
          }
        }
    };
    return n(this), s;
  }
  static assert(e) {
    if (!(e instanceof X))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, S.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, s = [];
    for (const n of this.issues)
      if (n.path.length > 0) {
        const a = n.path[0];
        r[a] = r[a] || [], r[a].push(e(n));
      } else
        s.push(e(n));
    return { formErrors: s, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
X.create = (t) => new X(t);
const ui = (t, e) => {
  let r;
  switch (t.code) {
    case m.invalid_type:
      t.received === b.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case m.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, S.jsonStringifyReplacer)}`;
      break;
    case m.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${S.joinValues(t.keys, ", ")}`;
      break;
    case m.invalid_union:
      r = "Invalid input";
      break;
    case m.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${S.joinValues(t.options)}`;
      break;
    case m.invalid_enum_value:
      r = `Invalid enum value. Expected ${S.joinValues(t.options)}, received '${t.received}'`;
      break;
    case m.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case m.invalid_return_type:
      r = "Invalid function return type";
      break;
    case m.invalid_date:
      r = "Invalid date";
      break;
    case m.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : S.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case m.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "bigint" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case m.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case m.custom:
      r = "Invalid input";
      break;
    case m.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case m.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case m.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, S.assertNever(t);
  }
  return { message: r };
}, _t = ui;
let di = _t;
function li() {
  return di;
}
const fi = (t) => {
  const { data: e, path: r, errorMaps: s, issueData: n } = t, a = [...r, ...n.path || []], i = {
    ...n,
    path: a
  };
  if (n.message !== void 0)
    return {
      ...n,
      path: a,
      message: n.message
    };
  let o = "";
  const d = s.filter((u) => !!u).slice().reverse();
  for (const u of d)
    o = u(i, { data: e, defaultError: o }).message;
  return {
    ...n,
    path: a,
    message: o
  };
};
function g(t, e) {
  const r = li(), s = fi({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === _t ? void 0 : _t
      // then global default map
    ].filter((n) => !!n)
  });
  t.common.issues.push(s);
}
class U {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const s = [];
    for (const n of r) {
      if (n.status === "aborted")
        return $;
      n.status === "dirty" && e.dirty(), s.push(n.value);
    }
    return { status: e.value, value: s };
  }
  static async mergeObjectAsync(e, r) {
    const s = [];
    for (const n of r) {
      const a = await n.key, i = await n.value;
      s.push({
        key: a,
        value: i
      });
    }
    return U.mergeObjectSync(e, s);
  }
  static mergeObjectSync(e, r) {
    const s = {};
    for (const n of r) {
      const { key: a, value: i } = n;
      if (a.status === "aborted" || i.status === "aborted")
        return $;
      a.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof i.value < "u" || n.alwaysSet) && (s[a.value] = i.value);
    }
    return { status: e.value, value: s };
  }
}
const $ = Object.freeze({
  status: "aborted"
}), Ie = (t) => ({ status: "dirty", value: t }), H = (t) => ({ status: "valid", value: t }), br = (t) => t.status === "aborted", qr = (t) => t.status === "dirty", ye = (t) => t.status === "valid", Fe = (t) => typeof Promise < "u" && t instanceof Promise;
var q;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(q || (q = {}));
class G {
  constructor(e, r, s, n) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = s, this._key = n;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const wr = (t, e) => {
  if (ye(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new X(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function x(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: s, description: n } = t;
  if (e && (r || s))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: n } : { errorMap: (i, o) => {
    const { message: d } = t;
    return i.code === "invalid_enum_value" ? { message: d ?? o.defaultError } : typeof o.data > "u" ? { message: d ?? s ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: d ?? r ?? o.defaultError };
  }, description: n };
}
class T {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Y(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: Y(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new U(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Y(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (Fe(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const s = this.safeParse(e, r);
    if (s.success)
      return s.data;
    throw s.error;
  }
  safeParse(e, r) {
    const s = {
      common: {
        issues: [],
        async: (r == null ? void 0 : r.async) ?? !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Y(e)
    }, n = this._parseSync({ data: e, path: s.path, parent: s });
    return wr(s, n);
  }
  "~validate"(e) {
    var s, n;
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Y(e)
    };
    if (!this["~standard"].async)
      try {
        const a = this._parseSync({ data: e, path: [], parent: r });
        return ye(a) ? {
          value: a.value
        } : {
          issues: r.common.issues
        };
      } catch (a) {
        (n = (s = a == null ? void 0 : a.message) == null ? void 0 : s.toLowerCase()) != null && n.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: r }).then((a) => ye(a) ? {
      value: a.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(e, r) {
    const s = await this.safeParseAsync(e, r);
    if (s.success)
      return s.data;
    throw s.error;
  }
  async safeParseAsync(e, r) {
    const s = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Y(e)
    }, n = this._parse({ data: e, path: s.path, parent: s }), a = await (Fe(n) ? n : Promise.resolve(n));
    return wr(s, a);
  }
  refine(e, r) {
    const s = (n) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(n) : r;
    return this._refinement((n, a) => {
      const i = e(n), o = () => a.addIssue({
        code: m.custom,
        ...s(n)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((d) => d ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((s, n) => e(s) ? !0 : (n.addIssue(typeof r == "function" ? r(s, n) : r), !1));
  }
  _refinement(e) {
    return new ae({
      schema: this,
      typeName: k.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return re.create(this, this._def);
  }
  nullable() {
    return _e.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return W.create(this);
  }
  promise() {
    return Ze.create(this, this._def);
  }
  or(e) {
    return Me.create([this, e], this._def);
  }
  and(e) {
    return ze.create(this, e, this._def);
  }
  transform(e) {
    return new ae({
      ...x(this._def),
      schema: this,
      typeName: k.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Ct({
      ...x(this._def),
      innerType: this,
      defaultValue: r,
      typeName: k.ZodDefault
    });
  }
  brand() {
    return new Ni({
      typeName: k.ZodBranded,
      type: this,
      ...x(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Ot({
      ...x(this._def),
      innerType: this,
      catchValue: r,
      typeName: k.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return zt.create(this, e);
  }
  readonly() {
    return Nt.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const hi = /^c[^\s-]{8,}$/i, yi = /^[0-9a-z]+$/, mi = /^[0-9A-HJKMNP-TV-Z]{26}$/i, pi = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, gi = /^[a-z0-9_-]{21}$/i, vi = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, _i = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, bi = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, qi = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let at;
const wi = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, ki = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, $i = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Ii = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, xi = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Ti = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, ss = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Si = new RegExp(`^${ss}$`);
function ns(t) {
  let e = "[0-5]\\d";
  t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`);
  const r = t.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${r}`;
}
function Ai(t) {
  return new RegExp(`^${ns(t)}$`);
}
function Ri(t) {
  let e = `${ss}T${ns(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function Ei(t, e) {
  return !!((e === "v4" || !e) && wi.test(t) || (e === "v6" || !e) && $i.test(t));
}
function Ci(t, e) {
  if (!vi.test(t))
    return !1;
  try {
    const [r] = t.split(".");
    if (!r)
      return !1;
    const s = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), n = JSON.parse(atob(s));
    return !(typeof n != "object" || n === null || "typ" in n && (n == null ? void 0 : n.typ) !== "JWT" || !n.alg || e && n.alg !== e);
  } catch {
    return !1;
  }
}
function Oi(t, e) {
  return !!((e === "v4" || !e) && ki.test(t) || (e === "v6" || !e) && Ii.test(t));
}
class K extends T {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== b.string) {
      const a = this._getOrReturnCtx(e);
      return g(a, {
        code: m.invalid_type,
        expected: b.string,
        received: a.parsedType
      }), $;
    }
    const s = new U();
    let n;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (n = this._getOrReturnCtx(e, n), g(n, {
          code: m.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), s.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (n = this._getOrReturnCtx(e, n), g(n, {
          code: m.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), s.dirty());
      else if (a.kind === "length") {
        const i = e.data.length > a.value, o = e.data.length < a.value;
        (i || o) && (n = this._getOrReturnCtx(e, n), i ? g(n, {
          code: m.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : o && g(n, {
          code: m.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), s.dirty());
      } else if (a.kind === "email")
        bi.test(e.data) || (n = this._getOrReturnCtx(e, n), g(n, {
          validation: "email",
          code: m.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "emoji")
        at || (at = new RegExp(qi, "u")), at.test(e.data) || (n = this._getOrReturnCtx(e, n), g(n, {
          validation: "emoji",
          code: m.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "uuid")
        pi.test(e.data) || (n = this._getOrReturnCtx(e, n), g(n, {
          validation: "uuid",
          code: m.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "nanoid")
        gi.test(e.data) || (n = this._getOrReturnCtx(e, n), g(n, {
          validation: "nanoid",
          code: m.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "cuid")
        hi.test(e.data) || (n = this._getOrReturnCtx(e, n), g(n, {
          validation: "cuid",
          code: m.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "cuid2")
        yi.test(e.data) || (n = this._getOrReturnCtx(e, n), g(n, {
          validation: "cuid2",
          code: m.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "ulid")
        mi.test(e.data) || (n = this._getOrReturnCtx(e, n), g(n, {
          validation: "ulid",
          code: m.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          n = this._getOrReturnCtx(e, n), g(n, {
            validation: "url",
            code: m.invalid_string,
            message: a.message
          }), s.dirty();
        }
      else
        a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (n = this._getOrReturnCtx(e, n), g(n, {
          validation: "regex",
          code: m.invalid_string,
          message: a.message
        }), s.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (n = this._getOrReturnCtx(e, n), g(n, {
          code: m.invalid_string,
          validation: { includes: a.value, position: a.position },
          message: a.message
        }), s.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (n = this._getOrReturnCtx(e, n), g(n, {
          code: m.invalid_string,
          validation: { startsWith: a.value },
          message: a.message
        }), s.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (n = this._getOrReturnCtx(e, n), g(n, {
          code: m.invalid_string,
          validation: { endsWith: a.value },
          message: a.message
        }), s.dirty()) : a.kind === "datetime" ? Ri(a).test(e.data) || (n = this._getOrReturnCtx(e, n), g(n, {
          code: m.invalid_string,
          validation: "datetime",
          message: a.message
        }), s.dirty()) : a.kind === "date" ? Si.test(e.data) || (n = this._getOrReturnCtx(e, n), g(n, {
          code: m.invalid_string,
          validation: "date",
          message: a.message
        }), s.dirty()) : a.kind === "time" ? Ai(a).test(e.data) || (n = this._getOrReturnCtx(e, n), g(n, {
          code: m.invalid_string,
          validation: "time",
          message: a.message
        }), s.dirty()) : a.kind === "duration" ? _i.test(e.data) || (n = this._getOrReturnCtx(e, n), g(n, {
          validation: "duration",
          code: m.invalid_string,
          message: a.message
        }), s.dirty()) : a.kind === "ip" ? Ei(e.data, a.version) || (n = this._getOrReturnCtx(e, n), g(n, {
          validation: "ip",
          code: m.invalid_string,
          message: a.message
        }), s.dirty()) : a.kind === "jwt" ? Ci(e.data, a.alg) || (n = this._getOrReturnCtx(e, n), g(n, {
          validation: "jwt",
          code: m.invalid_string,
          message: a.message
        }), s.dirty()) : a.kind === "cidr" ? Oi(e.data, a.version) || (n = this._getOrReturnCtx(e, n), g(n, {
          validation: "cidr",
          code: m.invalid_string,
          message: a.message
        }), s.dirty()) : a.kind === "base64" ? xi.test(e.data) || (n = this._getOrReturnCtx(e, n), g(n, {
          validation: "base64",
          code: m.invalid_string,
          message: a.message
        }), s.dirty()) : a.kind === "base64url" ? Ti.test(e.data) || (n = this._getOrReturnCtx(e, n), g(n, {
          validation: "base64url",
          code: m.invalid_string,
          message: a.message
        }), s.dirty()) : S.assertNever(a);
    return { status: s.value, value: e.data };
  }
  _regex(e, r, s) {
    return this.refinement((n) => e.test(n), {
      validation: r,
      code: m.invalid_string,
      ...q.errToObj(s)
    });
  }
  _addCheck(e) {
    return new K({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...q.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...q.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...q.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...q.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...q.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...q.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...q.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...q.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...q.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...q.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...q.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...q.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...q.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (e == null ? void 0 : e.offset) ?? !1,
      local: (e == null ? void 0 : e.local) ?? !1,
      ...q.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...q.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...q.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...q.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...q.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...q.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...q.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...q.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...q.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...q.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, q.errToObj(e));
  }
  trim() {
    return new K({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new K({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new K({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
K.create = (t) => new K({
  checks: [],
  typeName: k.ZodString,
  coerce: (t == null ? void 0 : t.coerce) ?? !1,
  ...x(t)
});
function Pi(t, e) {
  const r = (t.toString().split(".")[1] || "").length, s = (e.toString().split(".")[1] || "").length, n = r > s ? r : s, a = Number.parseInt(t.toFixed(n).replace(".", "")), i = Number.parseInt(e.toFixed(n).replace(".", ""));
  return a % i / 10 ** n;
}
class me extends T {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== b.number) {
      const a = this._getOrReturnCtx(e);
      return g(a, {
        code: m.invalid_type,
        expected: b.number,
        received: a.parsedType
      }), $;
    }
    let s;
    const n = new U();
    for (const a of this._def.checks)
      a.kind === "int" ? S.isInteger(e.data) || (s = this._getOrReturnCtx(e, s), g(s, {
        code: m.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), n.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (s = this._getOrReturnCtx(e, s), g(s, {
        code: m.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), n.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (s = this._getOrReturnCtx(e, s), g(s, {
        code: m.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), n.dirty()) : a.kind === "multipleOf" ? Pi(e.data, a.value) !== 0 && (s = this._getOrReturnCtx(e, s), g(s, {
        code: m.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), n.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (s = this._getOrReturnCtx(e, s), g(s, {
        code: m.not_finite,
        message: a.message
      }), n.dirty()) : S.assertNever(a);
    return { status: n.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, q.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, q.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, q.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, q.toString(r));
  }
  setLimit(e, r, s, n) {
    return new me({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: s,
          message: q.toString(n)
        }
      ]
    });
  }
  _addCheck(e) {
    return new me({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: q.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: q.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: q.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: q.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: q.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: q.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: q.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: q.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: q.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && S.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const s of this._def.checks) {
      if (s.kind === "finite" || s.kind === "int" || s.kind === "multipleOf")
        return !0;
      s.kind === "min" ? (r === null || s.value > r) && (r = s.value) : s.kind === "max" && (e === null || s.value < e) && (e = s.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
}
me.create = (t) => new me({
  checks: [],
  typeName: k.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...x(t)
});
class pe extends T {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== b.bigint)
      return this._getInvalidInput(e);
    let s;
    const n = new U();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (s = this._getOrReturnCtx(e, s), g(s, {
        code: m.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), n.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (s = this._getOrReturnCtx(e, s), g(s, {
        code: m.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), n.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (s = this._getOrReturnCtx(e, s), g(s, {
        code: m.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), n.dirty()) : S.assertNever(a);
    return { status: n.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return g(r, {
      code: m.invalid_type,
      expected: b.bigint,
      received: r.parsedType
    }), $;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, q.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, q.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, q.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, q.toString(r));
  }
  setLimit(e, r, s, n) {
    return new pe({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: s,
          message: q.toString(n)
        }
      ]
    });
  }
  _addCheck(e) {
    return new pe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: q.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: q.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: q.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: q.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: q.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
pe.create = (t) => new pe({
  checks: [],
  typeName: k.ZodBigInt,
  coerce: (t == null ? void 0 : t.coerce) ?? !1,
  ...x(t)
});
class bt extends T {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== b.boolean) {
      const s = this._getOrReturnCtx(e);
      return g(s, {
        code: m.invalid_type,
        expected: b.boolean,
        received: s.parsedType
      }), $;
    }
    return H(e.data);
  }
}
bt.create = (t) => new bt({
  typeName: k.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...x(t)
});
class Se extends T {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== b.date) {
      const a = this._getOrReturnCtx(e);
      return g(a, {
        code: m.invalid_type,
        expected: b.date,
        received: a.parsedType
      }), $;
    }
    if (Number.isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return g(a, {
        code: m.invalid_date
      }), $;
    }
    const s = new U();
    let n;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (n = this._getOrReturnCtx(e, n), g(n, {
        code: m.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), s.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (n = this._getOrReturnCtx(e, n), g(n, {
        code: m.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), s.dirty()) : S.assertNever(a);
    return {
      status: s.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Se({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: q.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: q.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
}
Se.create = (t) => new Se({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: k.ZodDate,
  ...x(t)
});
class qt extends T {
  _parse(e) {
    if (this._getType(e) !== b.symbol) {
      const s = this._getOrReturnCtx(e);
      return g(s, {
        code: m.invalid_type,
        expected: b.symbol,
        received: s.parsedType
      }), $;
    }
    return H(e.data);
  }
}
qt.create = (t) => new qt({
  typeName: k.ZodSymbol,
  ...x(t)
});
class wt extends T {
  _parse(e) {
    if (this._getType(e) !== b.undefined) {
      const s = this._getOrReturnCtx(e);
      return g(s, {
        code: m.invalid_type,
        expected: b.undefined,
        received: s.parsedType
      }), $;
    }
    return H(e.data);
  }
}
wt.create = (t) => new wt({
  typeName: k.ZodUndefined,
  ...x(t)
});
class kt extends T {
  _parse(e) {
    if (this._getType(e) !== b.null) {
      const s = this._getOrReturnCtx(e);
      return g(s, {
        code: m.invalid_type,
        expected: b.null,
        received: s.parsedType
      }), $;
    }
    return H(e.data);
  }
}
kt.create = (t) => new kt({
  typeName: k.ZodNull,
  ...x(t)
});
class $t extends T {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return H(e.data);
  }
}
$t.create = (t) => new $t({
  typeName: k.ZodAny,
  ...x(t)
});
class It extends T {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return H(e.data);
  }
}
It.create = (t) => new It({
  typeName: k.ZodUnknown,
  ...x(t)
});
class ne extends T {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return g(r, {
      code: m.invalid_type,
      expected: b.never,
      received: r.parsedType
    }), $;
  }
}
ne.create = (t) => new ne({
  typeName: k.ZodNever,
  ...x(t)
});
class xt extends T {
  _parse(e) {
    if (this._getType(e) !== b.undefined) {
      const s = this._getOrReturnCtx(e);
      return g(s, {
        code: m.invalid_type,
        expected: b.void,
        received: s.parsedType
      }), $;
    }
    return H(e.data);
  }
}
xt.create = (t) => new xt({
  typeName: k.ZodVoid,
  ...x(t)
});
class W extends T {
  _parse(e) {
    const { ctx: r, status: s } = this._processInputParams(e), n = this._def;
    if (r.parsedType !== b.array)
      return g(r, {
        code: m.invalid_type,
        expected: b.array,
        received: r.parsedType
      }), $;
    if (n.exactLength !== null) {
      const i = r.data.length > n.exactLength.value, o = r.data.length < n.exactLength.value;
      (i || o) && (g(r, {
        code: i ? m.too_big : m.too_small,
        minimum: o ? n.exactLength.value : void 0,
        maximum: i ? n.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: n.exactLength.message
      }), s.dirty());
    }
    if (n.minLength !== null && r.data.length < n.minLength.value && (g(r, {
      code: m.too_small,
      minimum: n.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: n.minLength.message
    }), s.dirty()), n.maxLength !== null && r.data.length > n.maxLength.value && (g(r, {
      code: m.too_big,
      maximum: n.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: n.maxLength.message
    }), s.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => n.type._parseAsync(new G(r, i, r.path, o)))).then((i) => U.mergeArray(s, i));
    const a = [...r.data].map((i, o) => n.type._parseSync(new G(r, i, r.path, o)));
    return U.mergeArray(s, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new W({
      ...this._def,
      minLength: { value: e, message: q.toString(r) }
    });
  }
  max(e, r) {
    return new W({
      ...this._def,
      maxLength: { value: e, message: q.toString(r) }
    });
  }
  length(e, r) {
    return new W({
      ...this._def,
      exactLength: { value: e, message: q.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
W.create = (t, e) => new W({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: k.ZodArray,
  ...x(e)
});
function he(t) {
  if (t instanceof O) {
    const e = {};
    for (const r in t.shape) {
      const s = t.shape[r];
      e[r] = re.create(he(s));
    }
    return new O({
      ...t._def,
      shape: () => e
    });
  } else
    return t instanceof W ? new W({
      ...t._def,
      type: he(t.element)
    }) : t instanceof re ? re.create(he(t.unwrap())) : t instanceof _e ? _e.create(he(t.unwrap())) : t instanceof ue ? ue.create(t.items.map((e) => he(e))) : t;
}
class O extends T {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = S.objectKeys(e);
    return this._cached = { shape: e, keys: r }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== b.object) {
      const u = this._getOrReturnCtx(e);
      return g(u, {
        code: m.invalid_type,
        expected: b.object,
        received: u.parsedType
      }), $;
    }
    const { status: s, ctx: n } = this._processInputParams(e), { shape: a, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof ne && this._def.unknownKeys === "strip"))
      for (const u in n.data)
        i.includes(u) || o.push(u);
    const d = [];
    for (const u of i) {
      const c = a[u], f = n.data[u];
      d.push({
        key: { status: "valid", value: u },
        value: c._parse(new G(n, f, n.path, u)),
        alwaysSet: u in n.data
      });
    }
    if (this._def.catchall instanceof ne) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const c of o)
          d.push({
            key: { status: "valid", value: c },
            value: { status: "valid", value: n.data[c] }
          });
      else if (u === "strict")
        o.length > 0 && (g(n, {
          code: m.unrecognized_keys,
          keys: o
        }), s.dirty());
      else if (u !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const c of o) {
        const f = n.data[c];
        d.push({
          key: { status: "valid", value: c },
          value: u._parse(
            new G(n, f, n.path, c)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: c in n.data
        });
      }
    }
    return n.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const c of d) {
        const f = await c.key, h = await c.value;
        u.push({
          key: f,
          value: h,
          alwaysSet: c.alwaysSet
        });
      }
      return u;
    }).then((u) => U.mergeObjectSync(s, u)) : U.mergeObjectSync(s, d);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return q.errToObj, new O({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, s) => {
          var a, i;
          const n = ((i = (a = this._def).errorMap) == null ? void 0 : i.call(a, r, s).message) ?? s.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: q.errToObj(e).message ?? n
          } : {
            message: n
          };
        }
      } : {}
    });
  }
  strip() {
    return new O({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new O({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new O({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new O({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: k.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new O({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    for (const s of S.objectKeys(e))
      e[s] && this.shape[s] && (r[s] = this.shape[s]);
    return new O({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    for (const s of S.objectKeys(this.shape))
      e[s] || (r[s] = this.shape[s]);
    return new O({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return he(this);
  }
  partial(e) {
    const r = {};
    for (const s of S.objectKeys(this.shape)) {
      const n = this.shape[s];
      e && !e[s] ? r[s] = n : r[s] = n.optional();
    }
    return new O({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    for (const s of S.objectKeys(this.shape))
      if (e && !e[s])
        r[s] = this.shape[s];
      else {
        let a = this.shape[s];
        for (; a instanceof re; )
          a = a._def.innerType;
        r[s] = a;
      }
    return new O({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return as(S.objectKeys(this.shape));
  }
}
O.create = (t, e) => new O({
  shape: () => t,
  unknownKeys: "strip",
  catchall: ne.create(),
  typeName: k.ZodObject,
  ...x(e)
});
O.strictCreate = (t, e) => new O({
  shape: () => t,
  unknownKeys: "strict",
  catchall: ne.create(),
  typeName: k.ZodObject,
  ...x(e)
});
O.lazycreate = (t, e) => new O({
  shape: t,
  unknownKeys: "strip",
  catchall: ne.create(),
  typeName: k.ZodObject,
  ...x(e)
});
class Me extends T {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), s = this._def.options;
    function n(a) {
      for (const o of a)
        if (o.result.status === "valid")
          return o.result;
      for (const o of a)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = a.map((o) => new X(o.ctx.common.issues));
      return g(r, {
        code: m.invalid_union,
        unionErrors: i
      }), $;
    }
    if (r.common.async)
      return Promise.all(s.map(async (a) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(n);
    {
      let a;
      const i = [];
      for (const d of s) {
        const u = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, c = d._parseSync({
          data: r.data,
          path: r.path,
          parent: u
        });
        if (c.status === "valid")
          return c;
        c.status === "dirty" && !a && (a = { result: c, ctx: u }), u.common.issues.length && i.push(u.common.issues);
      }
      if (a)
        return r.common.issues.push(...a.ctx.common.issues), a.result;
      const o = i.map((d) => new X(d));
      return g(r, {
        code: m.invalid_union,
        unionErrors: o
      }), $;
    }
  }
  get options() {
    return this._def.options;
  }
}
Me.create = (t, e) => new Me({
  options: t,
  typeName: k.ZodUnion,
  ...x(e)
});
function Tt(t, e) {
  const r = Y(t), s = Y(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === b.object && s === b.object) {
    const n = S.objectKeys(e), a = S.objectKeys(t).filter((o) => n.indexOf(o) !== -1), i = { ...t, ...e };
    for (const o of a) {
      const d = Tt(t[o], e[o]);
      if (!d.valid)
        return { valid: !1 };
      i[o] = d.data;
    }
    return { valid: !0, data: i };
  } else if (r === b.array && s === b.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const n = [];
    for (let a = 0; a < t.length; a++) {
      const i = t[a], o = e[a], d = Tt(i, o);
      if (!d.valid)
        return { valid: !1 };
      n.push(d.data);
    }
    return { valid: !0, data: n };
  } else
    return r === b.date && s === b.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class ze extends T {
  _parse(e) {
    const { status: r, ctx: s } = this._processInputParams(e), n = (a, i) => {
      if (br(a) || br(i))
        return $;
      const o = Tt(a.value, i.value);
      return o.valid ? ((qr(a) || qr(i)) && r.dirty(), { status: r.value, value: o.data }) : (g(s, {
        code: m.invalid_intersection_types
      }), $);
    };
    return s.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: s.data,
        path: s.path,
        parent: s
      }),
      this._def.right._parseAsync({
        data: s.data,
        path: s.path,
        parent: s
      })
    ]).then(([a, i]) => n(a, i)) : n(this._def.left._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }), this._def.right._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }));
  }
}
ze.create = (t, e, r) => new ze({
  left: t,
  right: e,
  typeName: k.ZodIntersection,
  ...x(r)
});
class ue extends T {
  _parse(e) {
    const { status: r, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== b.array)
      return g(s, {
        code: m.invalid_type,
        expected: b.array,
        received: s.parsedType
      }), $;
    if (s.data.length < this._def.items.length)
      return g(s, {
        code: m.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), $;
    !this._def.rest && s.data.length > this._def.items.length && (g(s, {
      code: m.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const a = [...s.data].map((i, o) => {
      const d = this._def.items[o] || this._def.rest;
      return d ? d._parse(new G(s, i, s.path, o)) : null;
    }).filter((i) => !!i);
    return s.common.async ? Promise.all(a).then((i) => U.mergeArray(r, i)) : U.mergeArray(r, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new ue({
      ...this._def,
      rest: e
    });
  }
}
ue.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ue({
    items: t,
    typeName: k.ZodTuple,
    rest: null,
    ...x(e)
  });
};
class Ve extends T {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== b.object)
      return g(s, {
        code: m.invalid_type,
        expected: b.object,
        received: s.parsedType
      }), $;
    const n = [], a = this._def.keyType, i = this._def.valueType;
    for (const o in s.data)
      n.push({
        key: a._parse(new G(s, o, s.path, o)),
        value: i._parse(new G(s, s.data[o], s.path, o)),
        alwaysSet: o in s.data
      });
    return s.common.async ? U.mergeObjectAsync(r, n) : U.mergeObjectSync(r, n);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, s) {
    return r instanceof T ? new Ve({
      keyType: e,
      valueType: r,
      typeName: k.ZodRecord,
      ...x(s)
    }) : new Ve({
      keyType: K.create(),
      valueType: e,
      typeName: k.ZodRecord,
      ...x(r)
    });
  }
}
class St extends T {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== b.map)
      return g(s, {
        code: m.invalid_type,
        expected: b.map,
        received: s.parsedType
      }), $;
    const n = this._def.keyType, a = this._def.valueType, i = [...s.data.entries()].map(([o, d], u) => ({
      key: n._parse(new G(s, o, s.path, [u, "key"])),
      value: a._parse(new G(s, d, s.path, [u, "value"]))
    }));
    if (s.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const d of i) {
          const u = await d.key, c = await d.value;
          if (u.status === "aborted" || c.status === "aborted")
            return $;
          (u.status === "dirty" || c.status === "dirty") && r.dirty(), o.set(u.value, c.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const d of i) {
        const u = d.key, c = d.value;
        if (u.status === "aborted" || c.status === "aborted")
          return $;
        (u.status === "dirty" || c.status === "dirty") && r.dirty(), o.set(u.value, c.value);
      }
      return { status: r.value, value: o };
    }
  }
}
St.create = (t, e, r) => new St({
  valueType: e,
  keyType: t,
  typeName: k.ZodMap,
  ...x(r)
});
class ge extends T {
  _parse(e) {
    const { status: r, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== b.set)
      return g(s, {
        code: m.invalid_type,
        expected: b.set,
        received: s.parsedType
      }), $;
    const n = this._def;
    n.minSize !== null && s.data.size < n.minSize.value && (g(s, {
      code: m.too_small,
      minimum: n.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: n.minSize.message
    }), r.dirty()), n.maxSize !== null && s.data.size > n.maxSize.value && (g(s, {
      code: m.too_big,
      maximum: n.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: n.maxSize.message
    }), r.dirty());
    const a = this._def.valueType;
    function i(d) {
      const u = /* @__PURE__ */ new Set();
      for (const c of d) {
        if (c.status === "aborted")
          return $;
        c.status === "dirty" && r.dirty(), u.add(c.value);
      }
      return { status: r.value, value: u };
    }
    const o = [...s.data.values()].map((d, u) => a._parse(new G(s, d, s.path, u)));
    return s.common.async ? Promise.all(o).then((d) => i(d)) : i(o);
  }
  min(e, r) {
    return new ge({
      ...this._def,
      minSize: { value: e, message: q.toString(r) }
    });
  }
  max(e, r) {
    return new ge({
      ...this._def,
      maxSize: { value: e, message: q.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
ge.create = (t, e) => new ge({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: k.ZodSet,
  ...x(e)
});
class At extends T {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
At.create = (t, e) => new At({
  getter: t,
  typeName: k.ZodLazy,
  ...x(e)
});
class Rt extends T {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return g(r, {
        received: r.data,
        code: m.invalid_literal,
        expected: this._def.value
      }), $;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Rt.create = (t, e) => new Rt({
  value: t,
  typeName: k.ZodLiteral,
  ...x(e)
});
function as(t, e) {
  return new ve({
    values: t,
    typeName: k.ZodEnum,
    ...x(e)
  });
}
class ve extends T {
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), s = this._def.values;
      return g(r, {
        expected: S.joinValues(s),
        received: r.parsedType,
        code: m.invalid_type
      }), $;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const r = this._getOrReturnCtx(e), s = this._def.values;
      return g(r, {
        received: r.data,
        code: m.invalid_enum_value,
        options: s
      }), $;
    }
    return H(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return ve.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return ve.create(this.options.filter((s) => !e.includes(s)), {
      ...this._def,
      ...r
    });
  }
}
ve.create = as;
class Et extends T {
  _parse(e) {
    const r = S.getValidEnumValues(this._def.values), s = this._getOrReturnCtx(e);
    if (s.parsedType !== b.string && s.parsedType !== b.number) {
      const n = S.objectValues(r);
      return g(s, {
        expected: S.joinValues(n),
        received: s.parsedType,
        code: m.invalid_type
      }), $;
    }
    if (this._cache || (this._cache = new Set(S.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const n = S.objectValues(r);
      return g(s, {
        received: s.data,
        code: m.invalid_enum_value,
        options: n
      }), $;
    }
    return H(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Et.create = (t, e) => new Et({
  values: t,
  typeName: k.ZodNativeEnum,
  ...x(e)
});
class Ze extends T {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== b.promise && r.common.async === !1)
      return g(r, {
        code: m.invalid_type,
        expected: b.promise,
        received: r.parsedType
      }), $;
    const s = r.parsedType === b.promise ? r.data : Promise.resolve(r.data);
    return H(s.then((n) => this._def.type.parseAsync(n, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
Ze.create = (t, e) => new Ze({
  type: t,
  typeName: k.ZodPromise,
  ...x(e)
});
class ae extends T {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === k.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: s } = this._processInputParams(e), n = this._def.effect || null, a = {
      addIssue: (i) => {
        g(s, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return s.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), n.type === "preprocess") {
      const i = n.transform(s.data, a);
      if (s.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (r.value === "aborted")
            return $;
          const d = await this._def.schema._parseAsync({
            data: o,
            path: s.path,
            parent: s
          });
          return d.status === "aborted" ? $ : d.status === "dirty" || r.value === "dirty" ? Ie(d.value) : d;
        });
      {
        if (r.value === "aborted")
          return $;
        const o = this._def.schema._parseSync({
          data: i,
          path: s.path,
          parent: s
        });
        return o.status === "aborted" ? $ : o.status === "dirty" || r.value === "dirty" ? Ie(o.value) : o;
      }
    }
    if (n.type === "refinement") {
      const i = (o) => {
        const d = n.refinement(o, a);
        if (s.common.async)
          return Promise.resolve(d);
        if (d instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (s.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: s.data,
          path: s.path,
          parent: s
        });
        return o.status === "aborted" ? $ : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((o) => o.status === "aborted" ? $ : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (n.type === "transform")
      if (s.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: s.data,
          path: s.path,
          parent: s
        });
        if (!ye(i))
          return $;
        const o = n.transform(i.value, a);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((i) => ye(i) ? Promise.resolve(n.transform(i.value, a)).then((o) => ({
          status: r.value,
          value: o
        })) : $);
    S.assertNever(n);
  }
}
ae.create = (t, e, r) => new ae({
  schema: t,
  typeName: k.ZodEffects,
  effect: e,
  ...x(r)
});
ae.createWithPreprocess = (t, e, r) => new ae({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: k.ZodEffects,
  ...x(r)
});
class re extends T {
  _parse(e) {
    return this._getType(e) === b.undefined ? H(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
re.create = (t, e) => new re({
  innerType: t,
  typeName: k.ZodOptional,
  ...x(e)
});
class _e extends T {
  _parse(e) {
    return this._getType(e) === b.null ? H(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
_e.create = (t, e) => new _e({
  innerType: t,
  typeName: k.ZodNullable,
  ...x(e)
});
class Ct extends T {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let s = r.data;
    return r.parsedType === b.undefined && (s = this._def.defaultValue()), this._def.innerType._parse({
      data: s,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Ct.create = (t, e) => new Ct({
  innerType: t,
  typeName: k.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...x(e)
});
class Ot extends T {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), s = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, n = this._def.innerType._parse({
      data: s.data,
      path: s.path,
      parent: {
        ...s
      }
    });
    return Fe(n) ? n.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new X(s.common.issues);
        },
        input: s.data
      })
    })) : {
      status: "valid",
      value: n.status === "valid" ? n.value : this._def.catchValue({
        get error() {
          return new X(s.common.issues);
        },
        input: s.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Ot.create = (t, e) => new Ot({
  innerType: t,
  typeName: k.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...x(e)
});
class Pt extends T {
  _parse(e) {
    if (this._getType(e) !== b.nan) {
      const s = this._getOrReturnCtx(e);
      return g(s, {
        code: m.invalid_type,
        expected: b.nan,
        received: s.parsedType
      }), $;
    }
    return { status: "valid", value: e.data };
  }
}
Pt.create = (t) => new Pt({
  typeName: k.ZodNaN,
  ...x(t)
});
class Ni extends T {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), s = r.data;
    return this._def.type._parse({
      data: s,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class zt extends T {
  _parse(e) {
    const { status: r, ctx: s } = this._processInputParams(e);
    if (s.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: s.data,
          path: s.path,
          parent: s
        });
        return a.status === "aborted" ? $ : a.status === "dirty" ? (r.dirty(), Ie(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: s.path,
          parent: s
        });
      })();
    {
      const n = this._def.in._parseSync({
        data: s.data,
        path: s.path,
        parent: s
      });
      return n.status === "aborted" ? $ : n.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: n.value
      }) : this._def.out._parseSync({
        data: n.value,
        path: s.path,
        parent: s
      });
    }
  }
  static create(e, r) {
    return new zt({
      in: e,
      out: r,
      typeName: k.ZodPipeline
    });
  }
}
class Nt extends T {
  _parse(e) {
    const r = this._def.innerType._parse(e), s = (n) => (ye(n) && (n.value = Object.freeze(n.value)), n);
    return Fe(r) ? r.then((n) => s(n)) : s(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Nt.create = (t, e) => new Nt({
  innerType: t,
  typeName: k.ZodReadonly,
  ...x(e)
});
O.lazycreate;
var k;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(k || (k = {}));
const E = K.create, ee = me.create;
Pt.create;
pe.create;
const je = bt.create;
Se.create;
qt.create;
wt.create;
kt.create;
$t.create;
It.create;
ne.create;
xt.create;
const it = W.create, F = O.create;
O.strictCreate;
const Di = Me.create;
ze.create;
ue.create;
const is = Ve.create;
St.create;
ge.create;
At.create;
Rt.create;
ve.create;
Et.create;
Ze.create;
ae.create;
const ot = re.create;
_e.create;
ae.createWithPreprocess;
F({
  duration: ee(),
  email: E().email(),
  firstName: E(),
  formFields: ot(
    is(E(), Di([E(), ee(), je()]))
  ),
  guestEmails: ot(E().array()),
  lastName: E(),
  likelyAvailableUserIds: ot(E().array()),
  slug: E(),
  startTime: ee(),
  timezone: E().default("Europe/Paris")
});
const ji = F({
  linkAvailability: F({
    hasMore: je(),
    linkAvailabilityByDuration: is(
      E(),
      // Key is a string like "900000"
      F({
        meetingDurationMillis: ee().int(),
        availabilities: it(
          F({
            startMillisUtc: ee().int(),
            endMillisUtc: ee().int()
          })
        )
      })
    )
  }),
  allUsersBusyTimes: it(
    F({
      isOffline: je(),
      meetingsUser: F({
        id: E(),
        userId: E(),
        isSalesStarter: je(),
        userProfile: F({
          firstName: E(),
          lastName: E(),
          email: E(),
          fullName: E()
        }),
        calendarProvider: E()
      }),
      busyTimes: it(
        F({
          start: ee().int(),
          end: ee().int()
        })
      )
    })
  )
});
class cf {
  constructor(e) {
    this.provider = e, this.headers = {}, this.httpOptions = {}, this.httpClient = "", this.hubspotApiDomain = "", this.hubspotMeetingSchedulerToken = "", this.meetingSchedulerName = "", this.meetingSchedulerOrganizerId = "", this.querySchema = F({
      name: E().default(this.meetingSchedulerName),
      organizerId: E().default(this.meetingSchedulerOrganizerId),
      type: E().default("ROUND_ROBIN_CALENDAR")
    }), this.http = {}, this.hubspotApiDomain = this.provider.hubspotApiDomain, this.hubspotMeetingSchedulerToken = this.provider.hubspotMeetingSchedulerToken, this.meetingSchedulerName = this.provider.meetingSchedulerName, this.meetingSchedulerOrganizerId = this.provider.meetingSchedulerOrganizerId, this.querySchema = F({
      name: E().default(this.meetingSchedulerName),
      organizerId: E().default(this.meetingSchedulerOrganizerId),
      type: E().default("ROUND_ROBIN_CALENDAR")
    }), this.headers = {
      headers: {
        Authorization: `Token ${this.provider.hubspotMeetingSchedulerToken}`
      }
    }, this.http = this.setHttp(this.provider.httpClient);
  }
  setHttp(e) {
    const r = { name: "hubspot", url: this.hubspotApiDomain };
    return e === "axios" ? se({ api: r, unserialized: !0 }) : we({ api: r });
  }
  async postBooking(e) {
    const r = new URL(
      "/scheduler/v3/meetings/meeting-links/book",
      this.hubspotApiDomain
    );
    return await this.http.post(
      r.toString(),
      {
        ...e,
        formFields: [
          { name: "mobilephone", value: e.phone },
          { name: "message", value: e.message }
        ],
        duration: 9e5
      },
      {
        headers: {
          Authorization: `Bearer ${this.hubspotMeetingSchedulerToken}`
        }
      }
    );
  }
  async getMeetings() {
    return (await this.http.get(`${this.hubspotApiDomain}/scheduler/v3/meetings/meeting-links`, {
      headers: {
        Authorization: `Bearer ${this.hubspotMeetingSchedulerToken}`
      }
    })).data.results;
  }
  async getMeeting(e, r) {
    if (!e)
      throw new Error("Meeting ID is required");
    const s = new URL(
      `/scheduler/v3/meetings/meeting-links/book/${encodeURIComponent(e)}?timezone=${encodeURIComponent(r)}`,
      this.hubspotApiDomain
    );
    return await this.http.get(s.toString(), {
      headers: {
        Authorization: `Bearer ${this.hubspotMeetingSchedulerToken}`
      }
    });
  }
  async getAvailabilities(e, r, s = "0") {
    if (!e)
      throw new Error("Meeting Slug is required");
    const n = s ? `&monthOffset=${s}` : "", a = new URL(
      `/scheduler/v3/meetings/meeting-links/book/availability-page/${encodeURIComponent(e)}?timezone=${encodeURIComponent(r)}&montOffset=${n}`,
      this.hubspotApiDomain
    ), i = await this.http.get(a.toString(), {
      ...this.httpOptions,
      headers: {
        Authorization: `Bearer ${this.hubspotMeetingSchedulerToken}`
      }
    });
    return ji.safeParse(i.data).data;
  }
  async getAvailableDurations(e, r) {
    const s = await this.getAvailabilities(e, r);
    return Object.keys(
      (s == null ? void 0 : s.linkAvailability.linkAvailabilityByDuration) ?? {}
    ).map(Number);
  }
  async getComputedAvailabilities(e, r) {
    var n;
    return {
      availabilities: (((n = e.linkAvailability.linkAvailabilityByDuration[r.toString()]) == null ? void 0 : n.availabilities) ?? []).filter((a) => a.startMillisUtc > Date.now()).reduce(
        (a, i) => {
          const o = new Date(i.startMillisUtc), d = new Date(
            o.getFullYear(),
            o.getMonth(),
            o.getDate()
          ).getTime();
          return {
            ...a,
            [d]: [...a[d] ?? [], i.startMillisUtc]
          };
        },
        {}
      ),
      hasMore: e.linkAvailability.hasMore
    };
  }
  async getAllComputedAvailabilities(e) {
    var n;
    const r = {}, s = Object.keys(
      e.linkAvailability.linkAvailabilityByDuration || {}
    ).map((a) => parseInt(a));
    for (const a of s) {
      const i = (((n = e.linkAvailability.linkAvailabilityByDuration[a.toString()]) == null ? void 0 : n.availabilities) ?? []).filter((o) => o.startMillisUtc > Date.now()).reduce(
        (o, d) => {
          const u = new Date(d.startMillisUtc), c = new Date(
            u.getFullYear(),
            u.getMonth(),
            u.getDate()
          ).getTime();
          return o[c] || (o[c] = []), o[c].push(d.startMillisUtc), o;
        },
        {}
      );
      Object.entries(i).forEach(
        ([o, d]) => {
          const u = parseInt(o);
          r[u] || (r[u] = []), r[u] = [
            ...r[u],
            ...d
          ];
        }
      );
    }
    return r;
  }
  async getMeetingDates(e, r, s) {
    const n = await this.getAvailabilities(
      e,
      r,
      s
    );
    if (!n)
      return null;
    const a = {}, i = await this.getAllComputedAvailabilities(n);
    return Object.entries(i).forEach(
      ([u, c]) => {
        const f = parseInt(u);
        a[f] || (a[f] = []), a[f] = [
          ...a[f],
          ...c
        ];
      }
    ), {
      dates: Object.keys(a).map((u) => parseInt(u)).sort((u, c) => u - c).map((u) => {
        const c = new Date(u), f = c.getTimezoneOffset() * 6e4, h = c.getTime() - f;
        return new Date(h).toISOString();
      }),
      hasMore: n.linkAvailability.hasMore
    };
  }
  async getAvailabilitiesForDate(e, r, s) {
    const n = [], a = new Date(Date.now()), i = new Date(e), o = i.getMonth() - a.getMonth(), d = await this.getAvailabilities(
      r,
      s,
      o.toString()
    );
    if (!d)
      return null;
    const u = await this.getAllComputedAvailabilities(d);
    return Object.entries(u).forEach(
      ([c, f]) => {
        const h = new Date(Number(c));
        i.toDateString() === h.toDateString() && n.push(
          ...f.map(
            (p) => new Date(p).toISOString()
          )
        );
      }
    ), n;
  }
}
class uf {
  constructor(e) {
    this.provider = e, this.apiKey = "", this.http = {}, this.apiUrl = "", this.apiKey = this.provider.apiKey, this.apiUrl = this.provider.apiUrl, this.http = this.setHttp(this.provider.httpClientType);
  }
  setHttp(e) {
    const r = { name: "ipLocation", url: this.apiUrl };
    return e === "axios" ? se({ api: r, unserialized: !0 }) : we({ api: r });
  }
  async getUserLocation() {
    var r, s, n, a, i, o, d, u, c, f, h, p, y, v;
    const e = await this.http.get(`?key=${this.apiKey}`).then(
      (_) => typeof _.data == "object" ? _ : { data: _ }
    ).catch(console.error);
    if (e != null && e.data)
      return {
        location: {
          countryCode: (n = (s = (r = e.data) == null ? void 0 : r.location) == null ? void 0 : s.country) == null ? void 0 : n.code,
          country: (o = (i = (a = e.data) == null ? void 0 : a.location) == null ? void 0 : i.country) == null ? void 0 : o.name,
          city: (u = (d = e.data) == null ? void 0 : d.location) == null ? void 0 : u.city,
          postal: (f = (c = e.data) == null ? void 0 : c.location) == null ? void 0 : f.postal
        },
        currency: (p = (h = e.data) == null ? void 0 : h.currency) == null ? void 0 : p.code,
        timezone: (v = (y = e.data) == null ? void 0 : y.time_zone) == null ? void 0 : v.id
      };
  }
}
class Ui {
  constructor(e) {
    this.httpOptions = {}, this.http = {}, this.apiUrl = "", this.httpOptions = {
      headers: { Authorization: e.apiKey }
    }, this.apiUrl = e.apiUrl;
    const r = { name: "sharegroop", url: this.apiUrl };
    this.http = e.httpClientType === "axios" ? se({ api: r, unserialized: !0 }) : we({ api: r });
  }
  async getOrderById(e) {
    return (await this.http.get(`v1/orders/${e}`, this.httpOptions)).data;
  }
}
Ui.SUCCESSFUL_STATUSES = [
  "completed",
  "confirmed",
  "pendingCommit"
];
const Li = (t) => ({
  query: (e) => {
    const r = w({
      filter: e.filters,
      includes: e.includes
    });
    return t.get(
      `v3/user/availability_requests/${e.availabilityRequestId}${r}`
    );
  }
}), Bi = (t) => ({
  query: (e) => t.put(
    `v3/user/availability_requests/${e.availabilityRequestId}`,
    { availability_request: { ...e } }
  )
}), Hi = (t) => ({
  query: (e) => {
    const r = w({
      filter: e.filters,
      includes: e.includes
    });
    return t.get(`v3/user/awaiting_user_actions${r}`);
  }
}), Fi = (t) => ({
  query: (e) => t.put(`v3/user/owner_nps/${e.id}`, e.body)
}), Mi = (t) => ({
  query: async (e) => {
    var d;
    if (typeof t.raw != "function")
      throw new Error("HttpClient does not implement the .raw method");
    const r = await t.raw(
      `v3/user/checks/${e.checkId}.pdf`,
      {
        responseType: "blob"
      }
    ), { headers: s, _data: n } = r;
    if (!n)
      throw new Error("noContent");
    const a = (d = s.get("content-disposition")) == null ? void 0 : d.toString(), [i, o] = (a == null ? void 0 : a.split("filename=")) ?? [];
    if (i != null && i.startsWith("attachment")) {
      const [u] = o.split(";").map((c) => c.replace(/"/g, ""));
      return [n, decodeURIComponent(u)];
    }
    throw new Error("noAttachment");
  }
}), zi = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.includes
    });
    return t.get(
      `v3/user/client_contracts/${e.clientContractId}${r}`
    );
  }
}), Vi = (t) => ({
  query: (e) => t.post(
    `v3/user/client_contracts/${e.clientContractId}/confirms`,
    {
      contract: {
        approved_by_client_at: (/* @__PURE__ */ new Date()).toISOString()
      }
    }
  )
}), Zi = (t) => ({
  query: (e, r) => {
    const s = w({
      includes: e.includes
    });
    return t.put(
      `v3/user/client_contracts/${e.clientContractId}${s}`,
      e.information,
      r
    );
  }
}), Wi = (t) => ({
  query: (e) => {
    const r = w({
      filter: e.filters,
      includes: e.includes
    }), s = r ? `${r}&type=${e.type}` : `?type=${e.type}`;
    return t.get(`v3/user/contracts${s}`);
  }
}), Gi = (t) => ({
  query: (e) => {
    const r = w({
      filter: e.filters,
      includes: e.includes
    });
    return t.get(
      `v3/user/contracts/${e.type}/${e.contractId}${r}`
    );
  }
}), Ji = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(
      `v3/user/contracts/${e.contractId}/guest_contacts${r}`
    );
  }
}), Ki = (t) => ({
  query: (e) => t.get(
    `v3/user/contracts/${e.type}/${e.contractId}.pdf`,
    { responseType: "arraybuffer" }
  )
}), Xi = (t) => ({
  query: (e) => t.delete(
    `v3/user/house_multi_inquiry_wishlists/${e.houseId}`
  )
}), Qi = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.included,
      filter: e.filters,
      pagination: e.paginate
    });
    return t.get(`v3/user/houses/${e.houseId}/bookings${r}`);
  }
}), Yi = (t) => ({
  query: (e) => t.post(
    `v3/user/houses/${e.houseId}/bookings/${e.bookingId}/owner_bookings/comments`,
    { comment: { content: e.comment } }
  )
}), eo = (t) => ({
  query: (e) => {
    const r = w({
      filter: e.filters,
      includes: e.includes,
      pagination: e.pagination
    });
    return t.get(`v3/user/houses/${e.houseId}/contracts${r}`);
  }
}), to = (t) => ({
  query: (e) => {
    const r = w({ filter: e.filters });
    return t.get(
      `v3/user/houses/${e.houseId}/signatory_owner_contracts${r}`
    );
  }
}), ro = (t) => ({
  query: (e) => t.get(
    `v3/user/houses/${e.houseId}/contracts/${e.contractId}/timeline_items`
  )
}), so = (t) => ({
  query: (e) => t.get(`v3/user/houses/${e.houseId}/contract_information`)
}), no = (t) => ({
  query: (e) => {
    const r = e.context === "company" ? "?context=company" : "";
    return t.put(
      `v3/user/houses/${e.houseId}/contract_information${r}`,
      e.formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  }
}), ao = (t) => ({
  query: (e) => t.post(
    `v3/user/houses/${e.houseId}/contracts/${e.contractId}/guest_contacts`,
    { guest_contact: e.guestContact }
  )
}), io = (t) => ({
  query: (e) => t.get(`v3/user/houses/${e.houseId}/dashboard_analytics`)
}), oo = (t) => ({
  query: (e) => t.get(`v3/user/houses/${e.houseId}/areas_equipments`)
}), co = (t) => ({
  query: (e) => t.get(`v3/user/houses/${e.houseId}/house_staffs`)
}), uo = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.included,
      filter: e.filter,
      pagination: e.paginate
    });
    return t.get(`v3/user/houses${r}`);
  }
}), lo = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(
      `v3/user/houses/${e.houseId}/stay_information${r}`
    );
  }
}), fo = (t) => ({
  query: (e) => t.get(
    `v3/user/houses/${e.houseId}/owner_tax_certificates.pdf?year=${e.year}`,
    { responseType: "arraybuffer" }
  )
}), ho = (t) => ({
  query: (e) => t.get(
    `v3/user/houses/${e.houseId}/owner_tax_certificate_available_years`
  )
}), yo = (t) => ({
  query: (e) => t.post(`v3/user/wishlists/${e.wishlistToken}/houses`, {
    wishlist: e.wishlist
  })
}), mo = (t) => ({
  query: () => t.get("v3/user/informations")
}), po = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      pagination: e.pagination
    });
    return t.get(`v3/user/wishlists/${e.wishlistToken}/houses${r}`);
  }
}), go = (t) => ({
  query: (e) => t.put("v3/user/informations", e)
}), vo = (t) => ({
  query: (e) => t.put("v1/user/informations", e)
}), _o = (t) => ({
  query: (e) => t.delete(
    `v3/user/wishlists/${e.wishlistToken}/houses/${e.wishlist.house_id}`
  )
}), bo = (t) => ({
  query: (e) => t.put(`v3/users/${e.userId}`, { user: { ...e.user } })
}), qo = (t) => ({
  query: (e) => t.get(
    `v3/user/multi_inquiry_wishlist_availabilities?private_token=${e.privateToken}&check_in=${e.checkIn}&check_out=${e.checkOut}`
  )
}), wo = (t) => ({
  query: (e) => t.post("v3/user/multi_inquiry_wishlists", {
    multi_inquiry_wishlist: { ...e }
  })
}), ko = (t) => ({
  query: (e) => t.delete(
    `v3/user/multi_inquiry_wishlists/${e.wishlistToken}`
  )
}), $o = (t) => ({
  query: (e) => t.get(`v3/user/multi_inquiry_wishlists/${e.wishlistToken}`)
}), Io = (t) => ({
  query: () => t.get("v3/user/multi_inquiry_wishlists")
}), xo = (t) => ({
  query: (e) => t.put(
    `v3/user/multi_inquiry_wishlists/${e.wishlistToken}`,
    { multi_inquiry_wishlist: { ...e } }
  )
}), To = (t) => ({
  query: (e) => {
    const r = w({
      filter: e.filters,
      includes: e.includes
    });
    return t.get(`v3/user/owner_contracts/${e.contractId}${r}`);
  }
}), So = (t) => ({
  query: (e) => t.post(`v3/user/owner_contracts/${e.contractId}/confirms`, {
    contract: { approved_by_owner_at: e.contract.approved_by_owner_at },
    owner_general_rental_condition_signed: e.owner_general_rental_condition_signed
  })
}), Ao = (t) => ({
  modifyUser: bo(t).query,
  auth: {
    emailSignUp: os(t).query,
    finishSignUp: ls(t).query,
    phoneSignIn: cs(t).query,
    tokenSignIn: us(t).query,
    tokenSignUp: ds(t).query
  },
  automaticProposal: {
    automaticProposalComments: {
      createAutomaticProposalComment: fs(t).query,
      modifyAutomaticProposalComment: hs(t).query
    }
  },
  availabilityRequest: {
    getAvailabilityRequestById: Li(t).query,
    modifyAvailabilityRequest: Bi(t).query
  },
  awaitingActions: {
    getAwaitingActions: Hi(t).query,
    updateOwnerNps: Fi(t).query
  },
  checks: {
    downloadCheckPdf: Mi(t).query
  },
  clientContracts: {
    getClientContract: zi(t).query,
    confirmClientContract: Vi(t).query,
    sendClientContractInformation: Zi(t).query
  },
  contracts: {
    getContractsByType: Wi(t).query,
    getContractsById: Gi(t).query,
    getContractPdf: Ki(t).query,
    getGuestContracts: Ji(t).query
  },
  houses: {
    getAreasEquipments: oo(t).query,
    getHouses: uo(t).query,
    getHouseContacts: co(t).query,
    bookings: {
      getBookings: Qi(t).query,
      owner: {
        addComment: Yi(t).query
      }
    },
    getStayInformation: lo(t).query,
    contracts: {
      addGuestContacts: ao(t).query,
      getHouseContracts: eo(t).query,
      modifyContractInformation: no(t).query,
      getContractInformation: so(t).query,
      getPaymentTimeline: ro(t).query,
      getSignatoryOwnerContracts: to(t).query
    },
    dashboardAnalytics: {
      getDashboardAnalytics: io(t).query
    },
    taxCertificates: {
      getOwnerTaxCertificateById: fo(t).query,
      getOwnerTaxCertificateAvailableYears: ho(t).query
    }
  },
  information: {
    addHouseToUserWishlist: yo(t).query,
    getUserInfo: mo(t).query,
    getUserWishlist: po(t).query,
    modifyUserInfo: go(t).query,
    oldModifyUserInfo: vo(t).query,
    removeHouseToUserWishlist: _o(t).query
  },
  multiInquiryWishlistAvailabilities: {
    getWishlistAvailability: qo(t).query
  },
  multiInquiryWishlists: {
    createWishlist: wo(t).query,
    deleteWishlist: ko(t).query,
    getWishlist: $o(t).query,
    getWishlists: Io(t).query,
    modifyWishlist: xo(t).query
  },
  houseMultiInquiryWishlists: {
    deleteHouseWishlist: Xi(t).query
  },
  ownerContracts: {
    getOwnerContractById: To(t).query,
    confirmOwnerContractById: So(t).query
  }
}), Ro = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include
    });
    return t.get(
      `v3/automatic_proposals${r}&private_token=${e.privateToken}`
    );
  }
}), Eo = (t) => ({
  getAutomaticProposals: Ro(t).query
}), Co = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(
      `v3/houses/${e.houseId}/area_groups/${e.areaGroupId}/areas${r}&page=all`
    );
  }
}), Oo = (t) => ({
  query: (e) => t.get(
    `v1/houses/${e.houseId}/bookings?private_token=${e.privateToken}&start_date=${e.startAt}&end_date=${e.endAt}&page=1&per=50`
  )
}), Po = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/destinations/${e.destinationId}${r}`);
  }
}), No = (t) => ({
  query: (e) => t.get(
    `v3/houses/${e.houseId}/areas_equipments${e.privateToken ? `?private_token=${e.privateToken}` : ""}`
  )
}), Do = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(
      `v3/houses/${e.houseId}${r}${e.privateToken ? `&private_token=${e.privateToken}` : ""}`
    );
  }
}), jo = (t) => ({
  query: (e) => t.get(
    `v3/houses/${e.houseId}/included_services`.concat(
      e.privateToken ? `?private_token=${e.privateToken}` : ""
    )
  )
}), Uo = (t) => ({
  query: (e) => t.get(
    `v3/houses/${e.houseId}/key_features${e.privateToken ? `?private_token=${e.privateToken}` : ""}`
  )
}), Lo = (t) => ({
  query: (e) => {
    const r = e.privateToken ? `?private_token=${e.privateToken}` : "";
    return t.get(`v3/houses/${e.houseId}/next_available_dates${r}`);
  }
}), Bo = (t) => ({
  query: (e) => t.get(
    `v3/houses/${e.houseId}/house_truth_links${e.privateToken ? `?private_token=${e.privateToken}` : ""}`
  )
}), Ho = (t) => ({
  query: (e) => {
    const r = w({
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(
      `v3/houses/${e.houseId}/photos${r}${e.privateToken ? `&private_token=${e.privateToken}` : ""}`
    );
  }
}), Fo = (t) => ({
  query: ({
    currency: e = "EUR",
    endDate: r,
    maxBudget: s = "1000000",
    minBudget: n = "0",
    page: a = "all",
    sortBy: i = "recommended",
    startDate: o,
    states: d,
    destinationIds: u,
    housesIds: c
  }) => {
    const f = d ? `&states[]=${d}` : "", h = u && u.length > 0 ? `&${u.map((y) => `destination_ids[]=${y}`).join("&")}` : "", p = c && c.length > 0 ? `&${c.map((y) => `house_ids[]=${y}`).join("&")}` : "";
    return t.get(
      `v3/ids/house_periods?currency=${e}&end_at=${r}&max_budget=${s}&min_budget=${n}&page=${a}&start_at=${o}&sort_by=${i}${f}${h}${p}`
    );
  }
}), Mo = (t) => ({
  query: ({
    currency: e = "EUR",
    endDate: r,
    maxBudget: s = "1000000",
    minBudget: n = "0",
    page: a = "all",
    sortBy: i = "recommended",
    startDate: o,
    houseIds: d,
    destinationIds: u = []
  }) => {
    const c = `&${d.map((f) => `house_ids[]=${f.toString()}`).concat(
      ...u.map((f) => `destination_ids[]=${f.toString()}`)
    ).join("&")}`;
    return t.get(
      `v1/house_periods?currency=${e}&end_at=${r}&max_budget=${s}&min_budget=${n}&page=${a}&start_at=${o}&sort_by=${i}${c}`
    );
  }
}), zo = (t) => ({
  query: (e) => t.get(
    `v3/houses/${e.houseId}/period_durations?private_token=${e.privateToken}&start_at=${e.startAt}&end_at=${e.endAt}&page=all`
  )
}), Vo = (t) => ({
  query: ({
    currency: e = "EUR",
    endDate: r,
    startDate: s,
    houseId: n
  }) => t.get(
    `v1/house_periods/${n}?currency=${e}&end_at=${r}&start_at=${s}`
  )
}), Zo = (t) => ({
  query: (e) => {
    const r = `?start_at=${e.startDate}&${e.destinationId.map((s) => `destination_ids[]=${s}`).join("&")}`;
    return t.get(`v3/period_durations/count_by_period_types${r}`);
  }
}), Wo = (t) => ({
  getDestinationById: Po(t).query,
  getHouseById: Do(t).query,
  getHouseIncludedServices: jo(t).query,
  getHouseTruthLinks: Bo(t).query,
  getHouseKeyFeatures: Uo(t).query,
  getPhotosByHouseId: Ho(t).query,
  getHouseAreaEquipments: No(t).query,
  areaGroups: {
    areas: {
      getHouseAreaGroupsAreas: Co(t).query
    }
  },
  bookings: {
    getBookingsByHouseId: Oo(t).query
  },
  periods: {
    getHousePeriodsIds: Fo(t).query,
    getHousePeriods: Mo(t).query,
    getHousePeriodsById: Vo(t).query,
    getPeriodDurations: zo(t).query,
    getCountByPeriodTypes: Zo(t).query,
    getHouseNextValidPeriod: Lo(t).query
  }
}), Go = (t) => ({
  query: (e) => t.post("v3/admin/admin_users", e)
}), Jo = (t) => ({
  query: (e) => t.get(`v3/admin/admin_users/${e.userId}`)
}), Ko = (t) => ({
  query: (e) => t.put(`v3/admin/admin_users/${e.userId}`, {
    admin_user: e.admin_user
  })
}), Xo = (t) => ({
  query: (e) => t.delete(`v3/admin/admin_users/${e.userId}`)
}), Qo = (t) => ({
  query: (e) => t.post(
    `v3/admin/admin_users/${e.adminUserId}/house_contacts`,
    { house_contact: e.house_contact }
  )
}), Yo = (t) => ({
  query: (e) => t.delete(
    `v3/admin/admin_users/${e.adminUserId}/house_contacts/${e.houseId}`
  )
}), ec = (t) => ({
  query: () => t.get("v3/admin/ad_partner_types")
}), tc = (t) => ({
  query: (e) => t.post(`v3/admin/areas/${e.areaId}/equipments`, e.payload)
}), rc = (t) => ({
  query: (e) => t.delete(
    `v3/admin/areas/${e.areaId}/equipments/${e.equipmentId}`
  )
}), sc = (t) => ({
  query: (e) => t.get(`v3/admin/areas/${e.areaId}/equipments`)
}), nc = (t) => ({
  query: (e) => t.put(
    `v3/admin/areas/${e.areaId}/equipments/${e.equipmentId}`,
    e.payload
  )
}), ac = (t) => ({
  query: () => t.get("v3/admin/area_types?page=all")
}), ic = (t) => ({
  query: (e) => {
    const r = e.attribute ? `/${e.attribute}` : "", s = w({
      filter: e.filter,
      includes: e.include,
      pagination: e.pagination
    });
    return t.get(`v3/admin/audits/${e.model}/${e.id}${r}${s}`);
  }
}), oc = (t) => ({
  query: (e) => t.post("v3/admin/auth/password", e)
}), cc = (t) => ({
  query: (e) => t.get(
    `v3/admin/auth/google_oauth2?access_token=${e.accessToken}&email=${e.email}`
  )
}), uc = (t) => ({
  query: (e) => t.put("v3/admin/auth/password", e)
}), dc = (t) => ({
  query: (e) => t.post("v3/admin/auth/sign_in", e)
}), lc = (t) => ({
  query: () => t.delete("v3/admin/auth/sign_out")
}), fc = (t) => ({
  query: () => t.get("v3/admin/auth/validate_token")
}), hc = (t) => ({
  query: (e) => t.put(`v3/admin/bank_exports/${e.id}/cancel`, {})
}), yc = (t) => ({
  query: (e) => t.put(
    `v3/admin/bank_exports/${e.id}/confirm`,
    e.formData,
    {
      headers: { "Content-Type": "multipart/form-data" }
    }
  )
}), mc = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter
    });
    return t.get(`v3/admin/bank_exports/${e.id}${r}`);
  }
}), pc = (t) => ({
  query: () => t.get("v3/admin/brands?page=all")
}), gc = (t) => ({
  query: () => t.get("v3/admin/cancelation_causes")
}), vc = (t) => ({
  query: (e) => t.put(`v3/admin/change_requests/${e.id}`, e.payload)
}), _c = (t) => ({
  query: (e) => t.post(
    `v3/admin/contracts/${e.contractId}/comments`,
    e.formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), bc = (t) => ({
  query: (e) => t.delete(
    `v3/admin/contracts/${e.contractId}/comments/${e.commentId}`
  )
}), qc = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/contracts/${e.contractId}/comments${r}`);
  }
}), wc = (t) => ({
  query: (e) => t.put(
    `v3/admin/contracts/${e.contractId}/comments/${e.commentId}`,
    e.formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), kc = (t) => ({
  query: (e) => t.post(
    `v3/admin/contracts/${e.contractId}/client_receipts`,
    { ...e.receipt },
    {
      headers: { "Content-Type": "multipart/form-data" },
      responseType: "blob"
    }
  )
}), $c = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(
      `v3/admin/contracts/${e.contractId}/client_receipts${r}`
    );
  }
}), Ic = (t) => ({
  query: async (e) => {
    const r = await t.get(
      `v3/admin/contracts/${e.contractId}/client_receipts/${e.receiptId}.pdf`,
      { responseType: "blob" }
    );
    return "data" in r ? r.data : r;
  }
}), xc = (t) => ({
  query: (e) => t.post(
    `v3/admin/contracts/${e.contractId}/owner_receipts`,
    { ...e.receipt },
    { responseType: "blob" }
  )
}), Tc = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(
      `v3/admin/contracts/${e.contractId}/owner_receipts${r}`
    );
  }
}), Sc = (t) => ({
  query: async (e) => {
    const r = await t.get(
      `v3/admin/contracts/${e.contractId}/owner_receipts/${e.receiptId}.pdf`,
      { responseType: "blob" }
    );
    return "data" in r ? r.data : r;
  }
}), Ac = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(
      `v3/admin/contracts/${e.contractId}/payment_transactions${r}`
    );
  }
}), Rc = (t) => ({
  query: (e) => t.put(
    `v3/admin/contracts/${e.contractId}/payment_transactions/${e.ptId}`,
    e.payment_transaction
  )
}), Ec = (t) => ({
  query: (e) => t.put(
    `v3/admin/contracts/${e.contractId}/payment_transactions/${e.ptId}`,
    { payment_transaction: e.payment_transaction }
  )
}), Cc = (t) => ({
  query: (e) => t.put(
    `v3/admin/contracts/${e.contractId}/manually_signed_client_contracts`,
    e.FormData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), Oc = (t) => ({
  query: (e) => t.put(
    `v3/admin/contracts/${e.contractId}/manually_signed_owner_contracts`,
    e.FormData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), Pc = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(
      `v3/admin/contracts/${e.contractId}/timeline_items${r}`
    );
  }
}), Nc = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/contracts/${e.contractId}${r}`);
  }
}), Dc = (t) => ({
  query: (e) => t.put(`v3/admin/contracts/${e.contractId}`, e.contract)
}), jc = (t) => ({
  query: (e) => t.put(
    `v3/admin/contracts/${e.contractId}/cancelation`,
    e.payload
  )
}), Uc = (t) => ({
  query: async (e) => {
    const r = await t.get(
      `v3/admin/contracts/${e.contractId}/signed_${e.contractVersion}_contract.pdf`,
      { responseType: "blob" }
    );
    return "data" in r ? r.data : r;
  }
}), Lc = (t) => ({
  query: (e) => t.put(`v3/admin/contracts/${e.contractId}`, e.formData, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}), Bc = (t) => ({
  query: (e) => t.post("v3/admin/credits", e.payload)
}), Hc = (t) => ({
  query: (e) => t.delete(`v3/admin/credits/${e.creditId}`)
}), Fc = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(`v3/admin/credits/${e.creditId}${r}`);
  }
}), Mc = (t) => ({
  query: (e) => t.put(`v3/admin/credits/${e.creditId}`, e.payload)
}), zc = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/destinations/${e.destinationId}${r}`);
  }
}), Vc = (t) => ({
  query: (e) => t.post("v3/admin/destinations", e)
}), Zc = (t) => ({
  query: (e) => t.post(`v3/admin/destinations/${e.destinationId}`, {
    ...e.destination
  })
}), Wc = (t) => ({
  query: (e) => t.delete(`v3/admin/destinations/${e.destinationId}`)
}), Gc = (t) => ({
  query: (e) => {
    const r = w({
      pagination: (e == null ? void 0 : e.pagination) ?? { page: "1", per: "100" }
    });
    return t.get(`v3/admin/experiences${r}`);
  }
}), Jc = (t) => ({
  query: (e) => {
    const r = w({
      pagination: e.pagination
    });
    return t.get(
      `v3/admin/destinations/${e.destinationId}/experiences${r}`
    );
  }
}), Kc = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/destination_trees${r}`);
  }
}), Xc = (t) => ({
  query: () => t.get("v3/admin/equipment_types?page=all")
}), Qc = (t) => ({
  query: () => t.get("v3/admin/event_types")
}), Yc = (t) => ({
  query: (e) => t.put(
    `v3/admin/expected_pay_outs/${e.expectedPayOutId}/assigns`,
    e.formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), eu = (t) => ({
  query: (e) => t.put(
    `v3/admin/expected_pay_outs/${e.expectedPayOutId}/credits/assigns`,
    { credit_ids: e.creditIds }
  )
}), tu = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(
      `v3/admin/expected_pay_outs/${e.expectedPayOutId}${r}`
    );
  }
}), ru = (t) => ({
  query: () => t.post("v3/admin/exports/figaro", {})
}), su = (t) => ({
  query: (e) => t.post("v3/admin/exports/incoming_payment_transactions", {
    ...e
  })
}), nu = (t) => ({
  query: (e) => t.post("v3/admin/exports/tourist_taxes", e.payload)
}), au = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/exports/figaro${r}`);
  }
}), iu = (t) => ({
  query: (e) => t.get(
    `v3/admin/exports/incoming_payment_transactions/${e.id}`,
    { responseType: "blob" }
  )
}), ou = (t) => ({
  query: (e) => t.get(`v3/admin/exports/pay_outs/${e.id}`, {
    responseType: "blob"
  })
}), cu = (t) => ({
  query: (e) => t.get(`v3/admin/exports/tourist_taxes/${e.id}`, {
    responseType: "blob"
  })
}), uu = (t) => ({
  query: (e) => t.post(
    `v3/admin/exports/incoming_payment_transactions/${e.id}`,
    { ...e.export }
  )
}), du = (t) => ({
  query: (e) => t.put(`v3/admin/exports/tourist_taxes/${e.id}`, e.payload)
}), lu = (t) => ({
  query: (e) => t.post("v3/admin/financial_reports/houses_vat_recoverys", e, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}), Vt = (t = "terms_of_services") => ["terms_of_services", "privacy_policy"].includes(t) ? t : `${t}_general_rental_conditions`, fu = (t) => ({
  query: ({
    type: e,
    ...r
  }) => t.post(`v3/admin/${Vt(e)}`, r)
}), hu = (t) => ({
  query: (e) => t.get(
    `v3/admin/${Vt(e.type)}?page=${e.page}`
  )
}), yu = (t) => ({
  query: (e) => t.get(
    `v3/admin/${Vt(e.type)}/${e.id}`
  )
}), mu = (t) => ({
  query: () => t.get("v3/admin/house_architectural_styles")
}), pu = (t) => ({
  query: () => t.get("v3/admin/house_categories")
}), gu = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/ad_partners`,
    e.payload
  )
}), vu = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}/areas`,
    e.payload
  )
}), _u = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/areas/${e.areaId}/duplicate_areas`,
    {
      area: e.area
    }
  )
}), bu = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/area_groups`,
    e.payload
  )
}), qu = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/calendar_import`,
    e.payload
  )
}), wu = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/stay_information/codes`,
    e.payload
  )
}), ku = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/places/${e.placeId}/distances`,
    { ...e.params }
  )
}), $u = (t) => ({
  query: (e) => t.post("v3/admin/houses", e)
}), Iu = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/house_truth_links`,
    e.payload
  )
}), xu = (t) => ({
  query: (e) => t.post(`v3/admin/houses/${e.houseId}/links`, e.payload)
}), Tu = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/period_durations`,
    e.payload
  )
}), Su = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/period_prices`,
    e.payload
  )
}), Au = (t) => ({
  query: (e) => t.delete(
    `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}/areas/${e.areaId}`
  )
}), Ru = (t) => ({
  query: (e) => t.delete(
    `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}`
  )
}), Eu = (t) => ({
  query: (e) => t.delete(`v3/admin/houses/${e.houseId}/calendar_import`)
}), Cu = (t) => ({
  query: (e) => t.delete(
    `v3/admin/houses/${e.houseId}/stay_information/codes/${e.codeId}`
  )
}), Ou = (t) => ({
  query: (e) => t.delete(
    `v3/admin/houses/${e.houseId}/house_truth_links/${e.houseTruthLinkId}`
  )
}), Pu = (t) => ({
  query: (e) => t.delete(`v3/admin/houses/${e.houseId}/links/${e.linkId}`)
}), Nu = (t) => ({
  query: (e) => t.get(`v3/admin/houses/${e.houseId}/ad_partners`)
}), Du = (t) => ({
  query: (e) => t.get(
    `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}/areas/${e.areaId}`
  )
}), ju = (t) => ({
  query: (e) => t.get(
    `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}`
  )
}), Uu = (t) => ({
  query: (e) => {
    var s;
    const r = w({ filter: (s = e == null ? void 0 : e.included) == null ? void 0 : s.filter });
    return t.get(`v3/admin/houses/${e.houseId}/area_groups${r}`);
  }
}), Lu = (t) => ({
  query: (e) => {
    var s, n;
    const r = w({
      filter: (s = e.included) == null ? void 0 : s.filter,
      pagination: (n = e == null ? void 0 : e.included) == null ? void 0 : n.pagination
    });
    return t.get(
      `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}/areas${r}`
    );
  }
}), Bu = (t) => ({
  query: (e) => t.get(`v3/admin/houses/${e.houseId}/calendar_import`)
}), Hu = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.included,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(
      `v3/admin/houses/${e.houseId}/signatory/credits${r}`
    );
  }
}), Fu = (t) => ({
  query: (e) => t.get(
    `v3/admin/houses/${e.houseId}/places/${e.placeId}/distances`
  )
}), Mu = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.included,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/houses/${e.houseId}${r}`);
  }
}), zu = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    if (e.houseIds.length > 0) {
      const s = `?ids=${e.houseIds.join(",")}`;
      return t.get(`v3/admin/houses${s}`, {
        ...e.params
      });
    }
    return t.get(`v3/admin/houses${r}`);
  }
}), Vu = (t) => ({
  query: (e) => t.get(`v3/admin/houses/${e.houseId}/house_truth_links`)
}), Zu = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/houses/${e.houseId}/period_durations${r}`);
  }
}), Wu = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/houses/${e.houseId}/period_prices${r}`);
  }
}), Gu = (t) => ({
  query: (e) => {
    var s, n, a;
    const r = w({
      filter: (s = e.included) == null ? void 0 : s.filter,
      includes: (n = e.included) == null ? void 0 : n.includes,
      pagination: (a = e.included) == null ? void 0 : a.pagination
    });
    return t.get(`v3/admin/houses/${e.houseId}/reviews${r}`);
  }
}), Ju = (t) => ({
  query: (e) => t.get(`v3/admin/houses/${e.houseId}/sale_information`)
}), Ku = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(`v3/admin/houses/${e.houseId}/stay_information${r}`);
  }
}), Xu = (t) => ({
  query: (e) => t.get(`v3/admin/houses/${e.houseId}/surrounding_information`)
}), Qu = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/ad_partners`,
    e.payload
  )
}), Yu = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}/areas/${e.areaId}`,
    e.payload
  )
}), ed = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}`,
    e.payload
  )
}), td = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/areas/${e.areaId}/area_photos`,
    {
      area: {
        area_photos_attributes: e.photoIds.map((r) => ({
          photo_id: r
        }))
      }
    }
  )
}), rd = (t) => ({
  query: (e) => t.put(`v3/admin/houses/${e.houseId}/automatic_offer`, {
    automatic_offer: e.automatic_offer
  })
}), sd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/calendar_import`,
    e.payload
  )
}), nd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/stay_information/codes/${e.codeId}`,
    e.payload
  )
}), ad = (t) => ({
  query: (e) => e.formData ? t.put(`v3/admin/houses/${e.houseId}`, e.formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }) : t.put(`v3/admin/houses/${e.houseId}`, {
    house: e.house
  })
}), id = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/house_truth_links/${e.houseTruthLinkId}`,
    e.payload
  )
}), od = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/links/${e.linkId}`,
    e.payload
  )
}), cd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/period_durations/${e.periodDurationId}`,
    e.payload
  )
}), ud = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/period_prices/${e.periodPriceId}`,
    e.payload
  )
}), dd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/reviews/${e.reviewId}`,
    e.payload
  )
}), ld = (t) => ({
  query: (e) => {
    const r = e.isFormData ? { "Content-Type": "multipart/form-data" } : void 0;
    return t.put(
      `v3/admin/houses/${e.houseId}/sale_information`,
      e.payload,
      { headers: r }
    );
  }
}), fd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/stay_information`,
    e.payload
  )
}), hd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/surrounding_information`,
    e.payload
  )
}), yd = (t) => ({
  query: (e) => t.delete(
    `v3/admin/houses/${e.houseId}/period_durations/${e.periodDurationId}`
  )
}), md = (t) => ({
  query: (e) => t.delete(
    `v3/admin/houses/${e.houseId}/period_prices/${e.periodPriceId}`
  )
}), pd = (t) => ({
  query: (e) => t.post("v3/admin/house_staffs", e.payload)
}), gd = (t) => ({
  query: (e) => t.put(
    `v3/admin/house_staffs/${e.houseStaffId}`,
    e.payload
  )
}), vd = (t) => ({
  query: (e) => t.delete(`v3/admin/house_staffs/${e.houseStaffId}`)
}), _d = (t) => ({
  query: () => t.get("v3/admin/house_styles")
}), bd = (t) => ({
  query: async (e) => {
    const r = await t.get(
      `v3/admin/hubspot/contracts/${e.contractVersion}_contracts/${e.contractId}.pdf`,
      { responseType: "blob" }
    );
    return "data" in r ? r.data : r;
  }
}), qd = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/included_services${r}`);
  }
}), wd = (t) => ({
  query: (e) => t.get(
    `v3/admin/owner_tax_certificates/${e.houseId}.pdf?year=${e.year}`,
    { responseType: "blob" }
  )
}), kd = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(`v3/admin/pay_ins/${e.payInId}${r}`);
  }
}), $d = (t) => ({
  query: (e) => t.post(`v3/admin/pay_ins/${e.payInId}/assigns`, e.params)
}), Id = (t) => ({
  query: () => t.get("v3/admin/payment_schedules")
}), xd = (t) => ({
  query: (e) => t.get(
    `v3/admin/payment_transactions/${e.paymentTransactionId}/pay_outs`
  )
}), Td = (t) => ({
  query: (e) => t.put(`v3/admin/photos/${e.photoId}`, {
    position: e.position,
    hidden: e.hidden
  })
}), Sd = (t) => ({
  query: (e) => t.delete(`v3/admin/photos/${e.photoId}`)
}), Ad = (t) => ({
  query: (e) => t.post(
    `v3/admin/places/${e.placeId}/destination_places`,
    e.payload
  )
}), Rd = (t) => ({
  query: (e) => t.post(
    `v3/admin/places/${e.placeId}/house_places`,
    e.payload
  )
}), Ed = (t) => ({
  query: (e) => t.post("v3/admin/places", e.payload)
}), Cd = (t) => ({
  query: (e) => t.get(`v3/admin/places/${e.placeId}`)
}), Od = (t) => ({
  query: (e) => t.put(`v3/admin/places/${e.placeId}`, e.payload)
}), Pd = (t) => ({
  query: (e) => t.delete(
    `v3/admin/places/${e.placeId}/destination_places/${e.destinationId}`
  )
}), Nd = (t) => ({
  query: (e) => t.delete(
    `v3/admin/places/${e.placeId}/house_places/${e.houseId}`
  )
}), Dd = (t) => ({
  query: (e) => t.delete(`v3/admin/places/${e.placeId}`)
}), jd = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/place_types${r}`);
  }
}), Ud = (t) => ({
  query: (e) => t.post("v3/admin/pools", e.payload)
}), Ld = (t) => ({
  query: (e) => t.get(`v3/admin/pools/${e.poolId}`)
}), Bd = (t) => ({
  query: (e) => t.get(`v3/admin/pools?ids=${e.poolIds.join()}`)
}), Hd = (t) => ({
  query: (e) => t.put(`v3/admin/pools/${e.poolId}`, e.payload)
}), Fd = (t) => ({
  query: () => t.get("v3/admin/subsidiaries")
}), Md = (t) => ({
  query: (e) => t.get(
    `v3/admin/tailor/contracts/${e.contractId}/appointments`
  )
}), zd = (t) => ({
  query: (e) => t.get(
    `v3/admin/tailor/contracts/${e.contractId}/appointments/${e.appointmentId}`
  )
}), Vd = (t) => ({
  query: () => t.get("v3/admin/themes")
}), Zd = (t) => ({
  query: (e) => t.post("v3/admin/users/invitation", e)
}), Wd = (t) => ({
  query: (e) => t.put(`v3/admin/users/${e.userId}/invitation`, {})
}), Gd = (t) => ({
  query: (e) => t.post("v3/admin/vouchers", e.payload)
}), Jd = (t) => ({
  query: (e) => t.post(
    `v3/admin/vouchers/${e.voucherId}/assigns`,
    e.params
  )
}), Kd = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(`v3/admin/vouchers/${e.voucherId}${r}`);
  }
}), Xd = (t) => ({
  query: (e) => t.put(`v3/admin/vouchers/${e.voucherId}`, e.payload)
}), Qd = (t) => ({
  query: (e) => t.delete(`v3/admin/vouchers/${e.voucherId}`)
}), Yd = (t) => ({
  adminUser: {
    createAdminUser: Go(t).query,
    getAdminUser: Jo(t).query,
    modifyAdminUser: Ko(t).query,
    removeAdminUser: Xo(t).query,
    houseContacts: {
      createHouseContact: Qo(t).query,
      removeHouseContact: Yo(t).query
    }
  },
  adPartnerType: {
    getAdPartnerTypes: ec(t).query
  },
  areaTypes: {
    getAreaTypes: ac(t).query
  },
  audits: {
    getAuditById: ic(t).query
  },
  auth: {
    forgotPassword: oc(t).query,
    googleSignIn: cc(t).query,
    resetPassword: uc(t).query,
    signIn: dc(t).query,
    signOut: lc(t).query,
    validateToken: fc(t).query
  },
  areas: {
    equipements: {
      createEquipement: tc(t).query,
      deleteEquipement: rc(t).query,
      getEquipements: sc(t).query,
      modifyEquipement: nc(t).query
    }
  },
  bankExports: {
    cancelBankExport: hc(t).query,
    confirmBankExport: yc(t).query,
    getBankExports: mc(t).query
  },
  brands: {
    getBrands: pc(t).query
  },
  cancelationCauses: {
    getCancelationCauses: gc(t).query
  },
  changeRequests: {
    modifyChangeRequest: vc(t).query
  },
  generalConditions: {
    createCondition: fu(t).query,
    getConditionById: yu(t).query,
    getConditions: hu(t).query
  },
  contracts: {
    cancelContract: jc(t).query,
    comments: {
      addComment: _c(t).query,
      deleteComment: bc(t).query,
      getComments: qc(t).query,
      modifyComment: wc(t).query
    },
    getContractById: Nc(t).query,
    getSignedContractPdf: Uc(t).query,
    manuallySignedContracts: {
      modifyClientContract: Cc(t).query,
      modifyOwnerContract: Oc(t).query
    },
    modifyContract: Dc(t).query,
    modifyClientInfo: Lc(t).query,
    receipts: {
      createClientReceiptByContractId: kc(t).query,
      createOwnerReceiptByContractId: xc(t).query,
      getClientReceipByContractId: $c(t).query,
      getClientReceiptPdf: Ic(t).query,
      getOwnerReceipByContractId: Tc(t).query,
      getOwnerReceiptPdf: Sc(t).query
    },
    paymentTransactions: {
      getPaymentTransactionByContractId: Ac(t).query,
      modifyPaymentTransaction: Rc(t).query,
      modifyPayOut: Ec(t).query
    },
    timeline: {
      getTimelineItemsByContractId: Pc(t).query
    }
  },
  credits: {
    createCredit: Bc(t).query,
    deleteCredit: Hc(t).query,
    getCredit: Fc(t).query,
    modifyCredit: Mc(t).query
  },
  destinations: {
    addDestination: Vc(t).query,
    experiences: {
      getDestinationExperiences: Jc(t).query,
      getExperiences: Gc(t).query
    },
    getDestinationById: zc(t).query,
    modifyDestination: Zc(t).query,
    removeDestination: Wc(t).query
  },
  destinationTree: {
    getTree: Kc(t).query
  },
  equipementTypes: {
    getEquipementTypes: Xc(t).query
  },
  eventTypes: {
    getEventTypes: Qc(t).query
  },
  expectedPayOuts: {
    approveExpectedPayOut: Yc(t).query,
    getExpectedPayOut: tu(t).query,
    credits: {
      assignCredits: eu(t).query
    }
  },
  exports: {
    figaro: {
      addExport: ru(t).query,
      getExport: au(t).query
    },
    incomingPaymentTransaction: {
      addExport: su(t).query,
      getIncomingPaymentTransaction: iu(t).query,
      modifyExport: uu(t).query
    },
    payOuts: {
      getPayOut: ou(t).query
    },
    touristTaxe: {
      addExport: nu(t).query,
      getTouristTax: cu(t).query,
      modifyExport: du(t).query
    }
  },
  financialReports: {
    sendHousesVatRecovery: lu(t).query
  },
  houseArchitecturalStyles: {
    getArchitecturalStyles: mu(t).query
  },
  houses: {
    adPartners: {
      addAdPartner: gu(t).query,
      getAdPartners: Nu(t).query,
      modifyAdPartner: Qu(t).query
    },
    areaGroups: {
      areas: {
        addArea: vu(t).query,
        deleteArea: Au(t).query,
        getArea: Du(t).query,
        getAreas: Lu(t).query,
        modifyArea: Yu(t).query
      },
      addAreaGroup: bu(t).query,
      deleteAreaGroup: Ru(t).query,
      getAreaGroup: ju(t).query,
      getAreaGroups: Uu(t).query,
      modifyAreaGroup: ed(t).query
    },
    areas: {
      addAreaDuplicate: _u(t).query,
      areaPhotos: {
        modifyAreaPhotos: td(t).query
      }
    },
    automaticOffer: {
      modifyAutomaticOffer: rd(t).query
    },
    calendarImport: {
      addCalendarImport: qu(t).query,
      deleteCalendarImport: Eu(t).query,
      getCalendarImport: Bu(t).query,
      modifyCalendarImport: sd(t).query
    },
    houseTruthLinks: {
      addHouseTruthLink: Iu(t).query,
      deleteHouseTruthLink: Ou(t).query,
      getHouseTruthLinks: Vu(t).query,
      modifyHouseTruthLink: id(t).query
    },
    links: {
      addLink: xu(t).query,
      deleteLink: Pu(t).query,
      modifyLink: od(t).query
    },
    periodDurations: {
      addPeriodDuration: Tu(t).query,
      getPeriodDurations: Zu(t).query,
      modifyPeriodDuration: cd(t).query,
      removePeriodDuration: yd(t).query
    },
    periodPrices: {
      addPeriodPrice: Su(t).query,
      getPeriodPrices: Wu(t).query,
      modifyPeriodPrice: ud(t).query,
      removePeriodPrice: md(t).query
    },
    places: {
      distances: {
        addDistance: ku(t).query,
        getDistances: Fu(t).query
      }
    },
    signatory: {
      credits: {
        getCredits: Hu(t).query
      }
    },
    reviews: {
      getReviews: Gu(t).query,
      modifyReview: dd(t).query
    },
    saleInformation: {
      getSaleInformation: Ju(t).query,
      modifySaleInformation: ld(t).query
    },
    surroundingInformation: {
      getSurroundingInformation: Xu(t).query,
      modifySurroundingInformation: hd(t).query
    },
    stayInformation: {
      codes: {
        addCode: wu(t).query,
        deleteCode: Cu(t).query,
        modifyCode: nd(t).query
      },
      getStayInformation: Ku(t).query,
      modifyStayInformation: fd(t).query
    },
    addHouse: $u(t).query,
    getHouseById: Mu(t).query,
    getHouses: zu(t).query,
    modifyHouse: ad(t).query
  },
  houseCategories: {
    getHouseCategories: pu(t).query
  },
  houseStaffs: {
    addHouseStaff: pd(t).query,
    modifyHouseStaff: gd(t).query,
    removeHouseStaff: vd(t).query
  },
  houseStyles: {
    getHouseStyles: _d(t).query
  },
  hubspot: {
    getHubspotContractPdf: bd(t).query
  },
  includedServices: {
    getIncludedServices: qd(t).query
  },
  ownerTaxCertificates: {
    getTaxCertificateById: wd(t).query
  },
  payIns: {
    assign: {
      assignPayIn: $d(t).query
    },
    getPayIn: kd(t).query
  },
  paymentSchedules: {
    getPaymentSchedules: Id(t).query
  },
  paymentTransactions: {
    payOuts: {
      getPayOuts: xd(t).query
    }
  },
  photos: {
    modifyPhoto: Td(t).query,
    removePhoto: Sd(t).query
  },
  places: {
    destinationPlaces: {
      addDestinationPlace: Ad(t).query,
      removeDestinationPlace: Pd(t).query
    },
    housePlaces: {
      addHousePlace: Rd(t).query,
      removeHousePlace: Nd(t).query
    },
    addPlace: Ed(t).query,
    getPlaceById: Cd(t).query,
    modifyPlace: Od(t).query,
    removePlace: Dd(t).query
  },
  placeTypes: {
    getPlaceTypes: jd(t).query
  },
  pools: {
    addPool: Ud(t).query,
    getPoolById: Ld(t).query,
    getPools: Bd(t).query,
    modifyPool: Hd(t).query
  },
  subsidiaries: {
    getSubsidiaries: Fd(t).query
  },
  tailor: {
    getAppointments: Md(t).query,
    getAppointment: zd(t).query
  },
  themes: {
    getThemes: Vd(t).query
  },
  user: {
    invitation: {
      addInvitation: Zd(t).query,
      modifyInvitation: Wd(t).query
    }
  },
  vouchers: {
    assign: {
      assignVoucher: Jd(t).query
    },
    addVoucher: Gd(t).query,
    getVoucher: Kd(t).query,
    modifyVoucher: Xd(t).query,
    removeVoucher: Qd(t).query
  }
}), el = (t) => ({
  query: (e) => t.post("v3/contacts", e.payload)
}), tl = (t) => ({
  createContactRequest: el(t).query
}), rl = (t) => ({
  query: (e) => t.post("v3/requests", e.request)
}), sl = (t) => ({
  query: (e) => t.put(`v3/requests/${e.request_uuid}`, e.request)
}), nl = (t) => ({
  request: {
    makeHouseRequest: rl(t).query,
    updateInquiry: sl(t).query
  }
}), al = (t) => ({
  query: (e) => t.post("v3/request_wishlists", {
    request_wishlist: { ...e }
  })
}), il = (t) => ({
  query: (e) => t.put("v3/request_wishlists", {
    request_wishlist: { ...e }
  })
}), ol = (t) => ({
  makeRequestWishlist: al(t).query,
  modifyRequestWishlist: il(t).query
}), cl = (t) => ({
  query: () => t.get("v3/searchable_tags/identifiers")
}), ul = (t) => ({
  getIdentifiers: cl(t).query
}), dl = (t) => ({
  query: (e) => t.get(
    `v3/multi_inquiry_wishlists?private_token=${e.wishlistToken}`
  )
}), ll = (t) => ({
  getWishlistShared: dl(t).query
}), fl = (t) => ({
  query: (e) => t.get(
    `v3/tailor/contracts/${e.contractId}/client_itinerary`
  )
}), hl = (t) => ({
  query: (e) => t.get(`v3/tailor/contracts/${e}/links_and_documents`)
}), yl = (t) => ({
  query: (e) => t.get(`v3/tailor/contracts/${e.contractId}/appointments`)
}), ml = (t) => ({
  contracts: {
    getClientItinerary: fl(t).query,
    getAllDocuments: hl(t).query,
    getAppointments: yl(t).query
  }
}), pl = (t) => ({
  query: () => t.get("v3/marketplace/user/permission")
}), gl = (t) => ({
  getMarketplacePermission: pl(t).query
}), vl = (t) => ({
  query: () => t.get("v1/privacy_policy")
}), _l = (t) => ({
  getPrivacyPolicy: vl(t).query
}), bl = (t) => ({
  query: (e) => t.post("v3/newsletter_emails", e)
}), ql = (t) => ({
  subscribeNewsletter: bl(t).query
}), wl = (t) => ({
  query: (e) => t.post(`v1/user/houses/${e.houseId}/owner_bookings`, {
    owner_booking: e.period
  })
}), kl = (t) => ({
  query: (e) => t.get(`v1/user/houses/${e.houseId}/calendar_exports`)
}), $l = (t) => ({
  query: (e) => t.get(
    `v2/user/houses/${e.houseId}/contracts/${e.contractId}`
  )
}), Il = (t) => ({
  query: (e) => t.get(`v1/user/houses/${e.houseId}/periods`)
}), xl = (t) => ({
  houses: {
    calendar: {
      getCalendarExports: kl(t).query
    },
    contracts: {
      getContractById: $l(t).query
    },
    bookings: {
      owner: {
        modifyOwnerBooking: wl(t).query
      }
    },
    periods: {
      getPeriods: Il(t).query
    }
  }
}), Tl = (t) => ({
  query: (e) => t.get(
    `v1/auth/password/edit?reset_password_token=${e.reset_password_token}`
  )
}), Sl = (t) => ({
  query: (e) => t.post("v1/auth/password", e)
}), Al = (t) => ({
  query: (e) => t.put("v1/auth/password", e)
}), Rl = (t) => ({
  query: (e) => t.put("v1/auth/password", e)
}), El = (t) => ({
  password: {
    getResetPasswordTokenConfirmation: Tl(t).query,
    sendForgottenPasswordEmail: Sl(t).query,
    updateUserConnectedPassword: Al(t).query,
    updateUserDisconnectedPassword: Rl(t).query
  }
}), Cl = (t) => ({
  query: () => t.get("v1/auth/validate_token")
}), Ol = (t) => ({
  query: (e) => t.post("v1/auth/sign_in", e)
}), Pl = (t) => ({
  query: () => t.delete("v1/auth/sign_out")
}), Nl = (t) => ({
  query: (e) => t.get(
    `v1/auth/invitation?email=${encodeURIComponent(e.email)}`
  )
}), Dl = (t) => ({
  session: {
    getValidateToken: Cl(t).query,
    signIn: Ol(t).query,
    signOut: Pl(t).query,
    verifyUserEmail: Nl(t).query
  }
}), jl = (t) => Object.assign(El(t), Dl(t)), Ul = (t) => ({
  query: (e) => t.get(`v1/owner_contracts/${e.contractId}`)
}), Ll = (t) => ({
  query: () => t.get("v1/owner_general_rental_condition")
}), Bl = (t) => ({
  query: (e) => {
    const r = e.ownerIsCompany ? "company" : "individual";
    return t.put(
      `v1/owner_contracts/${e.contractId}?context=${r}`,
      { contract: e.authSystem }
    );
  }
}), Hl = (t) => ({
  owner: {
    getContractById: Ul(t).query,
    getOwnerGeneralRentalCondition: Ll(t).query,
    sendSmsOrEmailAuthSystem: Bl(t).query
  }
}), Fl = (t) => ({
  query: (e) => t.post("v1/callback_requests", e)
}), Ml = (t) => ({
  query: (e) => t.post("v1/requests", e)
}), zl = (t) => ({
  query: (e) => t.post("v1/requests", e)
}), Vl = (t) => ({
  query: (e, r) => t.put(`v1/requests/${e}`, r)
}), Zl = (t) => ({
  prebooking: {
    createPrebooking: zl(t).query,
    updatePrebooking: Vl(t).query
  },
  lpRequest: {
    createLpRequest: Ml(t).query
  },
  callBackRequest: {
    createCallbackRequest: Fl(t).query
  }
}), Wl = (t) => ({
  query: (e) => t.post("v2/waiting_searches", e.payload)
}), Gl = (t) => ({
  addWaitingSearch: Wl(t).query
}), Jl = (t) => ({
  query: (e) => t.get(
    `lp-destinations/find-by-slug/${e.slug}?locale=${e.locale}`
  )
}), Kl = (t) => ({
  query: (e) => t.get(
    `collection-groups?sort=id&filters[lp_inspiration]&filters[lp_destination]=${e.destinationId}`
  )
}), Xl = (t) => ({
  query: (e) => t.get(
    `popular-destinations?sort=position&filters[lp_inspiration]&filters[lp_destination]=${e.destinationId}`
  )
}), Ql = (t) => ({
  getLandingPageDestination: Jl(t).query,
  getLandingPageDestinationHouses: Kl(t).query,
  getLandingPagePopularDestinations: Xl(t).query
});
class Yl {
  constructor(e) {
    this.httpSource = e, this.headersCustom = null;
  }
  setHeaders({ accessToken: e, client: r, uid: s }) {
    this.headersCustom = { accessToken: e, client: r, uid: s };
  }
  getHeaders() {
    return this.headersCustom ? {
      "access-token": this.headersCustom.accessToken,
      client: this.headersCustom.client,
      uid: this.headersCustom.uid,
      ...this.httpSource ? { Httpsource: this.httpSource } : {}
    } : null;
  }
  clearHeaders() {
    this.headersCustom = null;
  }
}
class ef {
  constructor() {
    this.localeCustom = null;
  }
  setLocale(e) {
    this.localeCustom = e;
  }
  getLocale() {
    return this.localeCustom;
  }
}
const tf = ({
  apiUrl: t,
  interceptors: e,
  locale: r,
  source: s,
  storageClient: n
}) => {
  const a = (d, u) => {
    const c = /* @__PURE__ */ new Date();
    `${c.getDate()}`, c.getMonth() + 1, `${c.getFullYear()}${c.getHours()}${c.getMinutes()}${c.getSeconds()}`;
  }, i = (d) => {
    const u = (d == null ? void 0 : d.get("access-token")) || "", c = (d == null ? void 0 : d.get("client")) || "", f = (d == null ? void 0 : d.get("uid")) || "";
    return {
      accessToken: u,
      client: c,
      uid: f
    };
  }, o = (d) => {
    const { accessToken: u, client: c, uid: f } = i(d.headers);
    u && c && f && (n == null || n.setItem("accessToken", u), n == null || n.setItem("client", c), n == null || n.setItem("uid", f));
  };
  return {
    triggerOnResponse: (d, u) => (o(d), process.env.SSR_LOG === "true" && a(), Array.isArray(e == null ? void 0 : e.response) && (e == null || e.response.forEach((c) => c(d))), d.status === 200 ? { ...d } : Promise.reject({
      response: { data: d._data, status: d.status }
    })),
    getHeaders: async () => {
      const d = await (n == null ? void 0 : n.getItem("accessToken")), u = await (n == null ? void 0 : n.getItem("client")), c = await (n == null ? void 0 : n.getItem("uid"));
      let f = { Httpsource: s };
      return d && u && c && (f = {
        "access-token": d,
        client: u,
        uid: c,
        Httpsource: f.Httpsource
      }), f;
    }
  };
}, rf = ({
  api: t,
  locale: e,
  storageClient: r,
  headersCustom: s,
  localeCustom: n
}) => {
  const a = (o) => `${t.url}/${o}/api/`, i = tf({
    apiUrl: t.url,
    getDeviceUniqueId: t.getDeviceUniqueId,
    interceptors: t.interceptors,
    locale: e,
    source: t.source,
    storageClient: r
  });
  return {
    get: async (o, d) => {
      try {
        const u = n == null ? void 0 : n.getLocale(), c = a(u || e), f = s != null && s.getHeaders() ? s.getHeaders() : await i.getHeaders(), h = await J(`${c}${o}`, {
          method: "GET",
          onResponse: ({ response: p }) => i.triggerOnResponse(
            p,
            o
          ),
          ...d ?? {},
          headers: { ...f, ...(d == null ? void 0 : d.headers) ?? {} }
        });
        return d != null && d.responseType ? Promise.resolve(h) : Promise.resolve(
          te(h)
        );
      } catch (u) {
        return Promise.resolve({
          errors: u
        });
      }
    },
    post: async (o, d, u) => {
      try {
        const c = n == null ? void 0 : n.getLocale(), f = a(c || e), h = s != null && s.getHeaders() ? s.getHeaders() : await i.getHeaders(), p = await J(`${f}${o}`, {
          method: "POST",
          body: d,
          onResponse: ({ response: y }) => i.triggerOnResponse(
            y,
            o
          ),
          ...u ?? {},
          headers: { ...h, ...(u == null ? void 0 : u.headers) ?? {} }
        });
        return Promise.resolve(te(p));
      } catch (c) {
        return Promise.resolve({
          errors: c
        });
      }
    },
    put: async (o, d, u) => {
      try {
        const c = n == null ? void 0 : n.getLocale(), f = a(c || e), h = s != null && s.getHeaders() ? s.getHeaders() : await i.getHeaders(), p = await J(`${f}${o}`, {
          method: "PUT",
          body: d,
          onResponse: ({ response: y }) => i.triggerOnResponse(
            y,
            o
          ),
          ...u ?? {},
          headers: { ...h, ...(u == null ? void 0 : u.headers) ?? {} }
        });
        return Promise.resolve(te(p));
      } catch (c) {
        return Promise.resolve({
          errors: c
        });
      }
    },
    delete: async (o) => {
      try {
        const d = n == null ? void 0 : n.getLocale(), u = a(d || e), c = s != null && s.getHeaders() ? s.getHeaders() : await i.getHeaders(), f = await J(`${u}${o}`, {
          method: "DELETE",
          headers: c,
          onResponse: ({ response: h }) => i.triggerOnResponse(
            h,
            o
          )
        });
        return Promise.resolve(te(f));
      } catch (d) {
        return Promise.resolve({
          errors: d
        });
      }
    },
    raw: async (o, d) => {
      const u = (n == null ? void 0 : n.getLocale()) ?? e, c = a(u), f = s != null && s.getHeaders() ? s.getHeaders() : await i.getHeaders(), h = await J.raw(`${c}${o}`, {
        method: "GET",
        onResponse: ({ response: p }) => i.triggerOnResponse(
          p,
          o
        ),
        ...d,
        headers: { ...f, ...d.headers ?? {} }
      });
      return { headers: h.headers, _data: h._data };
    }
  };
}, df = {
  lc: ({
    api: t,
    locale: e,
    storageClient: r,
    httpClientType: s = "axios"
  }) => {
    const n = new Yl(t.source), a = new ef(), i = (s === "axios" ? se : rf)({
      // @ts-expect-error ResT can be instanciated with an unrelated type
      api: t,
      locale: e,
      localeCustom: a,
      storageClient: r,
      headersCustom: n
    }), o = vt(xl(i), Ao(i)), d = vt(Zl(i), nl(i));
    return {
      admin: Yd(i),
      auth: jl(i),
      contacts: tl(i),
      contracts: Hl(i),
      user: o,
      houses: Wo(i),
      legal: _l(i),
      request: d,
      requestWishlists: ol(i),
      searchableTag: ul(i),
      multiInquiryWishlists: ll(i),
      tailor: ml(i),
      automaticProposals: Eo(i),
      marketplace: gl(i),
      newsletterEmails: ql(i),
      waitingSearches: Gl(i),
      headers: n,
      localeCustom: a
    };
  },
  strapiAdmin: ({ api: t }) => {
    const e = se({ api: t, unserialized: !0 });
    return {
      lpDestination: Ql(e)
    };
  }
};
export {
  nf as ABTestService,
  af as DocVerifier,
  of as GeoCoding,
  cf as Hubspot,
  Ui as ShareGroop,
  uf as UserLocation,
  df as buildRepositories
};
